export default{
	"name": "changsanjiaoMap",
	"type": "FeatureCollection",
	"features": [{
		"type": "Feature",
		"properties": {
			"adcode": 320000,
			"name": "江苏省",
			"center": [118.767413, 32.041544],
			"centroid": [119.486395, 32.983908],
			"cp": [119.767413, 33.041544],
			"childrenNum": 13,
			"level": "province",
			"acroutes": [100000],
			"parent": {
				"adcode": 100000
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[118.408205, 34.435512],
						[118.416231, 34.473885],
						[118.421395, 34.48324],
						[118.43088, 34.489076],
						[118.439523, 34.507995],
						[118.440421, 34.52751],
						[118.428017, 34.561169],
						[118.423864, 34.592929],
						[118.439186, 34.626305],
						[118.45434, 34.617737],
						[118.463657, 34.625277],
						[118.473816, 34.623435],
						[118.474882, 34.637184],
						[118.466463, 34.643137],
						[118.460851, 34.657569],
						[118.468484, 34.674309],
						[118.484255, 34.670884],
						[118.500812, 34.675165],
						[118.508164, 34.687066],
						[118.522701, 34.692288],
						[118.525226, 34.712573],
						[118.539314, 34.711503],
						[118.546105, 34.706197],
						[118.558901, 34.706839],
						[118.570463, 34.71253],
						[118.601332, 34.714156],
						[118.604924, 34.696482],
						[118.633716, 34.687023],
						[118.650554, 34.69507],
						[118.664304, 34.693443],
						[118.681366, 34.678333],
						[118.69029, 34.67859],
						[118.704041, 34.688778],
						[118.720093, 34.694214],
						[118.744732, 34.695284],
						[118.766228, 34.705213],
						[118.76735, 34.710519],
						[118.783402, 34.722029],
						[118.768529, 34.738072],
						[118.759212, 34.740853],
						[118.74013, 34.736917],
						[118.730364, 34.74543],
						[118.716501, 34.747739],
						[118.716445, 34.76382],
						[118.727221, 34.768738],
						[118.738502, 34.766857],
						[118.740186, 34.781224],
						[118.728399, 34.786867],
						[118.737548, 34.792083],
						[118.759998, 34.790287],
						[118.77358, 34.795332],
						[118.779024, 34.809608],
						[118.776611, 34.818754],
						[118.781999, 34.827472],
						[118.768248, 34.838795],
						[118.769034, 34.846143],
						[118.788734, 34.845673],
						[118.797265, 34.842853],
						[118.804617, 34.852466],
						[118.804449, 34.870277],
						[118.807199, 34.877708],
						[118.829761, 34.91114],
						[118.860799, 34.944003],
						[118.859227, 34.962647],
						[118.86512, 34.99323],
						[118.862482, 35.025719],
						[118.865345, 35.029854],
						[118.885774, 35.034244],
						[118.903847, 35.041319],
						[118.911143, 35.047754],
						[118.926521, 35.05078],
						[118.945155, 35.040808],
						[118.965641, 35.046476],
						[118.992132, 35.048181],
						[118.999877, 35.053039],
						[119.02721, 35.05534],
						[119.037368, 35.051334],
						[119.06139, 35.05159],
						[119.073625, 35.056661],
						[119.114597, 35.054956],
						[119.120378, 35.058024],
						[119.12049, 35.070083],
						[119.12947, 35.076175],
						[119.138057, 35.09628],
						[119.159048, 35.100965],
						[119.171395, 35.107183],
						[119.203218, 35.110888],
						[119.220729, 35.107183],
						[119.24071, 35.122938],
						[119.252665, 35.122683],
						[119.273768, 35.115487],
						[119.286677, 35.115146],
						[119.30183, 35.093171],
						[119.305871, 35.076686],
						[119.293524, 35.07298],
						[119.292682, 35.068506],
						[119.307162, 35.03305],
						[119.29184, 35.02849],
						[119.281064, 35.053678],
						[119.285442, 35.068506],
						[119.279436, 35.071105],
						[119.238072, 35.048479],
						[119.232572, 35.041831],
						[119.227521, 35.020944],
						[119.21899, 35.004828],
						[119.211357, 34.981715],
						[119.211806, 34.957912],
						[119.214612, 34.937687],
						[119.212704, 34.917799],
						[119.202433, 34.890433],
						[119.21377, 34.876726],
						[119.210515, 34.862333],
						[119.218035, 34.852594],
						[119.220393, 34.841187],
						[119.213602, 34.833924],
						[119.238577, 34.799563],
						[119.250756, 34.794049],
						[119.272196, 34.797811],
						[119.312831, 34.774724],
						[119.324393, 34.770406],
						[119.342689, 34.769251],
						[119.355037, 34.775751],
						[119.370864, 34.772971],
						[119.378497, 34.764547],
						[119.440684, 34.769208],
						[119.438271, 34.784302],
						[119.456175, 34.779813],
						[119.459486, 34.77109],
						[119.477165, 34.769037],
						[119.480421, 34.76412],
						[119.49709, 34.759458],
						[119.48839, 34.747868],
						[119.468241, 34.748167],
						[119.460777, 34.754069],
						[119.444332, 34.758432],
						[119.399993, 34.755823],
						[119.378273, 34.761383],
						[119.381809, 34.752444],
						[119.457129, 34.748167],
						[119.483508, 34.736404],
						[119.508427, 34.729217],
						[119.525714, 34.733281],
						[119.522795, 34.722329],
						[119.507978, 34.711032],
						[119.492488, 34.711546],
						[119.491814, 34.69554],
						[119.484855, 34.692716],
						[119.474584, 34.696054],
						[119.464986, 34.674694],
						[119.537051, 34.633758],
						[119.560736, 34.63153],
						[119.56893, 34.615381],
						[119.584926, 34.601328],
						[119.611248, 34.592929],
						[119.62528, 34.585901],
						[119.641388, 34.568971],
						[119.697906, 34.546593],
						[119.741066, 34.532871],
						[119.781813, 34.515759],
						[119.811615, 34.485557],
						[119.823009, 34.481996],
						[119.8495, 34.477404],
						[119.919039, 34.469122],
						[119.962536, 34.458907],
						[120.043019, 34.422201],
						[120.103691, 34.391622],
						[120.233284, 34.337179],
						[120.292833, 34.318092],
						[120.311635, 34.307042],
						[120.308492, 34.297452],
						[120.314272, 34.255814],
						[120.331671, 34.209333],
						[120.347499, 34.179236],
						[120.355973, 34.149559],
						[120.359846, 34.121897],
						[120.367591, 34.091424],
						[120.424671, 33.975121],
						[120.485454, 33.859221],
						[120.500384, 33.817928],
						[120.534508, 33.782587],
						[120.570596, 33.702247],
						[120.583786, 33.668462],
						[120.611175, 33.627251],
						[120.622849, 33.615113],
						[120.651136, 33.575699],
						[120.680153, 33.520297],
						[120.717476, 33.436715],
						[120.719833, 33.420467],
						[120.728252, 33.384571],
						[120.730777, 33.365183],
						[120.740992, 33.337615],
						[120.760748, 33.319869],
						[120.769335, 33.306818],
						[120.782862, 33.304208],
						[120.796388, 33.306122],
						[120.81373, 33.303425],
						[120.821812, 33.298552],
						[120.832589, 33.282148],
						[120.831971, 33.26883],
						[120.820297, 33.256077],
						[120.819455, 33.238184],
						[120.843028, 33.22965],
						[120.846844, 33.219852],
						[120.843757, 33.209835],
						[120.859865, 33.142781],
						[120.874065, 33.093645],
						[120.87182, 33.04723],
						[120.894438, 33.038634],
						[120.917843, 33.02576],
						[120.932604, 33.005899],
						[120.940124, 32.975467],
						[120.950395, 32.916405],
						[120.957579, 32.893504],
						[120.972677, 32.88568],
						[120.978682, 32.875712],
						[120.981376, 32.85971],
						[120.971947, 32.761182],
						[120.963136, 32.750238],
						[120.952865, 32.714068],
						[120.93294, 32.715688],
						[120.915036, 32.711703],
						[120.915934, 32.701234],
						[120.933838, 32.69221],
						[120.950059, 32.689581],
						[120.963585, 32.682396],
						[120.976044, 32.658426],
						[120.979637, 32.636335],
						[120.961733, 32.612178],
						[120.988448, 32.606741],
						[121.020496, 32.605513],
						[121.051701, 32.587137],
						[121.076901, 32.576391],
						[121.153119, 32.529266],
						[121.269523, 32.483434],
						[121.287652, 32.480185],
						[121.351915, 32.474256],
						[121.390529, 32.460729],
						[121.417413, 32.443115],
						[121.425495, 32.431033],
						[121.440536, 32.366071],
						[121.447047, 32.299258],
						[121.45019, 32.282272],
						[121.457767, 32.27391],
						[121.493912, 32.263478],
						[121.49958, 32.211169],
						[121.479263, 32.197999],
						[121.461527, 32.193726],
						[121.458609, 32.17769],
						[121.473089, 32.169803],
						[121.50306, 32.170067],
						[121.542291, 32.152131],
						[121.52551, 32.136528],
						[121.544368, 32.123039],
						[121.59258, 32.112943],
						[121.729637, 32.069194],
						[121.759047, 32.0594],
						[121.772405, 32.033235],
						[121.856031, 31.955225],
						[121.870287, 31.928279],
						[121.874833, 31.90212],
						[121.889145, 31.866627],
						[121.897452, 31.85354],
						[121.941005, 31.776572],
						[121.960143, 31.736868],
						[121.970302, 31.718892],
						[121.96772, 31.703924],
						[121.975185, 31.617035],
						[121.81781, 31.652049],
						[121.715269, 31.673848],
						[121.642643, 31.697458],
						[121.63327, 31.696173],
						[121.600886, 31.70698],
						[121.599651, 31.703127],
						[121.565022, 31.716722],
						[121.539429, 31.735496],
						[121.51305, 31.743686],
						[121.49857, 31.753247],
						[121.487738, 31.753424],
						[121.455578, 31.759356],
						[121.4315, 31.76927],
						[121.420893, 31.779581],
						[121.410902, 31.795598],
						[121.41629, 31.797634],
						[121.385029, 31.833552],
						[121.369314, 31.843281],
						[121.323066, 31.868528],
						[121.301907, 31.872727],
						[121.265594, 31.864107],
						[121.225296, 31.84704],
						[121.200321, 31.835144],
						[121.181519, 31.820416],
						[121.149247, 31.78728],
						[121.11849, 31.75909],
						[121.145318, 31.753911],
						[121.289111, 31.616282],
						[121.345573, 31.571676],
						[121.372232, 31.553224],
						[121.343496, 31.512049],
						[121.319923, 31.499711],
						[121.310326, 31.505925],
						[121.299943, 31.499756],
						[121.298596, 31.4915],
						[121.26885, 31.48746],
						[121.261441, 31.478848],
						[121.247073, 31.477072],
						[121.240899, 31.493675],
						[121.234725, 31.492698],
						[121.230348, 31.477427],
						[121.219067, 31.475207],
						[121.214352, 31.479114],
						[121.186065, 31.460822],
						[121.186065, 31.454339],
						[121.174952, 31.449276],
						[121.160921, 31.449676],
						[121.147339, 31.443947],
						[121.14689, 31.437241],
						[121.162717, 31.432222],
						[121.164288, 31.427203],
						[121.146272, 31.421072],
						[121.158844, 31.4101],
						[121.143803, 31.392327],
						[121.148461, 31.385395],
						[121.113776, 31.374462],
						[121.12023, 31.368684],
						[121.109286, 31.364684],
						[121.108332, 31.350637],
						[121.117255, 31.351704],
						[121.117985, 31.343435],
						[121.130445, 31.344191],
						[121.133307, 31.325561],
						[121.127246, 31.319291],
						[121.12994, 31.302613],
						[121.139649, 31.302969],
						[121.143803, 31.309685],
						[121.151267, 31.291937],
						[121.161314, 31.283975],
						[121.154242, 31.276723],
						[121.142905, 31.277657],
						[121.120342, 31.286154],
						[121.11501, 31.285265],
						[121.105469, 31.273653],
						[121.09879, 31.276233],
						[121.090147, 31.291893],
						[121.084703, 31.287622],
						[121.080437, 31.270138],
						[121.063263, 31.267913],
						[121.060962, 31.246509],
						[121.064329, 31.246153],
						[121.062646, 31.224655],
						[121.075442, 31.173449],
						[121.077014, 31.158438],
						[121.065733, 31.148593],
						[121.062533, 31.153137],
						[121.041486, 31.14984],
						[121.041823, 31.13888],
						[121.025659, 31.140751],
						[121.018475, 31.134113],
						[120.983902, 31.131706],
						[120.930359, 31.14142],
						[120.905383, 31.134202],
						[120.881305, 31.134736],
						[120.872325, 31.127161],
						[120.870585, 31.119719],
						[120.857901, 31.108533],
						[120.856778, 31.102828],
						[120.869575, 31.097212],
						[120.892193, 31.094181],
						[120.902128, 31.085666],
						[120.894551, 31.053875],
						[120.901959, 31.037641],
						[120.901342, 31.017479],
						[120.895168, 31.017345],
						[120.891352, 31.003737],
						[120.86806, 30.995348],
						[120.865646, 30.989815],
						[120.853692, 30.993206],
						[120.847349, 30.989592],
						[120.840053, 30.997803],
						[120.820914, 31.006369],
						[120.802898, 31.005388],
						[120.769953, 30.996642],
						[120.770177, 30.978078],
						[120.760692, 30.975445],
						[120.745931, 30.9625],
						[120.736109, 30.963706],
						[120.725614, 30.971517],
						[120.710067, 30.971919],
						[120.705521, 30.966473],
						[120.698225, 30.970803],
						[120.684474, 30.95518],
						[120.697551, 30.950358],
						[120.70945, 30.933169],
						[120.712705, 30.919683],
						[120.709843, 30.907535],
						[120.713266, 30.885067],
						[120.702546, 30.884039],
						[120.704286, 30.872959],
						[120.699909, 30.867821],
						[120.68279, 30.882565],
						[120.673642, 30.87573],
						[120.66309, 30.861342],
						[120.658713, 30.865274],
						[120.655401, 30.847489],
						[120.644176, 30.855354],
						[120.626216, 30.856069],
						[120.615496, 30.849589],
						[120.60298, 30.848919],
						[120.588949, 30.854416],
						[120.580867, 30.845656],
						[120.563805, 30.835511],
						[120.518231, 30.773227],
						[120.504425, 30.757974],
						[120.489439, 30.763432],
						[120.476979, 30.785571],
						[120.477204, 30.800014],
						[120.455259, 30.816825],
						[120.460984, 30.828269],
						[120.460422, 30.839846],
						[120.454473, 30.849634],
						[120.441284, 30.856292],
						[120.45234, 30.867911],
						[120.439544, 30.885201],
						[120.436345, 30.896949],
						[120.442294, 30.900612],
						[120.434998, 30.920799],
						[120.423436, 30.927453],
						[120.417992, 30.925578],
						[120.423492, 30.903069],
						[120.3947, 30.890785],
						[120.379434, 30.890785],
						[120.372418, 30.882163],
						[120.364673, 30.880465],
						[120.357994, 30.887077],
						[120.360127, 30.892795],
						[120.356928, 30.908875],
						[120.362709, 30.921648],
						[120.359453, 30.931919],
						[120.371127, 30.948751],
						[120.343514, 30.94],
						[120.308099, 30.932276],
						[120.250739, 30.926248],
						[120.221778, 30.926873],
						[120.149657, 30.937455],
						[120.135121, 30.941875],
						[120.111043, 30.955894],
						[120.103971, 30.965223],
						[120.052449, 31.005745],
						[120.017034, 31.017791],
						[120.001711, 31.027114],
						[119.988522, 31.059226],
						[119.969776, 31.074298],
						[119.94626, 31.106215],
						[119.936775, 31.146543],
						[119.921059, 31.1612],
						[119.919993, 31.17091],
						[119.900237, 31.169173],
						[119.878348, 31.160799],
						[119.866618, 31.168327],
						[119.842147, 31.168772],
						[119.837545, 31.173671],
						[119.826489, 31.173181],
						[119.823458, 31.165832],
						[119.829744, 31.161378],
						[119.823289, 31.154117],
						[119.809875, 31.148504],
						[119.801008, 31.156344],
						[119.791298, 31.156611],
						[119.793375, 31.168059],
						[119.779343, 31.178793],
						[119.755378, 31.170776],
						[119.740505, 31.173404],
						[119.713116, 31.167614],
						[119.703855, 31.151889],
						[119.682752, 31.160487],
						[119.678037, 31.168193],
						[119.663726, 31.165966],
						[119.662491, 31.159863],
						[119.641837, 31.148414],
						[119.638132, 31.135538],
						[119.63078, 31.131261],
						[119.613718, 31.129167],
						[119.599799, 31.109157],
						[119.582007, 31.108667],
						[119.574094, 31.11397],
						[119.571343, 31.128988],
						[119.560231, 31.140707],
						[119.545863, 31.147835],
						[119.532617, 31.159106],
						[119.514376, 31.156077],
						[119.494508, 31.164006],
						[119.485584, 31.161601],
						[119.482497, 31.152513],
						[119.475818, 31.158928],
						[119.460608, 31.156389],
						[119.454771, 31.164897],
						[119.438832, 31.177056],
						[119.423454, 31.181866],
						[119.415428, 31.172959],
						[119.400611, 31.178749],
						[119.391182, 31.174518],
						[119.389329, 31.188324],
						[119.395335, 31.193356],
						[119.405662, 31.192777],
						[119.394886, 31.19959],
						[119.379171, 31.189214],
						[119.371369, 31.197719],
						[119.365757, 31.195938],
						[119.360088, 31.212145],
						[119.365196, 31.232667],
						[119.370528, 31.242548],
						[119.379676, 31.269382],
						[119.371594, 31.271606],
						[119.367946, 31.288957],
						[119.356609, 31.30328],
						[119.350154, 31.301012],
						[119.35021, 31.280905],
						[119.345945, 31.268981],
						[119.337526, 31.258881],
						[119.33326, 31.264131],
						[119.314851, 31.265733],
						[119.294815, 31.263241],
						[119.266977, 31.250425],
						[119.26142, 31.261328],
						[119.249746, 31.261995],
						[119.249971, 31.256967],
						[119.238577, 31.254653],
						[119.236276, 31.259326],
						[119.218148, 31.264799],
						[119.215285, 31.274098],
						[119.204229, 31.265689],
						[119.197157, 31.27352],
						[119.199458, 31.293583],
						[119.181105, 31.300478],
						[119.176222, 31.293939],
						[119.15815, 31.294784],
						[119.149787, 31.276945],
						[119.140695, 31.276011],
						[119.13222, 31.262752],
						[119.120041, 31.261684],
						[119.10702, 31.250603],
						[119.10528, 31.235293],
						[119.083728, 31.239744],
						[119.073794, 31.23289],
						[119.062344, 31.238498],
						[119.048818, 31.233557],
						[119.014526, 31.241524],
						[119.0033, 31.233735],
						[118.986463, 31.231154],
						[118.984218, 31.237474],
						[118.92495, 31.2397],
						[118.915184, 31.244195],
						[118.891219, 31.237964],
						[118.869666, 31.242237],
						[118.840481, 31.236361],
						[118.831277, 31.229462],
						[118.819491, 31.236005],
						[118.806357, 31.229507],
						[118.79575, 31.229373],
						[118.781382, 31.239833],
						[118.778575, 31.261684],
						[118.761401, 31.277702],
						[118.726603, 31.28224],
						[118.707914, 31.296786],
						[118.704434, 31.302791],
						[118.719588, 31.294784],
						[118.721103, 31.32267],
						[118.735078, 31.344769],
						[118.745742, 31.372684],
						[118.75461, 31.385084],
						[118.765386, 31.387928],
						[118.770886, 31.376951],
						[118.767575, 31.363973],
						[118.784525, 31.368595],
						[118.80024, 31.368995],
						[118.829481, 31.377529],
						[118.847385, 31.393927],
						[118.851145, 31.392549],
						[118.86961, 31.421561],
						[118.866074, 31.44488],
						[118.870508, 31.463042],
						[118.883193, 31.496471],
						[118.886279, 31.527669],
						[118.873539, 31.532062],
						[118.875111, 31.551982],
						[118.881958, 31.565156],
						[118.873315, 31.578417],
						[118.877299, 31.589902],
						[118.862258, 31.595001],
						[118.870789, 31.599346],
						[118.868768, 31.611139],
						[118.858554, 31.62395],
						[118.832848, 31.630377],
						[118.819547, 31.628516],
						[118.814495, 31.619252],
						[118.802765, 31.619473],
						[118.79603, 31.628294],
						[118.789576, 31.646554],
						[118.782953, 31.656258],
						[118.799005, 31.666361],
						[118.774141, 31.682619],
						[118.768304, 31.677481],
						[118.760503, 31.680271],
						[118.748099, 31.675753],
						[118.745125, 31.656524],
						[118.7394, 31.651074],
						[118.735976, 31.633436],
						[118.72868, 31.634233],
						[118.719419, 31.627452],
						[118.71695, 31.639463],
						[118.694949, 31.639729],
						[118.685127, 31.636139],
						[118.673846, 31.640527],
						[118.65785, 31.641103],
						[118.643594, 31.649656],
						[118.647972, 31.65936],
						[118.643257, 31.671367],
						[118.646962, 31.679873],
						[118.654931, 31.67562],
						[118.671432, 31.688201],
						[118.674407, 31.696483],
						[118.680749, 31.696616],
						[118.697699, 31.709416],
						[118.687372, 31.716147],
						[118.684902, 31.724914],
						[118.677269, 31.728589],
						[118.653977, 31.730139],
						[118.652125, 31.73979],
						[118.641686, 31.743996],
						[118.648365, 31.748821],
						[118.641686, 31.758249],
						[118.627037, 31.759444],
						[118.619068, 31.75006],
						[118.609358, 31.757187],
						[118.600995, 31.754133],
						[118.593082, 31.744438],
						[118.57529, 31.740941],
						[118.571698, 31.746253],
						[118.55312, 31.729032],
						[118.529772, 31.742358],
						[118.529379, 31.748555],
						[118.538696, 31.749352],
						[118.53965, 31.761569],
						[118.533869, 31.767234],
						[118.523599, 31.762011],
						[118.510746, 31.765641],
						[118.502608, 31.778342],
						[118.482178, 31.778342],
						[118.486107, 31.795421],
						[118.504741, 31.841733],
						[118.490597, 31.843148],
						[118.475443, 31.850312],
						[118.466744, 31.858005],
						[118.467081, 31.868881],
						[118.4723, 31.879623],
						[118.452263, 31.884663],
						[118.44014, 31.892707],
						[118.41595, 31.901457],
						[118.402986, 31.914007],
						[118.386036, 31.914803],
						[118.375316, 31.925319],
						[118.364371, 31.930178],
						[118.369198, 31.94299],
						[118.368974, 31.956196],
						[118.379974, 31.968341],
						[118.376719, 31.981721],
						[118.387158, 31.983267],
						[118.390975, 31.989536],
						[118.389628, 32.01205],
						[118.401526, 32.018671],
						[118.38598, 32.033147],
						[118.394342, 32.048414],
						[118.385025, 32.060768],
						[118.393276, 32.062665],
						[118.405455, 32.080794],
						[118.433518, 32.086661],
						[118.441095, 32.092041],
						[118.462871, 32.10064],
						[118.473647, 32.11065],
						[118.472974, 32.114839],
						[118.489474, 32.120746],
						[118.500812, 32.121584],
						[118.494694, 32.130974],
						[118.500587, 32.14173],
						[118.507435, 32.137895],
						[118.495648, 32.165176],
						[118.495592, 32.177073],
						[118.50648, 32.182096],
						[118.509848, 32.194299],
						[118.521859, 32.188219],
						[118.532354, 32.195797],
						[118.539594, 32.192449],
						[118.551717, 32.199629],
						[118.561708, 32.196898],
						[118.575627, 32.202536],
						[118.580902, 32.19866],
						[118.598357, 32.199497],
						[118.619629, 32.205443],
						[118.626588, 32.202536],
						[118.644099, 32.20998],
						[118.667504, 32.235918],
						[118.675137, 32.255862],
						[118.667447, 32.257535],
						[118.659253, 32.266119],
						[118.670759, 32.285617],
						[118.667335, 32.296354],
						[118.659983, 32.296354],
						[118.660263, 32.305418],
						[118.678448, 32.316549],
						[118.696352, 32.317736],
						[118.683948, 32.324071],
						[118.687652, 32.330009],
						[118.703199, 32.328954],
						[118.707914, 32.33841],
						[118.697531, 32.342632],
						[118.699832, 32.349757],
						[118.692928, 32.351692],
						[118.702021, 32.357936],
						[118.696071, 32.367961],
						[118.698878, 32.383085],
						[118.690178, 32.378293],
						[118.678672, 32.393943],
						[118.685744, 32.404975],
						[118.688887, 32.418202],
						[118.687091, 32.431297],
						[118.692648, 32.465122],
						[118.68928, 32.47351],
						[118.672892, 32.469865],
						[118.647691, 32.47654],
						[118.643426, 32.47048],
						[118.628104, 32.467669],
						[118.608572, 32.470567],
						[118.608067, 32.475837],
						[118.59673, 32.476628],
						[118.592127, 32.482029],
						[118.592464, 32.500207],
						[118.608011, 32.501744],
						[118.617496, 32.512411],
						[118.614465, 32.5204],
						[118.604812, 32.52299],
						[118.608853, 32.537034],
						[118.598975, 32.54467],
						[118.584663, 32.549014],
						[118.56805, 32.558755],
						[118.563728, 32.564371],
						[118.569509, 32.586435],
						[118.598077, 32.601347],
						[118.601781, 32.597356],
						[118.623838, 32.592444],
						[118.633043, 32.578979],
						[118.641237, 32.587093],
						[118.658411, 32.594812],
						[118.668794, 32.5949],
						[118.689561, 32.588541],
						[118.700842, 32.588541],
						[118.69798, 32.60639],
						[118.725312, 32.608232],
						[118.725986, 32.596523],
						[118.740691, 32.589374],
						[118.743273, 32.597751],
						[118.757528, 32.603978],
						[118.775769, 32.597751],
						[118.774815, 32.587663],
						[118.784749, 32.582444],
						[118.801811, 32.58433],
						[118.805291, 32.593453],
						[118.820501, 32.604241],
						[118.824542, 32.602531],
						[118.824654, 32.589637],
						[118.820501, 32.582532],
						[118.827573, 32.581172],
						[118.827011, 32.572662],
						[118.842502, 32.572969],
						[118.848507, 32.568187],
						[118.855972, 32.574373],
						[118.872641, 32.576084],
						[118.874998, 32.58297],
						[118.884203, 32.580426],
						[118.885101, 32.586348],
						[118.901995, 32.589023],
						[118.909347, 32.586874],
						[118.896382, 32.577268],
						[118.898627, 32.560466],
						[118.887907, 32.55485],
						[118.914005, 32.548839],
						[118.919786, 32.557263],
						[118.936568, 32.557526],
						[118.940609, 32.547785],
						[118.964799, 32.526721],
						[118.967942, 32.514562],
						[118.97984, 32.503851],
						[118.997463, 32.503895],
						[119.00751, 32.514079],
						[119.01924, 32.517986],
						[119.041409, 32.514782],
						[119.043318, 32.502841],
						[119.050502, 32.492919],
						[119.062793, 32.484576],
						[119.067452, 32.462398],
						[119.073681, 32.455371],
						[119.085131, 32.452735],
						[119.096019, 32.466088],
						[119.115495, 32.476979],
						[119.134521, 32.491558],
						[119.147767, 32.492655],
						[119.142266, 32.499417],
						[119.150124, 32.509821],
						[119.155568, 32.528081],
						[119.167803, 32.536332],
						[119.166681, 32.545986],
						[119.154502, 32.554938],
						[119.153828, 32.56187],
						[119.175212, 32.571083],
						[119.176952, 32.593848],
						[119.187167, 32.599944],
						[119.193733, 32.579154],
						[119.20928, 32.573583],
						[119.220168, 32.57661],
						[119.220056, 32.592444],
						[119.231, 32.607135],
						[119.220505, 32.609854],
						[119.216913, 32.617308],
						[119.220224, 32.629628],
						[119.208719, 32.641508],
						[119.211637, 32.708199],
						[119.208943, 32.71525],
						[119.208214, 32.740518],
						[119.200861, 32.750982],
						[119.19132, 32.788844],
						[119.188906, 32.810854],
						[119.184922, 32.82564],
						[119.113081, 32.822928],
						[119.10427, 32.826734],
						[119.071324, 32.864738],
						[119.055104, 32.874751],
						[119.045731, 32.892455],
						[119.045002, 32.911424],
						[119.021541, 32.905961],
						[119.015592, 32.907534],
						[119.019801, 32.925713],
						[119.030016, 32.927854],
						[119.023281, 32.935063],
						[119.026312, 32.947251],
						[119.020812, 32.955813],
						[119.008913, 32.959395],
						[118.993647, 32.958215],
						[118.961207, 32.94581],
						[118.941619, 32.946116],
						[118.933818, 32.938645],
						[118.921414, 32.939563],
						[118.90626, 32.944936],
						[118.893239, 32.940873],
						[118.891162, 32.951489],
						[118.896214, 32.957735],
						[118.884652, 32.960618],
						[118.865233, 32.955027],
						[118.849349, 32.956643],
						[118.849405, 32.945897],
						[118.842502, 32.943669],
						[118.848956, 32.927198],
						[118.839471, 32.922523],
						[118.836945, 32.911424],
						[118.818985, 32.920644],
						[118.812194, 32.91693],
						[118.809332, 32.907884],
						[118.814608, 32.902727],
						[118.81124, 32.875494],
						[118.806189, 32.870247],
						[118.812531, 32.865219],
						[118.811689, 32.854987],
						[118.791035, 32.848384],
						[118.747875, 32.858704],
						[118.741813, 32.853369],
						[118.746808, 32.800353],
						[118.736874, 32.793351],
						[118.737941, 32.773264],
						[118.746359, 32.759256],
						[118.752702, 32.755842],
						[118.756294, 32.737059],
						[118.736706, 32.73233],
						[118.724471, 32.721951],
						[118.70724, 32.720287],
						[118.694163, 32.726637],
						[118.657569, 32.736096],
						[118.654033, 32.740693],
						[118.639385, 32.744809],
						[118.632313, 32.739993],
						[118.617047, 32.738942],
						[118.607562, 32.726637],
						[118.59078, 32.724841],
						[118.576581, 32.719104],
						[118.559743, 32.729921],
						[118.544702, 32.729396],
						[118.520456, 32.723221],
						[118.489755, 32.724491],
						[118.483469, 32.721426],
						[118.459279, 32.726111],
						[118.450467, 32.743364],
						[118.422854, 32.718097],
						[118.411011, 32.716039],
						[118.398664, 32.721426],
						[118.375316, 32.719017],
						[118.368188, 32.724754],
						[118.36628, 32.735001],
						[118.372285, 32.741744],
						[118.371163, 32.757724],
						[118.366224, 32.768318],
						[118.348769, 32.773001],
						[118.334064, 32.761576],
						[118.326431, 32.763459],
						[118.322334, 32.777465],
						[118.307124, 32.778735],
						[118.298761, 32.785562],
						[118.294439, 32.800134],
						[118.306619, 32.810591],
						[118.297863, 32.83207],
						[118.301736, 32.846241],
						[118.289557, 32.845498],
						[118.284618, 32.857305],
						[118.263178, 32.856168],
						[118.250606, 32.848384],
						[118.244432, 32.874488],
						[118.239774, 32.883363],
						[118.233039, 32.916231],
						[118.235396, 32.926543],
						[118.251335, 32.936155],
						[118.293373, 32.947164],
						[118.309649, 32.959002],
						[118.303812, 32.968654],
						[118.269352, 32.969178],
						[118.252402, 32.982148],
						[118.244825, 32.998303],
						[118.243478, 33.027767],
						[118.239605, 33.046445],
						[118.233375, 33.060014],
						[118.212441, 33.061934],
						[118.214854, 33.070833],
						[118.22765, 33.069525],
						[118.223666, 33.083439],
						[118.202899, 33.088106],
						[118.206491, 33.091246],
						[118.221308, 33.087626],
						[118.220915, 33.105855],
						[118.20969, 33.104329],
						[118.210476, 33.111829],
						[118.219625, 33.114096],
						[118.223722, 33.155464],
						[118.221364, 33.180693],
						[118.211599, 33.19912],
						[118.194368, 33.211664],
						[118.178204, 33.217979],
						[118.168382, 33.21345],
						[118.156315, 33.195461],
						[118.159964, 33.181042],
						[118.149019, 33.169495],
						[118.11888, 33.160562],
						[118.088292, 33.149667],
						[118.069153, 33.139948],
						[118.046871, 33.138422],
						[118.038228, 33.135196],
						[118.036713, 33.1525],
						[118.025656, 33.155943],
						[118.017406, 33.164615],
						[118.008482, 33.16784],
						[118.003879, 33.177033],
						[117.989175, 33.179648],
						[117.986424, 33.193371],
						[117.980924, 33.200166],
						[117.993608, 33.20561],
						[117.993496, 33.211272],
						[117.977444, 33.226253],
						[117.953816, 33.223945],
						[117.942366, 33.225078],
						[117.938999, 33.234309],
						[117.948035, 33.252115],
						[117.939448, 33.262606],
						[117.974245, 33.279711],
						[117.983281, 33.296768],
						[117.985919, 33.32026],
						[117.99243, 33.333135],
						[117.975368, 33.335745],
						[117.971607, 33.349313],
						[117.995517, 33.347095],
						[118.0059, 33.352095],
						[118.029304, 33.372269],
						[118.028238, 33.390569],
						[118.016844, 33.406692],
						[118.021952, 33.421596],
						[118.023579, 33.440928],
						[118.028631, 33.458432],
						[118.04356, 33.473718],
						[118.050632, 33.49204],
						[118.05776, 33.491693],
						[118.108104, 33.475107],
						[118.106813, 33.503934],
						[118.107992, 33.520167],
						[118.099124, 33.52941],
						[118.108384, 33.530017],
						[118.117252, 33.591657],
						[118.112257, 33.617064],
						[118.120115, 33.621659],
						[118.168102, 33.663739],
						[118.164005, 33.692633],
						[118.167709, 33.714979],
						[118.153341, 33.720175],
						[118.160862, 33.735327],
						[118.177811, 33.736107],
						[118.185332, 33.744937],
						[118.168326, 33.749569],
						[118.149187, 33.746452],
						[118.133472, 33.75143],
						[118.117982, 33.766534],
						[118.105971, 33.76463],
						[118.065561, 33.765798],
						[118.062418, 33.758398],
						[118.045749, 33.750045],
						[118.02835, 33.746625],
						[118.030876, 33.740479],
						[118.019931, 33.738704],
						[118.018809, 33.745846],
						[118.003936, 33.744937],
						[117.99445, 33.750045],
						[117.972505, 33.749872],
						[117.96549, 33.763461],
						[117.954321, 33.75104],
						[117.952749, 33.738185],
						[117.936754, 33.729353],
						[117.918176, 33.734332],
						[117.915819, 33.738358],
						[117.900497, 33.735674],
						[117.897578, 33.72931],
						[117.901675, 33.720131],
						[117.8877, 33.722599],
						[117.879955, 33.727751],
						[117.848357, 33.73602],
						[117.835841, 33.734115],
						[117.828151, 33.736972],
						[117.805589, 33.736193],
						[117.791277, 33.733163],
						[117.777919, 33.722513],
						[117.767031, 33.72182],
						[117.752663, 33.711515],
						[117.735264, 33.722729],
						[117.731953, 33.734765],
						[117.723478, 33.739007],
						[117.724713, 33.749569],
						[117.734086, 33.751776],
						[117.741831, 33.762769],
						[117.749015, 33.791629],
						[117.752495, 33.812868],
						[117.746153, 33.823724],
						[117.750081, 33.827183],
						[117.753, 33.847203],
						[117.752439, 33.863241],
						[117.75923, 33.874522],
						[117.758668, 33.885672],
						[117.753729, 33.891419],
						[117.740821, 33.891981],
						[117.715396, 33.879233],
						[117.70361, 33.887789],
						[117.690084, 33.915398],
						[117.672629, 33.934965],
						[117.67246, 33.952411],
						[117.662975, 33.968732],
						[117.671338, 33.986733],
						[117.666286, 33.998688],
						[117.645801, 34.013619],
						[117.629749, 34.02872],
						[117.616391, 34.032257],
						[117.610217, 34.029281],
						[117.618131, 34.017071],
						[117.616672, 34.004946],
						[117.610273, 33.999249],
						[117.59787, 33.997005],
						[117.58816, 33.987855],
						[117.575757, 33.982891],
						[117.568909, 33.985222],
						[117.556449, 34.007319],
						[117.544663, 34.013619],
						[117.54253, 34.021644],
						[117.545337, 34.035191],
						[117.530632, 34.050676],
						[117.514805, 34.060854],
						[117.50487, 34.06163],
						[117.500437, 34.052272],
						[117.476808, 34.047614],
						[117.460251, 34.037391],
						[117.435444, 34.028332],
						[117.415631, 34.025916],
						[117.405753, 34.030057],
						[117.400253, 34.041575],
						[117.388242, 34.055593],
						[117.371124, 34.060682],
						[117.377803, 34.071462],
						[117.357149, 34.088234],
						[117.343398, 34.08056],
						[117.319489, 34.084397],
						[117.311463, 34.068056],
						[117.29384, 34.071074],
						[117.287778, 34.078663],
						[117.277002, 34.078922],
						[117.257639, 34.0659],
						[117.224693, 34.064175],
						[117.212121, 34.074696],
						[117.20707, 34.068616],
						[117.192702, 34.068746],
						[117.182094, 34.076076],
						[117.161272, 34.084354],
						[117.15145, 34.083707],
						[117.157961, 34.09871],
						[117.146567, 34.097804],
						[117.130291, 34.10177],
						[117.129954, 34.117459],
						[117.123837, 34.128232],
						[117.106438, 34.13043],
						[117.089993, 34.145682],
						[117.072314, 34.146716],
						[117.054915, 34.155073],
						[117.047057, 34.151412],
						[117.038358, 34.167436],
						[117.025337, 34.167651],
						[117.030837, 34.186342],
						[117.040322, 34.201498],
						[117.047226, 34.205803],
						[117.051042, 34.221558],
						[117.044868, 34.224743],
						[117.049583, 34.242432],
						[117.045261, 34.24781],
						[117.027526, 34.240194],
						[117.020791, 34.243335],
						[117.018882, 34.255512],
						[117.010632, 34.2559],
						[116.984365, 34.269839],
						[116.968987, 34.28369],
						[116.969717, 34.293109],
						[116.976283, 34.304892],
						[116.969268, 34.323122],
						[116.982962, 34.345775],
						[116.980773, 34.358109],
						[116.961242, 34.363266],
						[116.960961, 34.371989],
						[116.969324, 34.38883],
						[116.945639, 34.395531],
						[116.920551, 34.406999],
						[116.909214, 34.408287],
						[116.883509, 34.403047],
						[116.867008, 34.39218],
						[116.848543, 34.389045],
						[116.828057, 34.389216],
						[116.804709, 34.412754],
						[116.782146, 34.431089],
						[116.782708, 34.438302],
						[116.773728, 34.453456],
						[116.76065, 34.462598],
						[116.745104, 34.468263],
						[116.722878, 34.472684],
						[116.662544, 34.473027],
						[116.623424, 34.488646],
						[116.575101, 34.488947],
						[116.568646, 34.492508],
						[116.573641, 34.497699],
						[116.592443, 34.493838],
						[116.598954, 34.500145],
						[116.595193, 34.511512],
						[116.587673, 34.512542],
						[116.570555, 34.523393],
						[116.548048, 34.542905],
						[116.52919, 34.540676],
						[116.520659, 34.543162],
						[116.526159, 34.553367],
						[116.509546, 34.557525],
						[116.490408, 34.573343],
						[116.491418, 34.588944],
						[116.478341, 34.603856],
						[116.477218, 34.615081],
						[116.447584, 34.620564],
						[116.432823, 34.63016],
						[116.430466, 34.650803],
						[116.393367, 34.643052],
						[116.382591, 34.63864],
						[116.37058, 34.642238],
						[116.364407, 34.651831],
						[116.378214, 34.668016],
						[116.378101, 34.684155],
						[116.385229, 34.68668],
						[116.38551, 34.694727],
						[116.392694, 34.703886],
						[116.391796, 34.710348],
						[116.377091, 34.718136],
						[116.363789, 34.715226],
						[116.368448, 34.725324],
						[116.365698, 34.742778],
						[116.371535, 34.750177],
						[116.403189, 34.756293],
						[116.405827, 34.817386],
						[116.408297, 34.826147],
						[116.40796, 34.850714],
						[116.436079, 34.883046],
						[116.445283, 34.88864],
						[116.445059, 34.895429],
						[116.455779, 34.900638],
						[116.480698, 34.89735],
						[116.500566, 34.90115],
						[116.502755, 34.906102],
						[116.523073, 34.903968],
						[116.54614, 34.909389],
						[116.560059, 34.909304],
						[116.613883, 34.922792],
						[116.622526, 34.940034],
						[116.631787, 34.940717],
						[116.639981, 34.932609],
						[116.657885, 34.928981],
						[116.658447, 34.93342],
						[116.675733, 34.933121],
						[116.677978, 34.939181],
						[116.696948, 34.932737],
						[116.706209, 34.933974],
						[116.721363, 34.925908],
						[116.745328, 34.921],
						[116.746002, 34.91575],
						[116.756609, 34.9175],
						[116.781192, 34.916561],
						[116.786973, 34.940461],
						[116.797637, 34.938754],
						[116.796907, 34.944131],
						[116.785458, 34.947288],
						[116.781641, 34.961922],
						[116.789106, 34.959789],
						[116.789106, 34.975104],
						[116.803699, 34.970369],
						[116.803867, 34.928298],
						[116.812173, 34.927957],
						[116.80875, 34.96879],
						[116.815878, 34.965292],
						[116.822164, 34.929323],
						[116.858084, 34.928384],
						[116.8761, 34.912548],
						[116.899055, 34.904693],
						[116.922291, 34.89449],
						[116.922123, 34.87143],
						[116.945302, 34.873779],
						[116.945246, 34.876811],
						[116.966967, 34.875616],
						[116.976845, 34.868526],
						[116.933741, 34.861906],
						[116.930092, 34.859685],
						[116.928858, 34.842896],
						[116.966125, 34.844477],
						[116.979146, 34.81495],
						[116.971681, 34.811873],
						[116.951139, 34.810591],
						[116.951644, 34.794562],
						[116.965844, 34.785071],
						[116.967921, 34.772971],
						[116.976789, 34.771261],
						[116.978472, 34.763606],
						[116.989697, 34.765146],
						[116.995647, 34.758261],
						[117.021913, 34.759202],
						[117.043185, 34.736532],
						[117.061145, 34.723997],
						[117.070518, 34.713685],
						[117.069058, 34.708294],
						[117.077365, 34.696482],
						[117.072033, 34.694214],
						[117.061706, 34.675722],
						[117.062323, 34.657697],
						[117.072987, 34.639069],
						[117.081518, 34.638212],
						[117.095886, 34.647548],
						[117.103912, 34.648961],
						[117.115249, 34.628147],
						[117.123724, 34.60467],
						[117.13349, 34.586073],
						[117.147634, 34.570257],
						[117.151282, 34.559283],
						[117.140618, 34.538703],
						[117.139383, 34.526653],
						[117.14595, 34.503963],
						[117.156614, 34.480923],
						[117.159869, 34.453113],
						[117.166043, 34.434653],
						[117.199549, 34.434481],
						[117.200223, 34.441608],
						[117.223122, 34.446459],
						[117.222336, 34.450623],
						[117.234628, 34.454486],
						[117.247929, 34.451052],
						[117.255843, 34.46204],
						[117.255113, 34.472555],
						[117.24271, 34.47852],
						[117.252363, 34.486501],
						[117.256011, 34.476331],
						[117.263588, 34.472641],
						[117.267461, 34.480022],
						[117.259323, 34.497056],
						[117.274364, 34.503534],
						[117.270828, 34.516145],
						[117.275206, 34.520606],
						[117.268078, 34.532828],
						[117.287441, 34.5336],
						[117.302651, 34.541362],
						[117.303381, 34.548351],
						[117.294513, 34.554139],
						[117.321341, 34.565413],
						[117.333015, 34.56177],
						[117.330938, 34.567985],
						[117.318086, 34.566228],
						[117.31904, 34.573643],
						[117.333745, 34.572657],
						[117.344016, 34.582044],
						[117.36321, 34.586158],
						[117.374435, 34.584187],
						[117.402554, 34.5694],
						[117.403789, 34.546893],
						[117.424499, 34.537031],
						[117.426744, 34.525237],
						[117.439428, 34.520005],
						[117.43825, 34.516445],
						[117.451439, 34.506279],
						[117.466481, 34.484656],
						[117.482084, 34.485943],
						[117.486686, 34.482039],
						[117.487359, 34.466332],
						[117.493252, 34.472641],
						[117.512952, 34.472598],
						[117.538265, 34.467233],
						[117.547806, 34.475173],
						[117.561332, 34.471954],
						[117.569807, 34.46307],
						[117.592257, 34.462512],
						[117.603202, 34.476846],
						[117.609656, 34.490491],
						[117.629244, 34.488518],
						[117.638224, 34.49727],
						[117.647035, 34.492937],
						[117.659102, 34.501045],
						[117.673414, 34.515845],
						[117.682001, 34.529569],
						[117.684471, 34.547322],
						[117.699344, 34.545607],
						[117.748622, 34.533386],
						[117.773991, 34.529054],
						[117.790491, 34.518933],
						[117.80166, 34.518761],
						[117.799303, 34.535015],
						[117.794813, 34.539947],
						[117.794589, 34.559755],
						[117.791446, 34.585087],
						[117.798517, 34.62185],
						[117.793634, 34.625619],
						[117.796048, 34.637741],
						[117.793634, 34.651788],
						[117.79964, 34.647291],
						[117.820126, 34.646178],
						[117.831743, 34.653458],
						[117.834494, 34.647291],
						[117.847515, 34.652387],
						[117.849367, 34.647206],
						[117.863454, 34.645193],
						[117.877934, 34.650203],
						[117.881021, 34.64515],
						[117.903135, 34.64455],
						[117.909701, 34.670199],
						[117.939672, 34.664847],
						[117.951683, 34.678462],
						[117.963301, 34.678547],
						[117.9917, 34.670071],
						[117.990802, 34.661722],
						[118.007415, 34.656113],
						[118.007864, 34.647505],
						[118.018191, 34.647034],
						[118.020661, 34.660437],
						[118.053943, 34.650931],
						[118.057423, 34.654999],
						[118.077796, 34.653715],
						[118.08397, 34.655899],
						[118.10266, 34.64772],
						[118.094578, 34.636584],
						[118.100527, 34.626562],
						[118.113043, 34.621464],
						[118.114727, 34.614396],
						[118.102828, 34.593443],
						[118.082399, 34.579858],
						[118.078975, 34.569786],
						[118.100471, 34.564727],
						[118.127243, 34.555382],
						[118.137177, 34.563227],
						[118.140713, 34.55401],
						[118.153734, 34.549165],
						[118.163556, 34.55148],
						[118.184659, 34.544192],
						[118.167597, 34.519705],
						[118.164959, 34.504906],
						[118.141611, 34.496884],
						[118.132855, 34.483412],
						[118.139927, 34.475344],
						[118.177755, 34.453241],
						[118.178878, 34.425207],
						[118.177138, 34.408717],
						[118.170403, 34.381355],
						[118.179271, 34.379422],
						[118.183368, 34.390333],
						[118.189598, 34.380624],
						[118.204359, 34.377359],
						[118.217716, 34.379121],
						[118.220298, 34.405925],
						[118.230962, 34.398709],
						[118.242411, 34.40571],
						[118.277377, 34.40468],
						[118.279903, 34.412152],
						[118.289164, 34.412281],
						[118.290679, 34.424563],
						[118.320931, 34.421342],
						[118.352248, 34.422845],
						[118.353203, 34.417435],
						[118.379974, 34.415545],
						[118.395184, 34.427053],
						[118.40495, 34.42774],
						[118.408205, 34.435512]
					]
				],
				[
					[
						[118.868207, 31.520525],
						[118.855691, 31.504726],
						[118.846711, 31.50304],
						[118.846262, 31.50912],
						[118.857824, 31.523809],
						[118.870452, 31.526028],
						[118.868207, 31.520525]
					]
				],
				[
					[
						[121.403775, 32.530583],
						[121.429255, 32.531505],
						[121.436495, 32.529266],
						[121.435205, 32.520005],
						[121.408601, 32.519566],
						[121.402652, 32.521541],
						[121.403775, 32.530583]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 340000,
			"name": "安徽省",
			"center": [117.283042, 31.86119],
			"centroid": [117.226862, 31.849273],
			"cp":[117.283042, 31.56119],
			"childrenNum": 16,
			"level": "province",
			"acroutes": [100000],
			"parent": {
				"adcode": 100000
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[115.639757, 33.585115],
						[115.625029, 33.625633],
						[115.617784, 33.632608],
						[115.601626, 33.657662],
						[115.602531, 33.67264],
						[115.599624, 33.688286],
						[115.607155, 33.68906],
						[115.596287, 33.700315],
						[115.601578, 33.718537],
						[115.59624, 33.731233],
						[115.583561, 33.747229],
						[115.574838, 33.752234],
						[115.570024, 33.765286],
						[115.56316, 33.771683],
						[115.56521, 33.780193],
						[115.582226, 33.788703],
						[115.59052, 33.783701],
						[115.614257, 33.775654],
						[115.621168, 33.796799],
						[115.623313, 33.811959],
						[115.616592, 33.820001],
						[115.625601, 33.823662],
						[115.626268, 33.836187],
						[115.636135, 33.841187],
						[115.633513, 33.867314],
						[115.620882, 33.876124],
						[115.605725, 33.867417],
						[115.592331, 33.868241],
						[115.579509, 33.877],
						[115.564209, 33.871333],
						[115.556678, 33.876897],
						[115.546192, 33.875506],
						[115.546573, 33.888436],
						[115.555296, 33.888591],
						[115.556821, 33.903682],
						[115.568308, 33.906927],
						[115.559776, 33.914549],
						[115.562588, 33.927164],
						[115.569976, 33.932828],
						[115.569166, 33.945492],
						[115.577555, 33.950125],
						[115.579033, 33.973954],
						[115.588375, 33.97699],
						[115.591044, 33.986201],
						[115.584085, 33.988619],
						[115.592665, 34.009865],
						[115.606583, 34.013209],
						[115.601054, 34.022981],
						[115.615067, 34.033369],
						[115.621359, 34.03013],
						[115.642236, 34.032289],
						[115.649576, 34.035632],
						[115.648003, 34.046327],
						[115.65358, 34.060106],
						[115.669166, 34.056713],
						[115.681845, 34.065503],
						[115.699814, 34.066017],
						[115.705963, 34.059797],
						[115.735849, 34.076811],
						[115.753437, 34.067714],
						[115.769118, 34.067405],
						[115.777603, 34.073727],
						[115.793427, 34.063653],
						[115.809109, 34.06247],
						[115.815543, 34.052908],
						[115.832226, 34.038563],
						[115.845238, 34.03085],
						[115.845477, 34.012026],
						[115.852722, 34.003847],
						[115.877078, 34.003178],
						[115.877555, 34.029872],
						[115.887278, 34.032804],
						[115.895334, 34.028741],
						[115.899338, 34.014752],
						[115.904342, 34.009968],
						[115.919738, 34.010791],
						[115.926697, 34.007911],
						[115.957583, 34.007756],
						[115.984037, 33.987847],
						[115.994952, 33.975086],
						[116.000338, 33.963198],
						[115.995524, 33.947551],
						[115.982703, 33.917175],
						[115.98704, 33.901159],
						[115.999147, 33.901931],
						[116.012493, 33.897399],
						[116.013446, 33.885706],
						[116.034561, 33.880039],
						[116.034752, 33.873754],
						[116.043475, 33.874888],
						[116.054914, 33.860873],
						[116.056725, 33.850928],
						[116.065067, 33.847475],
						[116.063494, 33.826188],
						[116.045953, 33.829023],
						[116.045429, 33.822991],
						[116.05806, 33.821393],
						[116.06235, 33.814485],
						[116.055438, 33.804792],
						[116.073313, 33.794066],
						[116.074457, 33.781534],
						[116.099099, 33.783133],
						[116.098908, 33.774881],
						[116.109299, 33.758219],
						[116.131654, 33.752234],
						[116.14276, 33.738458],
						[116.14214, 33.734432],
						[116.155391, 33.709917],
						[116.174027, 33.708988],
						[116.197288, 33.72535],
						[116.230367, 33.730562],
						[116.246048, 33.728704],
						[116.263589, 33.730098],
						[116.284657, 33.750119],
						[116.308155, 33.757548],
						[116.31683, 33.77127],
						[116.328746, 33.76637],
						[116.3307, 33.773849],
						[116.348718, 33.778749],
						[116.361063, 33.776273],
						[116.372502, 33.780245],
						[116.393713, 33.783082],
						[116.40825, 33.805514],
						[116.420929, 33.796696],
						[116.432607, 33.795304],
						[116.436944, 33.80309],
						[116.432988, 33.814846],
						[116.437326, 33.846547],
						[116.453007, 33.846959],
						[116.460157, 33.859946],
						[116.47398, 33.861337],
						[116.484895, 33.869787],
						[116.501911, 33.864686],
						[116.505295, 33.872363],
						[116.521215, 33.871075],
						[116.525219, 33.880503],
						[116.536897, 33.882255],
						[116.53928, 33.874218],
						[116.546668, 33.882512],
						[116.558393, 33.881482],
						[116.555104, 33.888282],
						[116.558346, 33.901674],
						[116.567068, 33.908214],
						[116.581606, 33.908317],
						[116.597097, 33.904146],
						[116.611825, 33.894617],
						[116.627316, 33.888591],
						[116.642712, 33.892454],
						[116.638517, 33.917175],
						[116.645762, 33.929893],
						[116.639995, 33.948889],
						[116.650338, 33.959081],
						[116.64805, 33.973336],
						[116.633512, 33.977093],
						[116.629937, 33.984039],
						[116.607249, 33.999886],
						[116.60315, 34.007911],
						[116.604199, 34.021335],
						[116.595619, 34.040106],
						[116.587421, 34.04571],
						[116.576887, 34.064064],
						[116.580319, 34.065555],
						[116.567735, 34.075938],
						[116.566877, 34.083801],
						[116.557964, 34.097779],
						[116.539613, 34.103482],
						[116.541472, 34.109956],
						[116.528031, 34.122851],
						[116.534656, 34.126601],
						[116.535991, 34.150997],
						[116.545857, 34.161061],
						[116.565495, 34.169533],
						[116.559966, 34.186166],
						[116.546143, 34.195508],
						[116.542712, 34.218858],
						[116.547144, 34.228196],
						[116.543617, 34.239533],
						[116.55396, 34.241893],
						[116.56764, 34.251229],
						[116.582321, 34.266512],
						[116.582416, 34.27523],
						[116.568975, 34.283434],
						[116.511873, 34.296456],
						[116.490138, 34.290919],
						[116.466306, 34.271179],
						[116.456868, 34.269127],
						[116.44581, 34.28815],
						[116.4307, 34.27805],
						[116.433226, 34.270153],
						[116.416258, 34.268256],
						[116.406105, 34.276512],
						[116.393951, 34.276101],
						[116.375934, 34.271281],
						[116.372216, 34.266102],
						[116.363255, 34.276255],
						[116.37336, 34.293944],
						[116.368832, 34.310244],
						[116.363541, 34.316856],
						[116.329652, 34.329719],
						[116.301577, 34.342119],
						[116.288803, 34.358923],
						[116.276792, 34.360409],
						[116.270834, 34.370704],
						[116.255629, 34.376492],
						[116.2399, 34.374545],
						[116.213589, 34.382227],
						[116.209919, 34.390216],
						[116.217068, 34.395541],
						[116.215877, 34.403324],
						[116.205295, 34.415662],
						[116.179223, 34.430506],
						[116.174933, 34.444682],
						[116.162064, 34.459419],
						[116.178842, 34.483565],
						[116.178603, 34.496044],
						[116.189471, 34.497067],
						[116.203913, 34.508675],
						[116.203818, 34.518748],
						[116.190948, 34.53567],
						[116.196334, 34.555654],
						[116.197002, 34.57594],
						[116.206296, 34.578086],
						[116.216925, 34.575123],
						[116.233417, 34.555143],
						[116.247717, 34.55177],
						[116.25296, 34.565721],
						[116.259156, 34.567612],
						[116.266067, 34.583757],
						[116.274885, 34.584626],
						[116.278651, 34.602096],
						[116.286086, 34.608838],
						[116.301101, 34.607765],
						[116.310872, 34.601432],
						[116.324981, 34.601125],
						[116.333989, 34.62089],
						[116.350958, 34.621145],
						[116.372121, 34.633451],
						[116.374218, 34.639986],
						[116.382559, 34.638659],
						[116.393379, 34.643049],
						[116.43051, 34.650809],
						[116.432845, 34.630132],
						[116.447573, 34.620532],
						[116.477221, 34.615119],
						[116.478365, 34.603832],
						[116.491425, 34.588968],
						[116.492378, 34.570576],
						[116.509585, 34.557494],
						[116.526124, 34.553354],
						[116.520643, 34.543184],
						[116.529175, 34.540679],
						[116.54805, 34.542928],
						[116.570548, 34.523401],
						[116.587707, 34.51251],
						[116.59519, 34.511539],
						[116.598956, 34.500187],
						[116.592473, 34.493845],
						[116.576792, 34.497681],
						[116.568689, 34.492515],
						[116.575123, 34.488935],
						[116.623407, 34.488628],
						[116.662588, 34.473027],
						[116.722883, 34.472669],
						[116.745095, 34.46827],
						[116.760681, 34.462591],
						[116.773693, 34.453483],
						[116.782702, 34.438285],
						[116.782654, 34.430199],
						[116.804723, 34.412744],
						[116.828078, 34.389243],
						[116.848526, 34.389038],
						[116.86702, 34.392162],
						[116.883512, 34.403068],
						[116.909203, 34.40829],
						[116.920547, 34.40701],
						[116.945667, 34.395541],
						[116.969308, 34.388833],
						[116.960967, 34.371985],
						[116.961253, 34.363277],
						[116.980223, 34.358359],
						[116.983178, 34.352468],
						[116.979651, 34.338533],
						[116.96926, 34.323109],
						[116.976648, 34.310911],
						[116.968974, 34.28369],
						[116.98437, 34.269845],
						[117.007249, 34.256973],
						[117.018879, 34.255537],
						[117.020786, 34.243329],
						[117.031081, 34.242765],
						[117.042092, 34.248664],
						[117.049575, 34.242406],
						[117.044904, 34.224758],
						[117.051005, 34.221577],
						[117.047239, 34.205772],
						[117.040328, 34.201513],
						[117.030795, 34.18632],
						[117.025314, 34.167633],
						[117.031558, 34.166709],
						[117.038374, 34.167428],
						[117.047049, 34.151408],
						[117.054913, 34.155105],
						[117.072311, 34.146683],
						[117.089994, 34.145707],
						[117.106439, 34.130402],
						[117.123836, 34.128193],
						[117.129985, 34.117457],
						[117.130318, 34.101787],
						[117.146572, 34.09783],
						[117.157916, 34.098755],
						[117.151434, 34.083698],
						[117.1613, 34.084315],
						[117.182082, 34.07604],
						[117.192711, 34.068742],
						[117.207058, 34.068639],
						[117.212158, 34.074704],
						[117.224742, 34.064167],
						[117.25763, 34.065914],
						[117.277029, 34.078919],
						[117.287754, 34.078662],
						[117.293807, 34.071055],
						[117.311491, 34.068073],
						[117.319498, 34.084366],
						[117.343426, 34.080563],
						[117.357153, 34.088221],
						[117.377792, 34.071466],
						[117.371119, 34.060671],
						[117.38823, 34.055582],
						[117.40029, 34.041545],
						[117.405723, 34.030078],
						[117.415638, 34.025913],
						[117.435466, 34.02833],
						[117.460251, 34.03738],
						[117.476791, 34.047613],
						[117.500432, 34.05224],
						[117.504913, 34.061648],
						[117.514779, 34.060877],
						[117.537468, 34.04463],
						[117.545332, 34.035169],
						[117.54252, 34.021644],
						[117.544665, 34.01362],
						[117.556438, 34.007345],
						[117.568926, 33.985223],
						[117.575742, 33.982908],
						[117.588183, 33.987847],
						[117.597859, 33.997005],
						[117.610299, 33.999217],
						[117.616638, 34.004927],
						[117.618116, 34.017118],
						[117.610251, 34.029307],
						[117.6164, 34.032289],
						[117.629746, 34.02869],
						[117.64252, 34.01542],
						[117.666305, 33.998703],
						[117.671309, 33.986715],
						[117.662968, 33.968705],
						[117.672501, 33.95239],
						[117.672596, 33.934938],
						[117.690089, 33.915372],
						[117.703626, 33.887818],
						[117.715399, 33.879267],
						[117.740852, 33.89199],
						[117.753769, 33.891424],
						[117.758631, 33.885655],
						[117.759203, 33.874527],
						[117.752434, 33.863243],
						[117.752959, 33.847165],
						[117.750099, 33.827167],
						[117.746142, 33.823765],
						[117.752482, 33.812835],
						[117.749002, 33.791643],
						[117.741853, 33.762759],
						[117.734036, 33.75177],
						[117.724694, 33.749551],
						[117.722739, 33.740831],
						[117.731939, 33.734742],
						[117.735275, 33.722717],
						[117.752673, 33.711517],
						[117.767067, 33.72184],
						[117.777935, 33.722511],
						[117.791757, 33.7334],
						[117.825504, 33.737322],
						[117.835847, 33.734123],
						[117.858964, 33.734329],
						[117.879936, 33.727775],
						[117.887706, 33.722614],
						[117.901671, 33.720137],
						[117.897572, 33.729324],
						[117.90048, 33.735671],
						[117.915828, 33.738354],
						[117.920547, 33.733349],
						[117.936705, 33.729375],
						[117.949431, 33.734071],
						[117.954293, 33.751047],
						[117.964922, 33.763429],
						[117.972358, 33.750274],
						[117.982796, 33.747333],
						[117.994426, 33.750067],
						[117.996714, 33.746146],
						[118.018783, 33.745836],
						[118.019974, 33.738716],
						[118.03089, 33.74047],
						[118.028316, 33.746662],
						[118.045761, 33.750016],
						[118.062443, 33.758374],
						[118.065589, 33.765802],
						[118.105961, 33.764616],
						[118.117973, 33.766524],
						[118.129746, 33.754195],
						[118.148859, 33.746404],
						[118.16292, 33.750738],
						[118.185322, 33.744959],
						[118.177458, 33.735826],
						[118.160823, 33.73531],
						[118.153339, 33.720137],
						[118.167734, 33.714975],
						[118.163969, 33.692623],
						[118.168258, 33.664015],
						[118.120117, 33.621655],
						[118.112443, 33.617262],
						[118.117782, 33.594419],
						[118.108392, 33.529991],
						[118.099145, 33.529371],
						[118.107963, 33.520163],
						[118.106819, 33.503917],
						[118.108106, 33.475091],
						[118.061681, 33.490773],
						[118.05067, 33.492067],
						[118.043568, 33.473694],
						[118.028649, 33.458423],
						[118.023597, 33.440923],
						[118.021881, 33.421193],
						[118.016924, 33.407001],
						[118.028268, 33.390578],
						[118.02598, 33.381459],
						[118.029269, 33.372236],
						[118.005913, 33.352075],
						[117.995475, 33.347099],
						[117.971595, 33.349328],
						[117.969546, 33.34404],
						[117.978983, 33.334139],
						[117.992996, 33.332946],
						[117.985894, 33.320243],
						[117.98313, 33.296388],
						[117.970404, 33.277195],
						[117.939469, 33.262617],
						[117.948049, 33.252135],
						[117.938993, 33.234282],
						[117.942377, 33.225043],
						[117.953816, 33.223953],
						[117.977458, 33.226237],
						[117.993473, 33.211286],
						[117.993616, 33.205627],
						[117.981509, 33.201006],
						[117.989183, 33.179663],
						[118.001528, 33.178624],
						[118.005866, 33.170314],
						[118.017448, 33.1646],
						[118.025694, 33.155977],
						[118.037086, 33.15234],
						[118.03823, 33.135195],
						[118.046905, 33.138416],
						[118.070451, 33.140391],
						[118.088278, 33.149691],
						[118.118878, 33.160548],
						[118.14905, 33.169483],
						[118.159965, 33.181065],
						[118.156342, 33.19545],
						[118.168354, 33.213466],
						[118.178173, 33.217983],
						[118.194379, 33.211701],
						[118.211633, 33.199085],
						[118.221261, 33.182208],
						[118.22374, 33.155457],
						[118.219593, 33.114096],
						[118.210441, 33.111861],
						[118.209679, 33.104324],
						[118.22088, 33.105883],
						[118.221309, 33.087637],
						[118.206485, 33.091276],
						[118.202863, 33.088104],
						[118.223692, 33.083477],
						[118.227648, 33.06949],
						[118.21516, 33.070946],
						[118.212396, 33.06195],
						[118.233368, 33.060025],
						[118.239612, 33.046451],
						[118.243473, 33.027776],
						[118.244807, 32.998324],
						[118.252434, 32.982137],
						[118.269355, 32.969175],
						[118.303816, 32.968655],
						[118.309631, 32.958971],
						[118.293378, 32.947151],
						[118.247906, 32.934757],
						[118.235418, 32.926528],
						[118.233034, 32.916267],
						[118.240041, 32.882349],
						[118.244426, 32.87448],
						[118.250575, 32.848366],
						[118.263206, 32.856185],
						[118.284607, 32.85728],
						[118.289517, 32.845499],
						[118.301719, 32.846228],
						[118.297858, 32.832047],
						[118.306628, 32.810563],
						[118.294426, 32.800131],
						[118.298764, 32.785578],
						[118.307153, 32.778691],
						[118.320785, 32.778274],
						[118.326409, 32.763456],
						[118.334035, 32.761577],
						[118.348811, 32.773004],
						[118.366209, 32.768309],
						[118.371166, 32.757716],
						[118.37231, 32.741746],
						[118.366256, 32.73496],
						[118.368163, 32.724781],
						[118.375313, 32.718987],
						[118.398668, 32.721388],
						[118.410966, 32.716063],
						[118.422882, 32.718099],
						[118.450479, 32.743364],
						[118.45925, 32.726086],
						[118.483511, 32.721388],
						[118.489755, 32.72452],
						[118.520451, 32.723215],
						[118.545284, 32.72948],
						[118.559726, 32.729897],
						[118.576599, 32.719091],
						[118.590803, 32.724834],
						[118.607534, 32.726661],
						[118.617019, 32.73898],
						[118.632319, 32.739971],
						[118.639421, 32.744825],
						[118.654054, 32.740702],
						[118.657581, 32.736109],
						[118.69414, 32.726608],
						[118.707248, 32.720292],
						[118.724454, 32.72191],
						[118.736704, 32.732351],
						[118.756294, 32.737048],
						[118.757438, 32.743834],
						[118.751528, 32.757142],
						[118.746332, 32.759281],
						[118.737943, 32.773265],
						[118.736847, 32.79335],
						[118.746809, 32.800392],
						[118.741804, 32.85337],
						[118.747858, 32.858687],
						[118.768163, 32.851494],
						[118.791042, 32.848418],
						[118.811728, 32.854986],
						[118.812538, 32.865203],
						[118.806199, 32.870258],
						[118.811251, 32.87547],
						[118.814588, 32.902722],
						[118.809345, 32.90788],
						[118.812205, 32.916892],
						[118.819021, 32.920642],
						[118.836942, 32.911422],
						[118.839516, 32.922517],
						[118.848954, 32.927205],
						[118.842519, 32.943662],
						[118.849383, 32.945902],
						[118.849335, 32.956628],
						[118.865255, 32.955014],
						[118.884654, 32.960585],
						[118.896237, 32.957774],
						[118.891232, 32.951734],
						[118.893568, 32.940798],
						[118.90577, 32.945068],
						[118.921451, 32.939548],
						[118.933796, 32.938663],
						[118.941613, 32.94611],
						[118.961203, 32.945797],
						[118.993663, 32.958242],
						[119.008916, 32.959388],
						[119.020832, 32.955795],
						[119.026313, 32.947255],
						[119.023549, 32.935382],
						[119.029602, 32.92632],
						[119.019831, 32.925695],
						[119.015064, 32.911683],
						[119.019497, 32.905118],
						[119.044997, 32.911422],
						[119.045712, 32.892458],
						[119.054912, 32.875053],
						[119.071308, 32.864733],
						[119.104292, 32.826729],
						[119.113062, 32.822922],
						[119.18494, 32.825634],
						[119.188896, 32.810876],
						[119.19128, 32.788812],
						[119.200908, 32.750984],
						[119.2082, 32.740493],
						[119.208963, 32.71528],
						[119.211632, 32.708179],
						[119.208677, 32.642784],
						[119.220212, 32.629616],
						[119.216923, 32.617282],
						[119.220498, 32.60986],
						[119.230984, 32.607141],
						[119.220069, 32.592452],
						[119.220212, 32.576609],
						[119.209297, 32.573576],
						[119.19433, 32.578596],
						[119.187133, 32.59998],
						[119.176933, 32.593811],
						[119.175169, 32.571066],
						[119.153863, 32.561862],
						[119.154483, 32.554958],
						[119.166685, 32.546014],
						[119.167781, 32.536337],
						[119.155579, 32.528071],
						[119.150098, 32.50981],
						[119.142281, 32.499396],
						[119.147762, 32.492644],
						[119.134511, 32.491545],
						[119.12045, 32.480082],
						[119.095998, 32.466052],
						[119.085131, 32.452701],
						[119.073691, 32.455371],
						[119.067447, 32.462439],
						[119.064445, 32.482385],
						[119.045522, 32.498454],
						[119.041375, 32.514781],
						[119.021737, 32.517868],
						[119.007533, 32.514048],
						[118.997428, 32.503896],
						[118.97984, 32.503844],
						[118.967924, 32.514572],
						[118.964778, 32.52671],
						[118.940565, 32.547793],
						[118.936561, 32.557521],
						[118.916351, 32.556057],
						[118.91597, 32.549519],
						[118.888325, 32.557207],
						[118.898668, 32.56045],
						[118.89638, 32.577289],
						[118.909345, 32.586857],
						[118.907867, 32.592295],
						[118.887896, 32.587119],
						[118.872405, 32.576034],
						[118.85596, 32.574361],
						[118.848525, 32.56819],
						[118.827028, 32.572687],
						[118.827791, 32.579694],
						[118.819259, 32.58623],
						[118.824645, 32.589628],
						[118.824931, 32.601914],
						[118.81373, 32.600816],
						[118.801766, 32.584348],
						[118.784369, 32.58257],
						[118.774693, 32.588112],
						[118.775789, 32.597732],
						[118.757533, 32.603953],
						[118.74433, 32.598882],
						[118.740708, 32.589367],
						[118.726027, 32.59632],
						[118.725312, 32.608239],
						[118.698001, 32.60641],
						[118.700861, 32.588531],
						[118.696666, 32.588269],
						[118.68904, 32.604737],
						[118.689564, 32.588531],
						[118.668782, 32.594909],
						[118.65229, 32.593079],
						[118.633034, 32.578962],
						[118.623406, 32.592609],
						[118.601814, 32.597366],
						[118.598096, 32.601339],
						[118.581271, 32.594543],
						[118.569497, 32.586439],
						[118.56373, 32.564372],
						[118.584655, 32.548996],
						[118.599002, 32.544654],
						[118.608821, 32.537069],
						[118.604864, 32.522839],
						[118.614445, 32.520432],
						[118.617448, 32.512426],
						[118.60801, 32.501751],
						[118.592376, 32.499867],
						[118.59333, 32.478826],
						[118.608058, 32.475842],
						[118.608582, 32.470554],
						[118.628077, 32.467675],
						[118.643425, 32.470502],
						[118.647715, 32.476522],
						[118.675217, 32.470136],
						[118.689278, 32.473486],
						[118.692615, 32.46511],
						[118.686895, 32.429815],
						[118.68904, 32.420649],
						[118.685751, 32.404986],
						[118.678697, 32.393931],
						[118.690184, 32.378263],
						[118.698763, 32.383189],
						[118.696094, 32.367991],
						[118.702052, 32.357927],
						[118.692901, 32.35169],
						[118.69986, 32.34975],
						[118.697524, 32.34262],
						[118.707915, 32.338426],
						[118.703244, 32.328988],
						[118.687657, 32.329985],
						[118.683463, 32.325003],
						[118.694855, 32.317243],
						[118.678458, 32.316561],
						[118.66025, 32.305443],
						[118.659964, 32.296369],
						[118.667305, 32.296369],
						[118.670784, 32.285615],
						[118.659249, 32.266098],
						[118.667448, 32.257545],
						[118.675741, 32.255131],
						[118.667495, 32.235923],
						[118.64414, 32.20999],
						[118.626599, 32.202534],
						[118.61964, 32.205475],
						[118.598334, 32.199489],
						[118.580889, 32.198649],
						[118.574931, 32.202587],
						[118.561728, 32.196863],
						[118.551719, 32.199646],
						[118.539612, 32.192452],
						[118.532367, 32.195813],
						[118.524645, 32.189039],
						[118.509822, 32.19429],
						[118.506485, 32.182107],
						[118.496809, 32.178588],
						[118.495618, 32.165194],
						[118.507438, 32.137875],
						[118.500622, 32.141711],
						[118.495046, 32.132883],
						[118.499097, 32.120376],
						[118.489469, 32.120744],
						[118.472977, 32.114858],
						[118.463349, 32.100666],
						[118.44109, 32.092045],
						[118.433511, 32.086682],
						[118.415112, 32.087418],
						[118.405198, 32.075799],
						[118.39476, 32.075589],
						[118.393282, 32.062705],
						[118.385084, 32.05813],
						[118.394378, 32.0484],
						[118.385989, 32.033146],
						[118.401528, 32.018679],
						[118.38966, 32.012049],
						[118.390994, 31.989527],
						[118.387181, 31.983264],
						[118.376695, 31.981737],
						[118.379221, 31.967262],
						[118.369021, 31.956153],
						[118.369498, 31.944201],
						[118.36435, 31.930141],
						[118.375313, 31.925349],
						[118.386037, 31.914815],
						[118.402958, 31.914025],
						[118.415923, 31.901435],
						[118.440136, 31.892689],
						[118.452291, 31.884628],
						[118.47231, 31.879623],
						[118.467114, 31.868873],
						[118.466781, 31.858016],
						[118.475456, 31.850321],
						[118.490613, 31.843152],
						[118.504721, 31.841729],
						[118.486132, 31.795434],
						[118.482176, 31.778344],
						[118.503196, 31.778028],
						[118.510775, 31.765631],
						[118.523597, 31.76199],
						[118.533844, 31.767266],
						[118.539659, 31.761568],
						[118.538706, 31.74938],
						[118.522119, 31.743047],
						[118.530031, 31.742309],
						[118.545093, 31.732071],
						[118.550003, 31.735976],
						[118.5572, 31.729643],
						[118.57169, 31.746214],
						[118.575312, 31.740937],
						[118.593091, 31.74442],
						[118.600718, 31.75397],
						[118.609345, 31.757189],
						[118.619021, 31.750066],
						[118.627076, 31.759458],
						[118.641661, 31.758244],
						[118.648382, 31.748799],
						[118.64209, 31.744314],
						[118.6521, 31.739776],
						[118.653959, 31.730118],
						[118.677267, 31.728587],
						[118.684893, 31.724893],
						[118.687324, 31.716183],
						[118.697715, 31.709426],
						[118.680746, 31.696598],
						[118.673406, 31.696334],
						[118.671404, 31.688467],
						[118.654912, 31.675635],
						[118.647, 31.679859],
						[118.643234, 31.671357],
						[118.647953, 31.659368],
						[118.643616, 31.650019],
						[118.657867, 31.641091],
						[118.673835, 31.640563],
						[118.684798, 31.636231],
						[118.694998, 31.639718],
						[118.716923, 31.639454],
						[118.719402, 31.62746],
						[118.728649, 31.634276],
						[118.734226, 31.632216],
						[118.745141, 31.656516],
						[118.744378, 31.668347],
						[118.751146, 31.677694],
						[118.768306, 31.677483],
						[118.774121, 31.682605],
						[118.799049, 31.666393],
						[118.783082, 31.656516],
						[118.789564, 31.646532],
						[118.796046, 31.628306],
						[118.802767, 31.619482],
						[118.81454, 31.619218],
						[118.819545, 31.628517],
						[118.833844, 31.630314],
						[118.858534, 31.623973],
						[118.868735, 31.611397],
						[118.870784, 31.599347],
						[118.865303, 31.591789],
						[118.877314, 31.589675],
						[118.873358, 31.573922],
						[118.881985, 31.564775],
						[118.875122, 31.551979],
						[118.873739, 31.531936],
						[118.883939, 31.53146],
						[118.885846, 31.518871],
						[118.868163, 31.520511],
						[118.870498, 31.526012],
						[118.857819, 31.523791],
						[118.846237, 31.509137],
						[118.846714, 31.503053],
						[118.856771, 31.506492],
						[118.883701, 31.500143],
						[118.877791, 31.478766],
						[118.870498, 31.463047],
						[118.866065, 31.44489],
						[118.86964, 31.421594],
						[118.851146, 31.392518],
						[118.847381, 31.393948],
						[118.829507, 31.377527],
						[118.800241, 31.368997],
						[118.784559, 31.368573],
						[118.771261, 31.363116],
						[118.7674, 31.365871],
						[118.770355, 31.379328],
						[118.765398, 31.387963],
						[118.754626, 31.385049],
						[118.74576, 31.372706],
						[118.735036, 31.344781],
						[118.72107, 31.322679],
						[118.719593, 31.294792],
						[118.704435, 31.302798],
						[118.707915, 31.296807],
						[118.726599, 31.282224],
						[118.761394, 31.277663],
						[118.779983, 31.259524],
						[118.781413, 31.239843],
						[118.795331, 31.229443],
						[118.802672, 31.228223],
						[118.819116, 31.236022],
						[118.824073, 31.230451],
						[118.851051, 31.23963],
						[118.869688, 31.24223],
						[118.891232, 31.237986],
						[118.915207, 31.244193],
						[118.924979, 31.239683],
						[118.953053, 31.237773],
						[118.983939, 31.237773],
						[118.986466, 31.231141],
						[119.003291, 31.233741],
						[119.015017, 31.241646],
						[119.022881, 31.238145],
						[119.039516, 31.23841],
						[119.048858, 31.233529],
						[119.062347, 31.238463],
						[119.073787, 31.232892],
						[119.085465, 31.240267],
						[119.105293, 31.23528],
						[119.107009, 31.250612],
						[119.120021, 31.261699],
						[119.131747, 31.262548],
						[119.14066, 31.276019],
						[119.150098, 31.277133],
						[119.158153, 31.294792],
						[119.176218, 31.293944],
						[119.181127, 31.300465],
						[119.199478, 31.293625],
						[119.197142, 31.273527],
						[119.204244, 31.26573],
						[119.215255, 31.27411],
						[119.218544, 31.264563],
						[119.236275, 31.259312],
						[119.238563, 31.254644],
						[119.250193, 31.257243],
						[119.249764, 31.262017],
						[119.261394, 31.261328],
						[119.266971, 31.250453],
						[119.294473, 31.263131],
						[119.314873, 31.26573],
						[119.333224, 31.264139],
						[119.337562, 31.258888],
						[119.345951, 31.268965],
						[119.350288, 31.281641],
						[119.350145, 31.301049],
						[119.356627, 31.303275],
						[119.367876, 31.289224],
						[119.371594, 31.271617],
						[119.379697, 31.26939],
						[119.365207, 31.232627],
						[119.360059, 31.212144],
						[119.365779, 31.195956],
						[119.371403, 31.197707],
						[119.379173, 31.189214],
						[119.394902, 31.199618],
						[119.405674, 31.194416],
						[119.389325, 31.188365],
						[119.39147, 31.174243],
						[119.400622, 31.178756],
						[119.415398, 31.172969],
						[119.423167, 31.181835],
						[119.438801, 31.177057],
						[119.454768, 31.164899],
						[119.460583, 31.156403],
						[119.475836, 31.158898],
						[119.482509, 31.152526],
						[119.48556, 31.161394],
						[119.494473, 31.163996],
						[119.51392, 31.156031],
						[119.5235, 31.159748],
						[119.534511, 31.158102],
						[119.545855, 31.147853],
						[119.56025, 31.140736],
						[119.571308, 31.128998],
						[119.57412, 31.113965],
						[119.581985, 31.108652],
						[119.599763, 31.109183],
						[119.613729, 31.129157],
						[119.623786, 31.130273],
						[119.624168, 31.115983],
						[119.649144, 31.105092],
						[119.634702, 31.093775],
						[119.629554, 31.085538],
						[119.634987, 31.064172],
						[119.631317, 31.046311],
						[119.634034, 31.01946],
						[119.624025, 31.005313],
						[119.616255, 31.002388],
						[119.607437, 30.991856],
						[119.588372, 30.979142],
						[119.580412, 30.967117],
						[119.582175, 30.947428],
						[119.580364, 30.929173],
						[119.563825, 30.919218],
						[119.556341, 30.896697],
						[119.559058, 30.891745],
						[119.558963, 30.871189],
						[119.573739, 30.853344],
						[119.575741, 30.829742],
						[119.561203, 30.829476],
						[119.55453, 30.825639],
						[119.524501, 30.776017],
						[119.507104, 30.769619],
						[119.491518, 30.777243],
						[119.480126, 30.773298],
						[119.478791, 30.753089],
						[119.484606, 30.744609],
						[119.479697, 30.736823],
						[119.482747, 30.704442],
						[119.466017, 30.683899],
						[119.452909, 30.671624],
						[119.448286, 30.655825],
						[119.433653, 30.644454],
						[119.412681, 30.642959],
						[119.400002, 30.658868],
						[119.395665, 30.678722],
						[119.391518, 30.685233],
						[119.379411, 30.679363],
						[119.372357, 30.680377],
						[119.35453, 30.666927],
						[119.343138, 30.664205],
						[119.333653, 30.652195],
						[119.323119, 30.630306],
						[119.311966, 30.621228],
						[119.291232, 30.616048],
						[119.275741, 30.617597],
						[119.258772, 30.614393],
						[119.25005, 30.620267],
						[119.239135, 30.609319],
						[119.253672, 30.596447],
						[119.254149, 30.588649],
						[119.264778, 30.582025],
						[119.264778, 30.573424],
						[119.245522, 30.561402],
						[119.236942, 30.546707],
						[119.242566, 30.530032],
						[119.261918, 30.525542],
						[119.261632, 30.517738],
						[119.272118, 30.510521],
						[119.287943, 30.512606],
						[119.313634, 30.531208],
						[119.326551, 30.533025],
						[119.328696, 30.52164],
						[119.336322, 30.507153],
						[119.330317, 30.488225],
						[119.334463, 30.478118],
						[119.336132, 30.445544],
						[119.349716, 30.438803],
						[119.352957, 30.424839],
						[119.349525, 30.408625],
						[119.363205, 30.409481],
						[119.368925, 30.39974],
						[119.366589, 30.388393],
						[119.371451, 30.38395],
						[119.393806, 30.38304],
						[119.403052, 30.374368],
						[119.399954, 30.367783],
						[119.386132, 30.363928],
						[119.375598, 30.354826],
						[119.34943, 30.34915],
						[119.342662, 30.363178],
						[119.329077, 30.371531],
						[119.300669, 30.36366],
						[119.289468, 30.349632],
						[119.278124, 30.341599],
						[119.265064, 30.338064],
						[119.247142, 30.340796],
						[119.239993, 30.327031],
						[119.245903, 30.321621],
						[119.236227, 30.2973],
						[119.229173, 30.289692],
						[119.222595, 30.299604],
						[119.205674, 30.301586],
						[119.201051, 30.291031],
						[119.188181, 30.291674],
						[119.156723, 30.29955],
						[119.151289, 30.304586],
						[119.128506, 30.304694],
						[119.111013, 30.311283],
						[119.090231, 30.324032],
						[119.073405, 30.31589],
						[119.063015, 30.304961],
						[119.05086, 30.306729],
						[119.048334, 30.312676],
						[119.028792, 30.312569],
						[119.004435, 30.328959],
						[118.988039, 30.333458],
						[118.988086, 30.348668],
						[118.975741, 30.347168],
						[118.96902, 30.351345],
						[118.959964, 30.347275],
						[118.955388, 30.359216],
						[118.936418, 30.35081],
						[118.936323, 30.34508],
						[118.917877, 30.332441],
						[118.908391, 30.330888],
						[118.899764, 30.322586],
						[118.879888, 30.314872],
						[118.881795, 30.298532],
						[118.878077, 30.282726],
						[118.889707, 30.254268],
						[118.882414, 30.24746],
						[118.893043, 30.242689],
						[118.903196, 30.21792],
						[118.924979, 30.213844],
						[118.929888, 30.203387],
						[118.920641, 30.199043],
						[118.910822, 30.187512],
						[118.864397, 30.169005],
						[118.852862, 30.166537],
						[118.845713, 30.156129],
						[118.856389, 30.148188],
						[118.865732, 30.151515],
						[118.881032, 30.146793],
						[118.896809, 30.148081],
						[118.895951, 30.138797],
						[118.888134, 30.127259],
						[118.887228, 30.117437],
						[118.871642, 30.113035],
						[118.868878, 30.10144],
						[118.872929, 30.094622],
						[118.875455, 30.072017],
						[118.878839, 30.064659],
						[118.888134, 30.06235],
						[118.897333, 30.051877],
						[118.890565, 30.041242],
						[118.902576, 30.029047],
						[118.898048, 30.017227],
						[118.890327, 30.012015],
						[118.895093, 30.001214],
						[118.89209, 29.994819],
						[118.899478, 29.981437],
						[118.891566, 29.959881],
						[118.894664, 29.938051],
						[118.884702, 29.938912],
						[118.871976, 29.94687],
						[118.86392, 29.936976],
						[118.848287, 29.941278],
						[118.838706, 29.934502],
						[118.844902, 29.915249],
						[118.845522, 29.899112],
						[118.841328, 29.891312],
						[118.807724, 29.867638],
						[118.802624, 29.860642],
						[118.778744, 29.841913],
						[118.766923, 29.848964],
						[118.755627, 29.845412],
						[118.750956, 29.831632],
						[118.765922, 29.823073],
						[118.75944, 29.817151],
						[118.745999, 29.818173],
						[118.739945, 29.813274],
						[118.736513, 29.788451],
						[118.74433, 29.779618],
						[118.749049, 29.761143],
						[118.744712, 29.738786],
						[118.724645, 29.72262],
						[118.718687, 29.709201],
						[118.700813, 29.706452],
						[118.682319, 29.686454],
						[118.67393, 29.669094],
						[118.647333, 29.643372],
						[118.640946, 29.641916],
						[118.633511, 29.648765],
						[118.619974, 29.654104],
						[118.602052, 29.643696],
						[118.573883, 29.638357],
						[118.555055, 29.613382],
						[118.549907, 29.613382],
						[118.535227, 29.590614],
						[118.500575, 29.575666],
						[118.494903, 29.553698],
						[118.497858, 29.543982],
						[118.495904, 29.519578],
						[118.47903, 29.510938],
						[118.458249, 29.506348],
						[118.448954, 29.513422],
						[118.429507, 29.503647],
						[118.414969, 29.50975],
						[118.393044, 29.50732],
						[118.38394, 29.510398],
						[118.379793, 29.502567],
						[118.358725, 29.477073],
						[118.34762, 29.473994],
						[118.324407, 29.49695],
						[118.310537, 29.496032],
						[118.306581, 29.47945],
						[118.316018, 29.450545],
						[118.316113, 29.422606],
						[118.291376, 29.419957],
						[118.28618, 29.426713],
						[118.276266, 29.423417],
						[118.267782, 29.427848],
						[118.255723, 29.426173],
						[118.248525, 29.431307],
						[118.232939, 29.423903],
						[118.218115, 29.42039],
						[118.204245, 29.395415],
						[118.193044, 29.395253],
						[118.188135, 29.406119],
						[118.1766, 29.404714],
						[118.163635, 29.412066],
						[118.136085, 29.418876],
						[118.12946, 29.432604],
						[118.138611, 29.437684],
						[118.137992, 29.454868],
						[118.127648, 29.472049],
						[118.143807, 29.489767],
						[118.142996, 29.499867],
						[118.13456, 29.508778],
						[118.109536, 29.521954],
						[118.103435, 29.530647],
						[118.082653, 29.533778],
						[118.050718, 29.543172],
						[118.042949, 29.566275],
						[118.014112, 29.577285],
						[118.003864, 29.578094],
						[117.994665, 29.573183],
						[117.984703, 29.561633],
						[117.964874, 29.569999],
						[117.954913, 29.565087],
						[117.938707, 29.549596],
						[117.920785, 29.554508],
						[117.889851, 29.545817],
						[117.876505, 29.546195],
						[117.863588, 29.55413],
						[117.852005, 29.554994],
						[117.829889, 29.563846],
						[117.822787, 29.571834],
						[117.807296, 29.573561],
						[117.794951, 29.570323],
						[117.770928, 29.557099],
						[117.753054, 29.560392],
						[117.736038, 29.551539],
						[117.707677, 29.549002],
						[117.69047, 29.555912],
						[117.682987, 29.568002],
						[117.682225, 29.587268],
						[117.678983, 29.59547],
						[117.668974, 29.596981],
						[117.661443, 29.611818],
						[117.647954, 29.614893],
						[117.628316, 29.606207],
						[117.608726, 29.591585],
						[117.586467, 29.584732],
						[117.574074, 29.591099],
						[117.557963, 29.590128],
						[117.546238, 29.594337],
						[117.54333, 29.588563],
						[117.534274, 29.598545],
						[117.523454, 29.629619],
						[117.530556, 29.65405],
						[117.516543, 29.663379],
						[117.493759, 29.65955],
						[117.474217, 29.668339],
						[117.451862, 29.695942],
						[117.457249, 29.725315],
						[117.455104, 29.749184],
						[117.44314, 29.758935],
						[117.434703, 29.761143],
						[117.413588, 29.78802],
						[117.409155, 29.802613],
						[117.424789, 29.834646],
						[117.418783, 29.850417],
						[117.403292, 29.84891],
						[117.384084, 29.843635],
						[117.375981, 29.818066],
						[117.356248, 29.813705],
						[117.347906, 29.822319],
						[117.338612, 29.847887],
						[117.333273, 29.850578],
						[117.325695, 29.843851],
						[117.303007, 29.840352],
						[117.297239, 29.836853],
						[117.292425, 29.822803],
						[117.278173, 29.825118],
						[117.271214, 29.830071],
						[117.257392, 29.831255],
						[117.249336, 29.846111],
						[117.25682, 29.859512],
						[117.261777, 29.880659],
						[117.253722, 29.90901],
						[117.246238, 29.915088],
						[117.21702, 29.92692],
						[117.206248, 29.927511],
						[117.188946, 29.921864],
						[117.177601, 29.921972],
						[117.148812, 29.911323],
						[117.134704, 29.903846],
						[117.127983, 29.895508],
						[117.133035, 29.874256],
						[117.127697, 29.861611],
						[117.110395, 29.855422],
						[117.092807, 29.836853],
						[117.073312, 29.832224],
						[117.0756, 29.822642],
						[117.092711, 29.809559],
						[117.127983, 29.795775],
						[117.135609, 29.780965],
						[117.135466, 29.772024],
						[117.108679, 29.751985],
						[117.10825, 29.745089],
						[117.122454, 29.728548],
						[117.113016, 29.712165],
						[117.085848, 29.696912],
						[117.070881, 29.693732],
						[117.051243, 29.682896],
						[117.042044, 29.680902],
						[117.015304, 29.685753],
						[116.996048, 29.683381],
						[116.984561, 29.674702],
						[116.971167, 29.655668],
						[116.939613, 29.64828],
						[116.918545, 29.634473],
						[116.873455, 29.609282],
						[116.848955, 29.576421],
						[116.838088, 29.569837],
						[116.818403, 29.564764],
						[116.795762, 29.566545],
						[116.780652, 29.570539],
						[116.779651, 29.57804],
						[116.786944, 29.591315],
						[116.774933, 29.595254],
						[116.770166, 29.592232],
						[116.760443, 29.599085],
						[116.740185, 29.585919],
						[116.729985, 29.568542],
						[116.721596, 29.56498],
						[116.716544, 29.590775],
						[116.688946, 29.604103],
						[116.685657, 29.611602],
						[116.670595, 29.625088],
						[116.651911, 29.63717],
						[116.652244, 29.645422],
						[116.663589, 29.659173],
						[116.677078, 29.66904],
						[116.680509, 29.681495],
						[116.705057, 29.688664],
						[116.717163, 29.690767],
						[116.715876, 29.697289],
						[116.706534, 29.696588],
						[116.705819, 29.697128],
						[116.703388, 29.710063],
						[116.698956, 29.7078],
						[116.673836, 29.709848],
						[116.687087, 29.734798],
						[116.703055, 29.741264],
						[116.720548, 29.763352],
						[116.739327, 29.774179],
						[116.745857, 29.790336],
						[116.762492, 29.802506],
						[116.780891, 29.79249],
						[116.789804, 29.795128],
						[116.812349, 29.811713],
						[116.830748, 29.841482],
						[116.861301, 29.867369],
						[116.882702, 29.893518],
						[116.891996, 29.919337],
						[116.891853, 29.92735],
						[116.900147, 29.949504],
						[116.887897, 29.968805],
						[116.868688, 29.980469],
						[116.845381, 29.969611],
						[116.835943, 29.970686],
						[116.835276, 29.95773],
						[116.828746, 29.963106],
						[116.829556, 30.006534],
						[116.802816, 29.996539],
						[116.787325, 30.020343],
						[116.783512, 30.030712],
						[116.770309, 30.035655],
						[116.764542, 30.048923],
						[116.753627, 30.048976],
						[116.747335, 30.057248],
						[116.720309, 30.053918],
						[116.685705, 30.07062],
						[116.666877, 30.076742],
						[116.642616, 30.076366],
						[116.611015, 30.070728],
						[116.596572, 30.059718],
						[116.586039, 30.046291],
						[116.57131, 30.014433],
						[116.571215, 29.98923],
						[116.564542, 29.949343],
						[116.558727, 29.924338],
						[116.551959, 29.90987],
						[116.54152, 29.901641],
						[116.525552, 29.897498],
						[116.479842, 29.897875],
						[116.467736, 29.896154],
						[116.441758, 29.879852],
						[116.392521, 29.855745],
						[116.35968, 29.843635],
						[116.343093, 29.835669],
						[116.322788, 29.820004],
						[116.312302, 29.808967],
						[116.280796, 29.788882],
						[116.261444, 29.782042],
						[116.253627, 29.783119],
						[116.227364, 29.816881],
						[116.208108, 29.827487],
						[116.187326, 29.829048],
						[116.167354, 29.827379],
						[116.135181, 29.819412],
						[116.131987, 29.844281],
						[116.134561, 29.877431],
						[116.125791, 29.901372],
						[116.104056, 29.926866],
						[116.085705, 29.950795],
						[116.077936, 29.956117],
						[116.073837, 29.969987],
						[116.081463, 29.981759],
						[116.078317, 30.010242],
						[116.088994, 30.026952],
						[116.091663, 30.036192],
						[116.079986, 30.057248],
						[116.079223, 30.066217],
						[116.0848, 30.075937],
						[116.083751, 30.095642],
						[116.088375, 30.11019],
						[116.085038, 30.126185],
						[116.075029, 30.133538],
						[116.06316, 30.151622],
						[116.056725, 30.169917],
						[116.05601, 30.181022],
						[116.063923, 30.193573],
						[116.064352, 30.206873],
						[116.046096, 30.223925],
						[116.031702, 30.227035],
						[116.026601, 30.239741],
						[116.012254, 30.249497],
						[115.994809, 30.255018],
						[115.988899, 30.267078],
						[115.985324, 30.291031],
						[115.980939, 30.295746],
						[115.958394, 30.305336],
						[115.938708, 30.306944],
						[115.921883, 30.301265],
						[115.904438, 30.310051],
						[115.903723, 30.315783],
						[115.914352, 30.3243],
						[115.916687, 30.334422],
						[115.896478, 30.3567],
						[115.884895, 30.379561],
						[115.90091, 30.397867],
						[115.909252, 30.398831],
						[115.921501, 30.416384],
						[115.930987, 30.420505],
						[115.938184, 30.417776],
						[115.946144, 30.425213],
						[115.920786, 30.429868],
						[115.915543, 30.443993],
						[115.894809, 30.452712],
						[115.894047, 30.459559],
						[115.900815, 30.469722],
						[115.898098, 30.482236],
						[115.909728, 30.506725],
						[115.919881, 30.515011],
						[115.905153, 30.52458],
						[115.899481, 30.537889],
						[115.887803, 30.542485],
						[115.883132, 30.559425],
						[115.875553, 30.569363],
						[115.87908, 30.578285],
						[115.866211, 30.587901],
						[115.857298, 30.589503],
						[115.84848, 30.601895],
						[115.828079, 30.606168],
						[115.824123, 30.596127],
						[115.819166, 30.59789],
						[115.807822, 30.615568],
						[115.814924, 30.624806],
						[115.809919, 30.642586],
						[115.798766, 30.65006],
						[115.797002, 30.658601],
						[115.775362, 30.668849],
						[115.77236, 30.677869],
						[115.762541, 30.685607],
						[115.767402, 30.694358],
						[115.765544, 30.707537],
						[115.776363, 30.728875],
						[115.782893, 30.751702],
						[115.79276, 30.759275],
						[115.810491, 30.759434],
						[115.820119, 30.750689],
						[115.834657, 30.756395],
						[115.85153, 30.756715],
						[115.854342, 30.767433],
						[115.868356, 30.774257],
						[115.8695, 30.782467],
						[115.85868, 30.784813],
						[115.865877, 30.798246],
						[115.86378, 30.815781],
						[115.848813, 30.82857],
						[115.849481, 30.841251],
						[115.863875, 30.855262],
						[115.865686, 30.864264],
						[115.876935, 30.869005],
						[115.885705, 30.877846],
						[115.912779, 30.887592],
						[115.932369, 30.889402],
						[115.936134, 30.902874],
						[115.970548, 30.920017],
						[115.976268, 30.931461],
						[115.993427, 30.936731],
						[116.009871, 30.949717],
						[116.024743, 30.953602],
						[116.034514, 30.951154],
						[116.039519, 30.957859],
						[116.07174, 30.956688],
						[116.06969, 30.969139],
						[116.0603, 30.994941],
						[116.058918, 31.012759],
						[116.046144, 31.014514],
						[116.015019, 31.011908],
						[116.010062, 31.017332],
						[116.00663, 31.034668],
						[115.994047, 31.034614],
						[115.983704, 31.041898],
						[115.961063, 31.046896],
						[115.946192, 31.04243],
						[115.938565, 31.047321],
						[115.942235, 31.060664],
						[115.939805, 31.071667],
						[115.925744, 31.076822],
						[115.909585, 31.090693],
						[115.902769, 31.089205],
						[115.887421, 31.109289],
						[115.886373, 31.127351],
						[115.880081, 31.141905],
						[115.869261, 31.14764],
						[115.857107, 31.143286],
						[115.841282, 31.128998],
						[115.829128, 31.126448],
						[115.813256, 31.13091],
						[115.797908, 31.127883],
						[115.781511, 31.11354],
						[115.770072, 31.113061],
						[115.764066, 31.118215],
						[115.75582, 31.142542],
						[115.740567, 31.152951],
						[115.728127, 31.174721],
						[115.700815, 31.201104],
						[115.678127, 31.207632],
						[115.655248, 31.210976],
						[115.645954, 31.209596],
						[115.636325, 31.19999],
						[115.629033, 31.184649],
						[115.603723, 31.173712],
						[115.596716, 31.150136],
						[115.585706, 31.144188],
						[115.559586, 31.160332],
						[115.540711, 31.191337],
						[115.538375, 31.220369],
						[115.53971, 31.231884],
						[115.530081, 31.249339],
						[115.51602, 31.263502],
						[115.507584, 31.267905],
						[115.501006, 31.262388],
						[115.494047, 31.265942],
						[115.473122, 31.265253],
						[115.466402, 31.276338],
						[115.457822, 31.281588],
						[115.460968, 31.318067],
						[115.449624, 31.31584],
						[115.442045, 31.346106],
						[115.420501, 31.349921],
						[115.404581, 31.337838],
						[115.3991, 31.342979],
						[115.372074, 31.349285],
						[115.382465, 31.356598],
						[115.375744, 31.371063],
						[115.38318, 31.37562],
						[115.392808, 31.38987],
						[115.373647, 31.40576],
						[115.38337, 31.418682],
						[115.385658, 31.443302],
						[115.389805, 31.45029],
						[115.377651, 31.47051],
						[115.371168, 31.494535],
						[115.377126, 31.503],
						[115.389614, 31.507603],
						[115.396812, 31.515168],
						[115.415877, 31.525959],
						[115.428556, 31.54722],
						[115.431559, 31.559012],
						[115.428223, 31.563401],
						[115.438852, 31.579948],
						[115.440043, 31.588723],
						[115.488232, 31.612242],
						[115.489662, 31.62577],
						[115.476983, 31.64294],
						[115.484276, 31.649068],
						[115.48542, 31.659791],
						[115.495382, 31.672942],
						[115.515067, 31.682869],
						[115.531845, 31.698551],
						[115.553485, 31.695278],
						[115.564924, 31.709004],
						[115.582655, 31.713913],
						[115.586945, 31.721726],
						[115.601435, 31.731701],
						[115.619166, 31.738351],
						[115.636564, 31.755078],
						[115.659633, 31.760196],
						[115.677793, 31.778872],
						[115.689805, 31.776551],
						[115.697145, 31.768638],
						[115.710825, 31.770906],
						[115.729843, 31.763309],
						[115.734276, 31.776023],
						[115.741997, 31.78209],
						[115.763065, 31.782353],
						[115.767927, 31.787839],
						[115.788327, 31.779821],
						[115.815353, 31.76236],
						[115.831034, 31.777606],
						[115.836468, 31.77386],
						[115.850243, 31.786731],
						[115.858298, 31.773702],
						[115.868689, 31.776551],
						[115.885229, 31.776076],
						[115.900815, 31.792006],
						[115.910253, 31.792322],
						[115.915019, 31.811888],
						[115.91316, 31.820113],
						[115.904056, 31.829393],
						[115.89295, 31.833294],
						[115.895715, 31.867503],
						[115.898337, 31.880255],
						[115.90377, 31.883522],
						[115.917259, 31.909969],
						[115.920167, 31.92045],
						[115.916115, 31.935987],
						[115.909013, 31.943253],
						[115.911349, 31.957996],
						[115.92317, 31.985474],
						[115.924552, 31.995579],
						[115.933799, 32.001631],
						[115.927603, 32.007524],
						[115.927841, 32.023572],
						[115.919547, 32.027886],
						[115.927745, 32.036303],
						[115.922216, 32.049663],
						[115.927793, 32.058761],
						[115.939614, 32.065861],
						[115.942569, 32.077692],
						[115.932512, 32.084264],
						[115.926554, 32.105239],
						[115.931368, 32.109286],
						[115.940329, 32.146755],
						[115.941949, 32.165141],
						[115.933656, 32.180426],
						[115.925267, 32.187831],
						[115.922884, 32.203637],
						[115.912731, 32.227629],
						[115.914733, 32.254869],
						[115.920072, 32.273181],
						[115.911063, 32.284199],
						[115.908251, 32.299253],
						[115.900291, 32.301404],
						[115.906964, 32.311579],
						[115.904581, 32.340995],
						[115.899242, 32.344979],
						[115.897908, 32.372289],
						[115.899099, 32.390106],
						[115.88928, 32.413473],
						[115.889423, 32.424263],
						[115.879223, 32.432591],
						[115.883275, 32.438614],
						[115.882703, 32.456104],
						[115.864257, 32.458932],
						[115.872359, 32.469769],
						[115.881273, 32.472491],
						[115.883561, 32.489242],
						[115.874457, 32.497773],
						[115.87317, 32.504734],
						[115.853055, 32.504472],
						[115.845763, 32.501803],
						[115.847336, 32.509548],
						[115.856964, 32.517973],
						[115.873027, 32.525821],
						[115.87765, 32.54387],
						[115.899433, 32.556214],
						[115.910205, 32.566987],
						[115.928365, 32.567563],
						[115.915448, 32.576871],
						[115.891568, 32.576243],
						[115.887564, 32.567667],
						[115.861397, 32.537383],
						[115.845953, 32.531628],
						[115.839948, 32.524775],
						[115.841473, 32.501227],
						[115.823837, 32.502222],
						[115.804104, 32.485473],
						[115.788756, 32.468931],
						[115.780987, 32.46757],
						[115.78704, 32.485788],
						[115.771502, 32.505309],
						[115.766783, 32.492435],
						[115.757202, 32.480187],
						[115.74195, 32.476365],
						[115.701197, 32.495313],
						[115.692093, 32.487515],
						[115.692188, 32.480605],
						[115.701244, 32.470869],
						[115.696716, 32.467466],
						[115.675887, 32.466419],
						[115.681559, 32.451182],
						[115.680606, 32.439976],
						[115.674933, 32.431963],
						[115.66745, 32.40991],
						[115.656297, 32.408758],
						[115.657965, 32.427406],
						[115.654152, 32.428925],
						[115.645572, 32.417559],
						[115.627126, 32.405457],
						[115.604533, 32.42594],
						[115.586087, 32.419235],
						[115.563875, 32.402995],
						[115.553628, 32.407501],
						[115.569119, 32.414625],
						[115.567593, 32.421644],
						[115.547288, 32.424735],
						[115.537469, 32.438928],
						[115.523218, 32.442018],
						[115.524123, 32.447831],
						[115.515591, 32.450606],
						[115.509347, 32.466733],
						[115.510682, 32.467832],
						[115.510587, 32.468827],
						[115.508632, 32.468565],
						[115.496716, 32.493377],
						[115.490377, 32.496308],
						[115.486993, 32.510542],
						[115.477651, 32.511798],
						[115.47665, 32.520955],
						[115.465734, 32.520118],
						[115.438947, 32.53257],
						[115.443713, 32.543294],
						[115.434657, 32.545177],
						[115.431082, 32.552448],
						[115.408871, 32.54999],
						[115.412779, 32.559822],
						[115.411588, 32.574779],
						[115.403246, 32.576661],
						[115.38766, 32.570909],
						[115.328985, 32.561182],
						[115.324695, 32.555952],
						[115.305105, 32.55318],
						[115.297145, 32.560555],
						[115.300387, 32.568399],
						[115.310873, 32.570543],
						[115.29848, 32.573263],
						[115.305534, 32.583197],
						[115.299386, 32.588112],
						[115.294858, 32.581054],
						[115.289185, 32.58989],
						[115.267212, 32.578073],
						[115.254724, 32.584975],
						[115.261302, 32.591667],
						[115.254772, 32.595223],
						[115.241998, 32.592609],
						[115.229796, 32.579067],
						[115.223647, 32.581472],
						[115.22951, 32.59057],
						[115.21216, 32.588478],
						[115.201102, 32.591824],
						[115.192236, 32.602332],
						[115.209634, 32.611689],
						[115.199386, 32.619686],
						[115.201054, 32.633378],
						[115.194572, 32.631288],
						[115.194905, 32.642366],
						[115.202722, 32.645501],
						[115.209538, 32.636723],
						[115.208919, 32.64989],
						[115.219405, 32.65919],
						[115.204009, 32.653913],
						[115.205153, 32.672928],
						[115.193666, 32.682852],
						[115.189472, 32.678778],
						[115.196907, 32.672719],
						[115.182989, 32.666764],
						[115.18461, 32.678308],
						[115.178461, 32.682904],
						[115.182703, 32.694498],
						[115.179081, 32.701965],
						[115.184324, 32.720396],
						[115.179367, 32.726347],
						[115.189615, 32.770917],
						[115.183561, 32.776917],
						[115.182084, 32.787299],
						[115.191092, 32.790064],
						[115.209491, 32.785421],
						[115.206345, 32.79768],
						[115.196907, 32.802114],
						[115.189948, 32.812545],
						[115.195573, 32.828867],
						[115.1889, 32.840389],
						[115.202675, 32.843518],
						[115.198575, 32.854361],
						[115.19114, 32.857488],
						[115.176269, 32.856289],
						[115.159777, 32.862284],
						[115.154915, 32.877294],
						[115.141998, 32.885423],
						[115.14052, 32.897512],
						[115.116164, 32.900221],
						[115.098099, 32.894802],
						[115.08623, 32.903243],
						[115.067355, 32.903243],
						[115.029748, 32.906838],
						[115.02746, 32.914339],
						[115.036755, 32.916319],
						[115.03542, 32.932361],
						[115.023981, 32.933715],
						[115.009252, 32.940173],
						[114.978795, 32.941319],
						[114.959967, 32.939496],
						[114.951817, 32.934393],
						[114.942236, 32.937569],
						[114.93604, 32.95215],
						[114.924124, 32.958971],
						[114.914543, 32.971622],
						[114.893857, 32.972663],
						[114.883371, 32.983751],
						[114.884944, 32.992703],
						[114.901579, 33.000354],
						[114.891903, 33.020492],
						[114.915401, 33.016069],
						[114.924934, 33.016746],
						[114.936993, 33.025486],
						[114.92298, 33.036099],
						[114.922456, 33.048323],
						[114.914972, 33.059765],
						[114.919548, 33.068814],
						[114.914019, 33.082801],
						[114.897289, 33.086597],
						[114.898242, 33.096942],
						[114.906297, 33.11659],
						[114.902913, 33.129583],
						[114.910253, 33.136598],
						[114.92665, 33.13852],
						[114.933085, 33.144911],
						[114.932656, 33.154003],
						[114.958061, 33.150003],
						[114.966354, 33.146366],
						[114.968881, 33.133688],
						[114.981464, 33.129063],
						[114.992332, 33.120956],
						[114.990473, 33.102868],
						[115.012017, 33.09767],
						[115.023361, 33.090756],
						[115.041235, 33.086649],
						[115.051578, 33.092472],
						[115.057441, 33.083737],
						[115.069548, 33.086753],
						[115.111111, 33.082905],
						[115.153247, 33.084413],
						[115.167927, 33.088728],
						[115.172408, 33.108066],
						[115.197146, 33.121424],
						[115.209824, 33.113472],
						[115.224362, 33.126257],
						[115.236993, 33.126724],
						[115.246288, 33.13639],
						[115.266497, 33.1327],
						[115.269595, 33.137845],
						[115.290329, 33.132441],
						[115.292856, 33.143404],
						[115.301483, 33.141638],
						[115.300148, 33.16299],
						[115.294381, 33.177897],
						[115.296764, 33.201317],
						[115.326411, 33.211338],
						[115.316259, 33.218398],
						[115.316307, 33.223797],
						[115.33175, 33.235631],
						[115.329748, 33.250578],
						[115.340139, 33.261164],
						[115.340282, 33.286325],
						[115.333799, 33.284717],
						[115.335039, 33.2981],
						[115.347002, 33.301004],
						[115.360205, 33.2981],
						[115.358776, 33.311428],
						[115.36502, 33.336005],
						[115.348337, 33.33896],
						[115.346812, 33.358709],
						[115.338566, 33.363011],
						[115.341664, 33.371199],
						[115.316116, 33.370992],
						[115.313256, 33.377107],
						[115.329414, 33.401665],
						[115.317355, 33.418241],
						[115.315639, 33.431447],
						[115.319023, 33.441493],
						[115.316354, 33.448897],
						[115.323313, 33.448638],
						[115.324552, 33.457595],
						[115.335944, 33.447292],
						[115.345811, 33.449777],
						[115.348861, 33.478973],
						[115.343809, 33.480837],
						[115.351245, 33.490411],
						[115.345429, 33.502934],
						[115.366592, 33.523473],
						[115.395096, 33.506504],
						[115.396812, 33.502002],
						[115.405344, 33.516696],
						[115.401721, 33.524353],
						[115.414638, 33.541629],
						[115.421979, 33.556782],
						[115.463685, 33.567227],
						[115.474314, 33.55735],
						[115.501864, 33.564383],
						[115.511302, 33.553369],
						[115.528556, 33.562728],
						[115.552722, 33.56552],
						[115.559347, 33.561953],
						[115.565019, 33.576378],
						[115.601149, 33.578187],
						[115.639757, 33.585115]
					]
				],
				[
					[
						[118.868163, 31.520511],
						[118.885846, 31.518871],
						[118.883701, 31.500143],
						[118.856771, 31.506492],
						[118.868163, 31.520511]
					]
				],
				[
					[
						[116.698956, 29.7078],
						[116.705819, 29.697128],
						[116.706534, 29.696588],
						[116.705057, 29.688664],
						[116.680509, 29.681495],
						[116.673026, 29.687532],
						[116.656677, 29.686346],
						[116.654151, 29.694756],
						[116.668021, 29.700308],
						[116.673836, 29.709848],
						[116.698956, 29.7078]
					]
				],
				[
					[
						[115.508632, 32.468565],
						[115.510587, 32.468827],
						[115.510682, 32.467832],
						[115.509347, 32.466733],
						[115.508632, 32.468565]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": 330000,
			"name": "浙江省",
			"center": [120.153576, 30.287459],
			"centroid": [120.109921, 29.181449],
			"cp":[120.153576,29.287459],
			"childrenNum": 11,
			"level": "province",
			"acroutes": [100000],
			"parent": {
				"adcode": 100000
			}
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[118.344964, 29.475681],
						[118.358694, 29.477083],
						[118.379806, 29.502567],
						[118.383005, 29.510153],
						[118.393045, 29.507308],
						[118.414994, 29.509741],
						[118.430594, 29.503721],
						[118.44895, 29.51341],
						[118.459826, 29.505577],
						[118.470407, 29.507473],
						[118.495899, 29.519553],
						[118.497868, 29.543995],
						[118.494915, 29.553721],
						[118.499689, 29.573623],
						[118.515486, 29.583305],
						[118.53522, 29.590638],
						[118.549886, 29.613416],
						[118.555053, 29.613416],
						[118.573902, 29.638371],
						[118.602051, 29.643683],
						[118.620014, 29.654099],
						[118.633498, 29.648788],
						[118.640929, 29.641912],
						[118.647327, 29.643394],
						[118.673902, 29.669083],
						[118.682367, 29.681061],
						[118.682908, 29.688345],
						[118.691668, 29.693942],
						[118.700821, 29.706452],
						[118.718686, 29.709167],
						[118.72464, 29.722621],
						[118.744719, 29.738788],
						[118.74905, 29.761121],
						[118.744325, 29.779626],
						[118.736501, 29.788465],
						[118.739946, 29.813295],
						[118.745999, 29.818186],
						[118.75781, 29.816747],
						[118.76593, 29.823077],
						[118.750969, 29.831625],
						[118.755595, 29.845432],
						[118.766963, 29.848925],
						[118.778725, 29.841899],
						[118.802593, 29.860676],
						[118.807712, 29.86766],
						[118.841324, 29.891319],
						[118.845507, 29.899082],
						[118.844916, 29.915261],
						[118.838716, 29.934476],
						[118.848263, 29.941249],
						[118.863913, 29.93698],
						[118.871983, 29.946873],
						[118.88468, 29.93891],
						[118.894867, 29.939197],
						[118.891521, 29.959885],
						[118.899493, 29.98143],
						[118.892062, 29.994806],
						[118.895015, 30.000386],
						[118.89034, 30.012037],
						[118.898017, 30.017246],
						[118.902594, 30.029059],
						[118.890586, 30.04128],
						[118.897328, 30.049646],
						[118.888125, 30.062357],
						[118.878824, 30.064653],
						[118.875478, 30.072033],
						[118.872918, 30.094619],
						[118.868883, 30.101464],
						[118.871639, 30.113021],
						[118.887239, 30.117446],
						[118.888125, 30.127239],
						[118.89595, 30.138793],
						[118.896787, 30.148093],
						[118.877348, 30.147396],
						[118.865733, 30.151493],
						[118.856383, 30.148216],
						[118.845704, 30.156122],
						[118.85284, 30.166566],
						[118.864405, 30.168983],
						[118.910812, 30.187493],
						[118.920655, 30.198999],
						[118.929858, 30.20338],
						[118.924986, 30.213861],
						[118.903184, 30.217913],
						[118.892554, 30.243249],
						[118.882417, 30.247465],
						[118.8897, 30.254258],
						[118.878086, 30.282734],
						[118.881826, 30.298524],
						[118.879857, 30.314884],
						[118.899789, 30.322572],
						[118.908401, 30.330872],
						[118.917899, 30.332467],
						[118.936354, 30.34506],
						[118.936452, 30.350824],
						[118.955399, 30.359204],
						[118.959385, 30.347267],
						[118.969031, 30.351356],
						[118.975724, 30.347145],
						[118.988126, 30.348698],
						[118.988027, 30.333489],
						[119.004464, 30.328951],
						[119.028775, 30.312593],
						[119.048313, 30.312675],
						[119.050823, 30.306745],
						[119.062978, 30.304945],
						[119.073411, 30.315865],
						[119.090242, 30.324003],
						[119.11101, 30.311285],
						[119.12853, 30.3047],
						[119.151266, 30.304577],
						[119.156729, 30.299547],
						[119.188225, 30.291652],
						[119.201069, 30.291039],
						[119.205695, 30.301551],
						[119.222624, 30.299628],
						[119.225479, 30.288789],
						[119.233747, 30.293411],
						[119.245902, 30.321631],
						[119.239997, 30.327029],
						[119.247132, 30.340808],
						[119.265046, 30.338069],
						[119.278136, 30.341585],
						[119.289455, 30.349639],
						[119.300676, 30.363701],
						[119.326562, 30.371753],
						[119.342654, 30.363169],
						[119.349446, 30.349148],
						[119.375627, 30.354789],
						[119.386159, 30.363905],
						[119.399987, 30.367788],
						[119.403038, 30.373347],
						[119.393836, 30.383033],
						[119.371444, 30.383932],
						[119.366572, 30.388386],
						[119.368934, 30.399746],
						[119.360912, 30.410737],
						[119.349544, 30.408612],
						[119.352989, 30.424831],
						[119.349692, 30.438841],
						[119.336158, 30.44558],
						[119.334485, 30.478084],
						[119.330351, 30.488249],
						[119.336355, 30.507149],
						[119.328678, 30.521637],
						[119.326562, 30.532981],
						[119.313619, 30.531186],
						[119.28793, 30.512618],
						[119.272133, 30.510495],
						[119.26165, 30.51776],
						[119.261896, 30.525554],
						[119.242556, 30.530043],
						[119.236945, 30.546731],
						[119.245508, 30.561417],
						[119.264751, 30.57345],
						[119.264751, 30.582056],
						[119.254121, 30.588663],
						[119.253678, 30.596452],
						[119.240095, 30.604933],
						[119.245853, 30.618877],
						[119.255006, 30.615126],
						[119.278383, 30.617613],
						[119.291227, 30.616023],
						[119.311946, 30.621241],
						[119.323117, 30.630291],
						[119.333648, 30.652219],
						[119.343147, 30.6642],
						[119.354564, 30.66693],
						[119.372379, 30.680376],
						[119.379367, 30.679358],
						[119.391523, 30.685224],
						[119.395657, 30.678706],
						[119.400037, 30.658862],
						[119.412684, 30.642968],
						[119.433649, 30.644476],
						[119.448314, 30.655846],
						[119.45294, 30.671616],
						[119.465982, 30.683921],
						[119.482763, 30.704452],
						[119.480303, 30.738091],
						[119.484584, 30.744605],
						[119.478777, 30.753074],
						[119.479564, 30.771229],
						[119.491523, 30.777253],
						[119.507124, 30.769642],
						[119.524496, 30.776032],
						[119.554515, 30.825635],
						[119.561208, 30.829459],
						[119.575726, 30.829743],
						[119.573758, 30.853334],
						[119.558945, 30.871186],
						[119.559092, 30.891718],
						[119.556336, 30.896718],
						[119.563817, 30.919236],
						[119.580352, 30.929152],
						[119.582173, 30.947437],
						[119.579565, 30.962671],
						[119.585864, 30.976401],
						[119.607468, 30.991875],
						[119.616277, 31.002392],
						[119.624004, 31.005316],
						[119.634043, 31.019485],
						[119.631337, 31.046317],
						[119.634978, 31.064174],
						[119.629516, 31.082311],
						[119.634683, 31.093751],
						[119.649152, 31.105109],
						[119.624152, 31.11602],
						[119.623807, 31.130254],
						[119.638128, 31.135526],
						[119.641573, 31.148136],
						[119.662537, 31.159852],
						[119.663719, 31.165973],
						[119.678039, 31.168203],
						[119.682764, 31.160501],
						[119.703876, 31.151906],
						[119.713128, 31.167635],
						[119.740491, 31.173432],
						[119.755353, 31.170756],
						[119.779319, 31.178782],
						[119.793394, 31.168041],
						[119.791278, 31.156609],
						[119.800973, 31.156325],
						[119.809881, 31.148501],
						[119.823316, 31.154136],
						[119.829762, 31.161393],
						[119.823463, 31.165811],
						[119.826465, 31.173188],
						[119.837587, 31.173675],
						[119.842164, 31.16877],
						[119.866623, 31.168324],
						[119.878729, 31.160785],
						[119.900235, 31.169176],
						[119.920954, 31.170392],
						[119.921052, 31.16119],
						[119.936751, 31.146555],
						[119.946249, 31.106245],
						[119.969773, 31.074277],
						[119.988523, 31.059223],
						[120.001712, 31.027118],
						[120.017017, 31.017821],
						[120.05245, 31.005722],
						[120.09438, 30.973233],
						[120.111014, 30.955928],
						[120.135128, 30.941911],
						[120.149646, 30.937482],
						[120.221791, 30.926876],
						[120.250778, 30.926226],
						[120.308061, 30.932281],
						[120.343347, 30.939961],
						[120.371103, 30.948777],
						[120.35944, 30.931915],
						[120.362688, 30.921674],
						[120.35693, 30.908872],
						[120.360129, 30.892775],
						[120.358012, 30.887084],
						[120.364656, 30.880457],
						[120.372432, 30.882164],
						[120.37942, 30.890783],
						[120.394676, 30.890783],
						[120.423515, 30.90306],
						[120.418003, 30.925576],
						[120.423416, 30.927445],
						[120.434981, 30.920821],
						[120.442265, 30.90058],
						[120.434489, 30.887978],
						[120.439558, 30.885213],
						[120.452353, 30.867893],
						[120.44128, 30.856303],
						[120.454469, 30.849633],
						[120.460375, 30.839872],
						[120.461015, 30.828279],
						[120.455257, 30.816847],
						[120.477255, 30.800002],
						[120.477009, 30.785596],
						[120.489066, 30.763861],
						[120.50442, 30.757959],
						[120.517462, 30.772287],
						[120.56382, 30.83552],
						[120.580897, 30.845688],
						[120.588968, 30.854432],
						[120.602994, 30.848901],
						[120.616872, 30.849999],
						[120.625681, 30.855896],
						[120.644726, 30.854839],
						[120.655405, 30.847518],
						[120.658703, 30.86529],
						[120.663082, 30.861346],
						[120.673073, 30.874927],
						[120.682817, 30.88253],
						[120.699943, 30.867811],
						[120.704274, 30.872935],
						[120.702551, 30.884034],
						[120.713279, 30.885051],
						[120.709835, 30.907531],
						[120.712689, 30.919683],
						[120.709441, 30.933175],
						[120.697581, 30.950321],
						[120.684441, 30.955156],
						[120.69822, 30.970796],
						[120.705504, 30.966449],
						[120.710081, 30.971892],
						[120.725583, 30.971527],
						[120.736114, 30.963728],
						[120.745957, 30.962509],
						[120.758457, 30.974532],
						[120.769677, 30.977294],
						[120.769923, 30.996626],
						[120.802896, 31.005397],
						[120.820908, 31.006371],
						[120.840052, 30.997803],
						[120.847335, 30.9896],
						[120.853241, 30.992971],
						[120.865642, 30.989803],
						[120.868054, 30.995367],
						[120.891331, 31.003732],
						[120.895121, 31.017374],
						[120.910081, 31.016928],
						[120.918103, 31.012786],
						[120.940101, 31.010026],
						[120.936312, 31.017131],
						[120.949993, 31.017618],
						[120.949107, 31.029959],
						[120.95831, 31.028579],
						[120.963182, 31.016603],
						[120.989511, 31.01441],
						[121.000534, 30.973923],
						[120.99143, 30.968358],
						[121.000042, 30.934719],
						[120.99896, 30.909522],
						[121.002552, 30.904848],
						[120.99266, 30.90184],
						[120.993842, 30.889645],
						[121.008507, 30.888141],
						[121.021893, 30.875171],
						[121.014806, 30.871024],
						[121.016283, 30.86285],
						[121.003979, 30.846095],
						[120.997779, 30.844061],
						[120.989117, 30.832306],
						[120.994629, 30.821485],
						[121.010918, 30.834625],
						[121.030062, 30.828564],
						[121.037936, 30.813877],
						[121.039954, 30.827221],
						[121.06205, 30.837797],
						[121.060525, 30.8452],
						[121.080456, 30.848739],
						[121.09773, 30.857116],
						[121.104816, 30.849349],
						[121.114757, 30.851463],
						[121.123566, 30.847274],
						[121.120614, 30.836333],
						[121.134639, 30.833038],
						[121.137641, 30.826245],
						[121.128143, 30.809971],
						[121.126273, 30.788567],
						[121.117267, 30.785474],
						[121.122976, 30.779003],
						[121.140643, 30.776927],
						[121.1527, 30.778962],
						[121.174649, 30.772002],
						[121.191825, 30.77884],
						[121.200338, 30.773631],
						[121.200092, 30.783277],
						[121.218006, 30.784945],
						[121.226224, 30.775096],
						[121.232277, 30.755801],
						[121.256392, 30.743954],
						[121.269778, 30.73072],
						[121.272041, 30.723268],
						[121.265841, 30.709502],
						[121.270663, 30.70156],
						[121.27465, 30.677402],
						[121.257031, 30.673653],
						[121.244974, 30.654787],
						[121.231687, 30.644109],
						[121.221008, 30.63987],
						[121.188872, 30.633063],
						[121.172632, 30.625807],
						[121.15088, 30.611783],
						[121.149206, 30.60004],
						[121.11648, 30.585482],
						[121.085377, 30.575204],
						[121.058359, 30.564028],
						[121.071598, 30.542692],
						[121.093153, 30.515842],
						[121.119236, 30.48976],
						[121.183212, 30.434348],
						[121.225486, 30.404649],
						[121.278784, 30.405057],
						[121.328046, 30.397131],
						[121.371894, 30.370894],
						[121.395073, 30.338437],
						[121.452701, 30.298565],
						[121.476274, 30.279421],
						[121.49778, 30.258595],
						[121.527554, 30.224913],
						[121.561462, 30.184176],
						[121.591678, 30.143546],
						[121.61471, 30.108308],
						[121.619927, 30.088512],
						[121.626029, 30.07769],
						[121.63533, 30.069819],
						[121.653096, 30.071131],
						[121.667466, 30.048867],
						[121.69975, 30.008016],
						[121.724996, 29.992221],
						[121.771453, 29.99497],
						[121.784051, 29.993493],
						[121.814366, 29.974331],
						[121.835183, 29.957956],
						[121.859986, 29.944],
						[121.901817, 29.923678],
						[121.919534, 29.920804],
						[121.927113, 29.931151],
						[121.9529, 29.950732],
						[121.968008, 29.956519],
						[121.981739, 29.947037],
						[121.984396, 29.937637],
						[121.994534, 29.934599],
						[122.0029, 29.923186],
						[122.003442, 29.898999],
						[122.00979, 29.891114],
						[122.080115, 29.892634],
						[122.096257, 29.905036],
						[122.11673, 29.909964],
						[122.140155, 29.901751],
						[122.143058, 29.877724],
						[122.135922, 29.872261],
						[122.102212, 29.859649],
						[122.08479, 29.844528],
						[122.04857, 29.826036],
						[122.037595, 29.813747],
						[122.015991, 29.771936],
						[122.003146, 29.762273],
						[121.959199, 29.750017],
						[121.937595, 29.748536],
						[121.925538, 29.741256],
						[121.906443, 29.719247],
						[121.863234, 29.67925],
						[121.833559, 29.653111],
						[121.858953, 29.636601],
						[121.872486, 29.632483],
						[121.893845, 29.636559],
						[121.909593, 29.650105],
						[121.923422, 29.65167],
						[121.937595, 29.642571],
						[121.966089, 29.635859],
						[121.985381, 29.606291],
						[121.999751, 29.593686],
						[122.000292, 29.58244],
						[121.987201, 29.570616],
						[121.985774, 29.563776],
						[121.995076, 29.545108],
						[121.986414, 29.541193],
						[121.968993, 29.515595],
						[121.96668, 29.506566],
						[121.973127, 29.477991],
						[121.992074, 29.461411],
						[121.991729, 29.445942],
						[121.981493, 29.429934],
						[121.975538, 29.411159],
						[121.959642, 29.407156],
						[121.945814, 29.395311],
						[121.937693, 29.384125],
						[121.938579, 29.369512],
						[121.932231, 29.353451],
						[121.935971, 29.348124],
						[121.952064, 29.344119],
						[121.958363, 29.334373],
						[121.946552, 29.316695],
						[121.940892, 29.298271],
						[121.944829, 29.284182],
						[121.967566, 29.281414],
						[121.981099, 29.2841],
						[122.000243, 29.278811],
						[121.99852, 29.266124],
						[122.001965, 29.26009],
						[121.990991, 29.260793],
						[121.968304, 29.250006],
						[121.968008, 29.243888],
						[121.977457, 29.224087],
						[121.971896, 29.193364],
						[121.948619, 29.19324],
						[121.9373, 29.182859],
						[121.949111, 29.183314],
						[121.96043, 29.170575],
						[121.98666, 29.154855],
						[121.988284, 29.149269],
						[121.979278, 29.144842],
						[121.985381, 29.137601],
						[121.98853, 29.110992],
						[121.983363, 29.101224],
						[121.968747, 29.093028],
						[121.983314, 29.091454],
						[121.984396, 29.086942],
						[121.969829, 29.075888],
						[121.966138, 29.052866],
						[121.951621, 29.04744],
						[121.935085, 29.05183],
						[121.931591, 29.070713],
						[121.903835, 29.069056],
						[121.899406, 29.076426],
						[121.909642, 29.085866],
						[121.898077, 29.103956],
						[121.884494, 29.105446],
						[121.860036, 29.086404],
						[121.842368, 29.08835],
						[121.827014, 29.101845],
						[121.811167, 29.109916],
						[121.794238, 29.105197],
						[121.780557, 29.109626],
						[121.769386, 29.148277],
						[121.768008, 29.166686],
						[121.749947, 29.136691],
						[121.715596, 29.12498],
						[121.648814, 29.150924],
						[121.60846, 29.169127],
						[121.616531, 29.143518],
						[121.659936, 29.118359],
						[121.661511, 29.106108],
						[121.65536, 29.092738],
						[121.651915, 29.075888],
						[121.658952, 29.058497],
						[121.699454, 29.039985],
						[121.712643, 29.028926],
						[121.71535, 29.012274],
						[121.711265, 28.986005],
						[121.718352, 28.970422],
						[121.743352, 28.954257],
						[121.772043, 28.898365],
						[121.776423, 28.879783],
						[121.774602, 28.863895],
						[121.759051, 28.85597],
						[121.738677, 28.856592],
						[121.704228, 28.863646],
						[121.668352, 28.872939],
						[121.660084, 28.869661],
						[121.687348, 28.863355],
						[121.69222, 28.855265],
						[121.702899, 28.825262],
						[121.70472, 28.804633],
						[121.694582, 28.772872],
						[121.689415, 28.719167],
						[121.679129, 28.698891],
						[121.646305, 28.682809],
						[121.587397, 28.67221],
						[121.540842, 28.655583],
						[121.557082, 28.644982],
						[121.568844, 28.626563],
						[121.586216, 28.586553],
						[121.596157, 28.575238],
						[121.615054, 28.571743],
						[121.634247, 28.562715],
						[121.63907, 28.549108],
						[121.64222, 28.520808],
						[121.652653, 28.502616],
						[121.667811, 28.485713],
						[121.671108, 28.472596],
						[121.664513, 28.444858],
						[121.681935, 28.440318],
						[121.691826, 28.418446],
						[121.692761, 28.407321],
						[121.687151, 28.400904],
						[121.658903, 28.392403],
						[121.658854, 28.378441],
						[121.646403, 28.365102],
						[121.63656, 28.359558],
						[121.635871, 28.347468],
						[121.66033, 28.355639],
						[121.666433, 28.344091],
						[121.672633, 28.347801],
						[121.669336, 28.333375],
						[121.656935, 28.318613],
						[121.645665, 28.296674],
						[121.649011, 28.278319],
						[121.637053, 28.269767],
						[121.634297, 28.259461],
						[121.624208, 28.250489],
						[121.579523, 28.24185],
						[121.571944, 28.258709],
						[121.571452, 28.279404],
						[121.564365, 28.28804],
						[121.525979, 28.303598],
						[121.499306, 28.305934],
						[121.488774, 28.301429],
						[121.477652, 28.284327],
						[121.459739, 28.271853],
						[121.456048, 28.250322],
						[121.446402, 28.238595],
						[121.419581, 28.218018],
						[121.402357, 28.197311],
						[121.391333, 28.159102],
						[121.3778, 28.150289],
						[121.37214, 28.131282],
						[121.361215, 28.126144],
						[121.343154, 28.127397],
						[121.33774, 28.135961],
						[121.328144, 28.134165],
						[121.310083, 28.110726],
						[121.307425, 28.088494],
						[121.297829, 28.06446],
						[121.282278, 28.054636],
						[121.261165, 28.034442],
						[121.238675, 28.028838],
						[121.176175, 28.022315],
						[121.149797, 28.025284],
						[121.140988, 28.031389],
						[121.13587, 28.050581],
						[121.135279, 28.070522],
						[121.121106, 28.125266],
						[121.108409, 28.139011],
						[121.0902, 28.127146],
						[121.07086, 28.110517],
						[121.059098, 28.096351],
						[121.039413, 28.055849],
						[121.030948, 28.033647],
						[121.02455, 28.003745],
						[121.015249, 27.981617],
						[120.991824, 27.949734],
						[121.055899, 27.900133],
						[121.075584, 27.894439],
						[121.099452, 27.895067],
						[121.116726, 27.899798],
						[121.137395, 27.908841],
						[121.157917, 27.910306],
						[121.16274, 27.902519],
						[121.160378, 27.884641],
						[121.166775, 27.876895],
						[121.185181, 27.874801],
						[121.19586, 27.869817],
						[121.200535, 27.855159],
						[121.196647, 27.833964],
						[121.184344, 27.814105],
						[121.167169, 27.811675],
						[121.15772, 27.813895],
						[121.143842, 27.791728],
						[121.13149, 27.788836],
						[121.13144, 27.797595],
						[121.152504, 27.815362],
						[121.133015, 27.813183],
						[121.107671, 27.813686],
						[121.089856, 27.817541],
						[121.069875, 27.834215],
						[121.027798, 27.832623],
						[121.020072, 27.835891],
						[121.012149, 27.846237],
						[120.974255, 27.887196],
						[120.951469, 27.895905],
						[120.941774, 27.896784],
						[120.910869, 27.864708],
						[120.883703, 27.820934],
						[120.840642, 27.758741],
						[120.809638, 27.77555],
						[120.797729, 27.779574],
						[120.761114, 27.717692],
						[120.739658, 27.702175],
						[120.708949, 27.682585],
						[120.700681, 27.669412],
						[120.685376, 27.622999],
						[120.674992, 27.609105],
						[120.652059, 27.586854],
						[120.634884, 27.577281],
						[120.637049, 27.561449],
						[120.642807, 27.556577],
						[120.662295, 27.519612],
						[120.678191, 27.516419],
						[120.686311, 27.4923],
						[120.702797, 27.478726],
						[120.699648, 27.465654],
						[120.676813, 27.431055],
						[120.673614, 27.419954],
						[120.675041, 27.382312],
						[120.670071, 27.362834],
						[120.657079, 27.352316],
						[120.612246, 27.336915],
						[120.580307, 27.321385],
						[120.571645, 27.309978],
						[120.57573, 27.293645],
						[120.574057, 27.286699],
						[120.563427, 27.277941],
						[120.552944, 27.257771],
						[120.554765, 27.252044],
						[120.576173, 27.241135],
						[120.571497, 27.228204],
						[120.564116, 27.220243],
						[120.556143, 27.204065],
						[120.55324, 27.17343],
						[120.545956, 27.156824],
						[120.522285, 27.142154],
						[120.492462, 27.136168],
						[120.467757, 27.143166],
						[120.461655, 27.142576],
						[120.445267, 27.16087],
						[120.43759, 27.161039],
						[120.426172, 27.173472],
						[120.42568, 27.183333],
						[120.404371, 27.20398],
						[120.400926, 27.211564],
						[120.413918, 27.230942],
						[120.398515, 27.242483],
						[120.401763, 27.250864],
						[120.415395, 27.256381],
						[120.422383, 27.250822],
						[120.43006, 27.258866],
						[120.4088, 27.276636],
						[120.401369, 27.298571],
						[120.383406, 27.312714],
						[120.374794, 27.329255],
						[120.358357, 27.337546],
						[120.351467, 27.346761],
						[120.355257, 27.353873],
						[120.343249, 27.366242],
						[120.351566, 27.383574],
						[120.340739, 27.399642],
						[120.331733, 27.396025],
						[120.319823, 27.399684],
						[120.315985, 27.406708],
						[120.315148, 27.393165],
						[120.302697, 27.392197],
						[120.289508, 27.395941],
						[120.273366, 27.389421],
						[120.258209, 27.412679],
						[120.26377, 27.41802],
						[120.262441, 27.432905],
						[120.249006, 27.439885],
						[120.24689, 27.434587],
						[120.221595, 27.420291],
						[120.213228, 27.420291],
						[120.202402, 27.428364],
						[120.176909, 27.419954],
						[120.163376, 27.424874],
						[120.141821, 27.422183],
						[120.131437, 27.416716],
						[120.137195, 27.402334],
						[120.128878, 27.391608],
						[120.121594, 27.397413],
						[120.107175, 27.395562],
						[120.09625, 27.390347],
						[120.09684, 27.37962],
						[120.077007, 27.369187],
						[120.052303, 27.338682],
						[120.027549, 27.342259],
						[120.026614, 27.350801],
						[120.015984, 27.36477],
						[120.009586, 27.363928],
						[120.005206, 27.376675],
						[119.994232, 27.379199],
						[119.988326, 27.371375],
						[119.960275, 27.366116],
						[119.964015, 27.360478],
						[119.960176, 27.351853],
						[119.937932, 27.3346],
						[119.944035, 27.314146],
						[119.933503, 27.316545],
						[119.903286, 27.317597],
						[119.899054, 27.311494],
						[119.887637, 27.313304],
						[119.865589, 27.306232],
						[119.871298, 27.315408],
						[119.856731, 27.314819],
						[119.8462, 27.324037],
						[119.835077, 27.312967],
						[119.844822, 27.306653],
						[119.840146, 27.298908],
						[119.822331, 27.301433],
						[119.819526, 27.296045],
						[119.795756, 27.310441],
						[119.790491, 27.302612],
						[119.77056, 27.305685],
						[119.769772, 27.324373],
						[119.777991, 27.320164],
						[119.784979, 27.323574],
						[119.781485, 27.330476],
						[119.768394, 27.335736],
						[119.769132, 27.345415],
						[119.751022, 27.350086],
						[119.74743, 27.359973],
						[119.740491, 27.362203],
						[119.750481, 27.373226],
						[119.740294, 27.375708],
						[119.739555, 27.386813],
						[119.733847, 27.388706],
						[119.724349, 27.401703],
						[119.71303, 27.402838],
						[119.704319, 27.416927],
						[119.704713, 27.424706],
						[119.689506, 27.430845],
						[119.685471, 27.438413],
						[119.693886, 27.438665],
						[119.703433, 27.447284],
						[119.704024, 27.458508],
						[119.709929, 27.46246],
						[119.706681, 27.470656],
						[119.710717, 27.482508],
						[119.709634, 27.496797],
						[119.702892, 27.500285],
						[119.708551, 27.514276],
						[119.689506, 27.534064],
						[119.690589, 27.537256],
						[119.670559, 27.536584],
						[119.659339, 27.539693],
						[119.668837, 27.556493],
						[119.672036, 27.556409],
						[119.675038, 27.574383],
						[119.645461, 27.578205],
						[119.630894, 27.582698],
						[119.626465, 27.620481],
						[119.64113, 27.625392],
						[119.647528, 27.640543],
						[119.639654, 27.652671],
						[119.644033, 27.663496],
						[119.635569, 27.668405],
						[119.606238, 27.67474],
						[119.595018, 27.666895],
						[119.583945, 27.665175],
						[119.578925, 27.669832],
						[119.566523, 27.663748],
						[119.550135, 27.663832],
						[119.549299, 27.670167],
						[119.539161, 27.67537],
						[119.541917, 27.663916],
						[119.537094, 27.658923],
						[119.525923, 27.660307],
						[119.52046, 27.650069],
						[119.511503, 27.653468],
						[119.501169, 27.649901],
						[119.49797, 27.625896],
						[119.500923, 27.608224],
						[119.488718, 27.59882],
						[119.481877, 27.585679],
						[119.48483, 27.570394],
						[119.477497, 27.553847],
						[119.474643, 27.539314],
						[119.466523, 27.52646],
						[119.45171, 27.51352],
						[119.438472, 27.508772],
						[119.432861, 27.513016],
						[119.422674, 27.536584],
						[119.41667, 27.539651],
						[119.394968, 27.539272],
						[119.376808, 27.534988],
						[119.360027, 27.524402],
						[119.341867, 27.506797],
						[119.347674, 27.492763],
						[119.334682, 27.480029],
						[119.285026, 27.457626],
						[119.276463, 27.435512],
						[119.267851, 27.421468],
						[119.251069, 27.420753],
						[119.24728, 27.4295],
						[119.243441, 27.419828],
						[119.222674, 27.417053],
						[119.209485, 27.422099],
						[119.19477, 27.418735],
						[119.180252, 27.428238],
						[119.16849, 27.424874],
						[119.153973, 27.428532],
						[119.147526, 27.424832],
						[119.138766, 27.434419],
						[119.12853, 27.43177],
						[119.121394, 27.438329],
						[119.125921, 27.452203],
						[119.118884, 27.461451],
						[119.131286, 27.46309],
						[119.130744, 27.4728],
						[119.115095, 27.482845],
						[119.088126, 27.464099],
						[119.072525, 27.472253],
						[119.066423, 27.466957],
						[119.055301, 27.477591],
						[119.037191, 27.480617],
						[119.020803, 27.497931],
						[118.998903, 27.496335],
						[118.990734, 27.503352],
						[118.982761, 27.49604],
						[118.990439, 27.48856],
						[118.988322, 27.477255],
						[118.966029, 27.473346],
						[118.955448, 27.449849],
						[118.949198, 27.456364],
						[118.933352, 27.463595],
						[118.910763, 27.460862],
						[118.901462, 27.464688],
						[118.897722, 27.478978],
						[118.889454, 27.481332],
						[118.89034, 27.494107],
						[118.886501, 27.501251],
						[118.879907, 27.49957],
						[118.873607, 27.517764],
						[118.857859, 27.516671],
						[118.859631, 27.527594],
						[118.869178, 27.539903],
						[118.889011, 27.547505],
						[118.896048, 27.563129],
						[118.910222, 27.570352],
						[118.90407, 27.575979],
						[118.902741, 27.592313],
						[118.913913, 27.619138],
						[118.902643, 27.623671],
						[118.903726, 27.638864],
						[118.89531, 27.655566],
						[118.879907, 27.667944],
						[118.874641, 27.682795],
						[118.880546, 27.689297],
						[118.875035, 27.700958],
						[118.878479, 27.70532],
						[118.900084, 27.704985],
						[118.897968, 27.718909],
						[118.890438, 27.718741],
						[118.880645, 27.731153],
						[118.87218, 27.734424],
						[118.853972, 27.774251],
						[118.839995, 27.779322],
						[118.839405, 27.788585],
						[118.851462, 27.796003],
						[118.847131, 27.812513],
						[118.838814, 27.820641],
						[118.835418, 27.838195],
						[118.826314, 27.846614],
						[118.835763, 27.866509],
						[118.82656, 27.874843],
						[118.831531, 27.886316],
						[118.820408, 27.89536],
						[118.81844, 27.916711],
						[118.803725, 27.918302],
						[118.804562, 27.927092],
						[118.767111, 27.941824],
						[118.754168, 27.942745],
						[118.753479, 27.948018],
						[118.729906, 27.97258],
						[118.732514, 27.990904],
						[118.72656, 28.000399],
						[118.726609, 28.014201],
						[118.733499, 28.026455],
						[118.732662, 28.035947],
						[118.720359, 28.045438],
						[118.718784, 28.063624],
						[118.73532, 28.074994],
						[118.743144, 28.088536],
						[118.763518, 28.094721],
						[118.765142, 28.102912],
						[118.773607, 28.107968],
						[118.785369, 28.106715],
						[118.802298, 28.117286],
						[118.800428, 28.13312],
						[118.805891, 28.153088],
						[118.798115, 28.168917],
						[118.782908, 28.172633],
						[118.775182, 28.167998],
						[118.760959, 28.167413],
						[118.769276, 28.185746],
						[118.782121, 28.193178],
						[118.794769, 28.205953],
						[118.804168, 28.207874],
						[118.812387, 28.225573],
						[118.802052, 28.240431],
						[118.781186, 28.243102],
						[118.754513, 28.253452],
						[118.740881, 28.267514],
						[118.739355, 28.27736],
						[118.727298, 28.281115],
						[118.730152, 28.2968],
						[118.722327, 28.31048],
						[118.713518, 28.312899],
						[118.700182, 28.310397],
						[118.689896, 28.291001],
						[118.674788, 28.271435],
						[118.666668, 28.269725],
						[118.651363, 28.27711],
						[118.64024, 28.27348],
						[118.632465, 28.261297],
						[118.623016, 28.256623],
						[118.595703, 28.256999],
						[118.598016, 28.270643],
						[118.584482, 28.284327],
						[118.568833, 28.285245],
						[118.558596, 28.282324],
						[118.547474, 28.28658],
						[118.546244, 28.275024],
						[118.530201, 28.270434],
						[118.514157, 28.269641],
						[118.505643, 28.279905],
						[118.495604, 28.273104],
						[118.492947, 28.262715],
						[118.502691, 28.246817],
						[118.490683, 28.238428],
						[118.481037, 28.245982],
						[118.463862, 28.243061],
						[118.445161, 28.254745],
						[118.448852, 28.261505],
						[118.438616, 28.261255],
						[118.430446, 28.280781],
						[118.433202, 28.28829],
						[118.459679, 28.30168],
						[118.47085, 28.316694],
						[118.481923, 28.32099],
						[118.48709, 28.328996],
						[118.469423, 28.328204],
						[118.473901, 28.339046],
						[118.469275, 28.355848],
						[118.455151, 28.383984],
						[118.431135, 28.398362],
						[118.44024, 28.411946],
						[118.456529, 28.415988],
						[118.450131, 28.418154],
						[118.459334, 28.42982],
						[118.465929, 28.448232],
						[118.463321, 28.455854],
						[118.482169, 28.47118],
						[118.472179, 28.479384],
						[118.461647, 28.482631],
						[118.454315, 28.476385],
						[118.438124, 28.492999],
						[118.421785, 28.492125],
						[118.415043, 28.497412],
						[118.421933, 28.502991],
						[118.430791, 28.500785],
						[118.445555, 28.513273],
						[118.437287, 28.521682],
						[118.433251, 28.516479],
						[118.425328, 28.525261],
						[118.428133, 28.534668],
						[118.420702, 28.544739],
						[118.428084, 28.54736],
						[118.41337, 28.555142],
						[118.409433, 28.569247],
						[118.417307, 28.572825],
						[118.415683, 28.583475],
						[118.421588, 28.596287],
						[118.414059, 28.595372],
						[118.417749, 28.607558],
						[118.425279, 28.611426],
						[118.433399, 28.627062],
						[118.427789, 28.63147],
						[118.422129, 28.646812],
						[118.432612, 28.651551],
						[118.432858, 28.676533],
						[118.414994, 28.686591],
						[118.418832, 28.692242],
						[118.402247, 28.703005],
						[118.39147, 28.700512],
						[118.392503, 28.710442],
						[118.401903, 28.714473],
						[118.399738, 28.727559],
						[118.392356, 28.738858],
						[118.396293, 28.754932],
						[118.386942, 28.754807],
						[118.383694, 28.774201],
						[118.378724, 28.784622],
						[118.38335, 28.787363],
						[118.371932, 28.801769],
						[118.368192, 28.811275],
						[118.331873, 28.814803],
						[118.320554, 28.821236],
						[118.310564, 28.821983],
						[118.295308, 28.835222],
						[118.304314, 28.840078],
						[118.297424, 28.847837],
						[118.293881, 28.860866],
						[118.287926, 28.864517],
						[118.28143, 28.891356],
						[118.276115, 28.89596],
						[118.269865, 28.918644],
						[118.256824, 28.92362],
						[118.237631, 28.91852],
						[118.224983, 28.911843],
						[118.199392, 28.902969],
						[118.193487, 28.908277],
						[118.196686, 28.915949],
						[118.206036, 28.919598],
						[118.227837, 28.942443],
						[118.223802, 28.947832],
						[118.199392, 28.954672],
						[118.195997, 28.965034],
						[118.186597, 28.97697],
						[118.16514, 28.986709],
						[118.147178, 28.984803],
						[118.147867, 28.977799],
						[118.133743, 28.983891],
						[118.125918, 28.994499],
						[118.132463, 29.008379],
						[118.127296, 29.016085],
						[118.113713, 29.009208],
						[118.110022, 28.991723],
						[118.099933, 28.990397],
						[118.110662, 29.003739],
						[118.10702, 29.011984],
						[118.097079, 28.998726],
						[118.090681, 29.010451],
						[118.088073, 29.029424],
						[118.072177, 29.038991],
						[118.066961, 29.053942],
						[118.076902, 29.062845],
						[118.07577, 29.074563],
						[118.045898, 29.088846],
						[118.037974, 29.101886],
						[118.053083, 29.116248],
						[118.03891, 29.126346],
						[118.045012, 29.149104],
						[118.04137, 29.160853],
						[118.028378, 29.169251],
						[118.033447, 29.177151],
						[118.042453, 29.210319],
						[118.05141, 29.217596],
						[118.057906, 29.214784],
						[118.07326, 29.217017],
						[118.081971, 29.234587],
						[118.075573, 29.24736],
						[118.080445, 29.266331],
						[118.077886, 29.278769],
						[118.071931, 29.287033],
						[118.078132, 29.290587],
						[118.105101, 29.284926],
						[118.115878, 29.293685],
						[118.136105, 29.283893],
						[118.152886, 29.28629],
						[118.169373, 29.29761],
						[118.176607, 29.297404],
						[118.176066, 29.305914],
						[118.166567, 29.313886],
						[118.179756, 29.321404],
						[118.1833, 29.332225],
						[118.207808, 29.347587],
						[118.208694, 29.360346],
						[118.204018, 29.36786],
						[118.208792, 29.377521],
						[118.194323, 29.388253],
						[118.193044, 29.39527],
						[118.204264, 29.395394],
						[118.218093, 29.420361],
						[118.232955, 29.42391],
						[118.248507, 29.431337],
						[118.255692, 29.42618],
						[118.267798, 29.427871],
						[118.277641, 29.423374],
						[118.286154, 29.426716],
						[118.291371, 29.41999],
						[118.316125, 29.42259],
						[118.315977, 29.450562],
						[118.306627, 29.479434],
						[118.310564, 29.496011],
						[118.324442, 29.496918],
						[118.344964, 29.475681]
					]
				],
				[
					[
						[122.256887, 30.065104],
						[122.269929, 30.062439],
						[122.291632, 30.065145],
						[122.31176, 30.038656],
						[122.32677, 30.031848],
						[122.334102, 30.021266],
						[122.343896, 30.020446],
						[122.346898, 30.011544],
						[122.340303, 30.006539],
						[122.344289, 29.995257],
						[122.341287, 29.976834],
						[122.331986, 29.962183],
						[122.324112, 29.941291],
						[122.308955, 29.943466],
						[122.279033, 29.937514],
						[122.239958, 29.962593],
						[122.192616, 29.978886],
						[122.168944, 29.989103],
						[122.139958, 29.987092],
						[122.120863, 29.98381],
						[122.108806, 30.00494],
						[122.092468, 30.006786],
						[122.073422, 30.005145],
						[122.038875, 29.989595],
						[122.026424, 29.992426],
						[122.012005, 30.021184],
						[121.99857, 30.037548],
						[121.981247, 30.048826],
						[121.978196, 30.059282],
						[121.992221, 30.074656],
						[121.983461, 30.100316],
						[121.948471, 30.147888],
						[121.935085, 30.16161],
						[121.936414, 30.167795],
						[121.949997, 30.176068],
						[121.955164, 30.184012],
						[121.977211, 30.174471],
						[121.996306, 30.161405],
						[122.036808, 30.148912],
						[122.048767, 30.147233],
						[122.072684, 30.154114],
						[122.095716, 30.158088],
						[122.110922, 30.154811],
						[122.119978, 30.14924],
						[122.121454, 30.141088],
						[122.133019, 30.136622],
						[122.144879, 30.118798],
						[122.156641, 30.112611],
						[122.169486, 30.117118],
						[122.182429, 30.117036],
						[122.191631, 30.108677],
						[122.240746, 30.108103],
						[122.258315, 30.098595],
						[122.279525, 30.102857],
						[122.293896, 30.100316],
						[122.304083, 30.086544],
						[122.290943, 30.074451],
						[122.281642, 30.077403],
						[122.265943, 30.076214],
						[122.256543, 30.071828],
						[122.256887, 30.065104]
					]
				],
				[
					[
						[122.625097, 30.817539],
						[122.615845, 30.82474],
						[122.622243, 30.826001],
						[122.636269, 30.819939],
						[122.637745, 30.814447],
						[122.625097, 30.817539]
					]
				],
				[
					[
						[122.150932, 30.190073],
						[122.166484, 30.198385],
						[122.176621, 30.199982],
						[122.178196, 30.191752],
						[122.196356, 30.193635],
						[122.218206, 30.188885],
						[122.204181, 30.18176],
						[122.208118, 30.175167],
						[122.197586, 30.175904],
						[122.184495, 30.163453],
						[122.190696, 30.161078],
						[122.176474, 30.155138],
						[122.170125, 30.139121],
						[122.162891, 30.137933],
						[122.150686, 30.146659],
						[122.1436, 30.166935],
						[122.150932, 30.190073]
					]
				],
				[
					[
						[122.207773, 29.70316],
						[122.208216, 29.715627],
						[122.217813, 29.711759],
						[122.226179, 29.714105],
						[122.232773, 29.706122],
						[122.229624, 29.701637],
						[122.262301, 29.688057],
						[122.281642, 29.688633],
						[122.277606, 29.677933],
						[122.270864, 29.685135],
						[122.250391, 29.688139],
						[122.24611, 29.67999],
						[122.229082, 29.693489],
						[122.207773, 29.70316]
					]
				],
				[
					[
						[122.427607, 30.738538],
						[122.432183, 30.742325],
						[122.450441, 30.743017],
						[122.460432, 30.730272],
						[122.467075, 30.730272],
						[122.473621, 30.715204],
						[122.486514, 30.711132],
						[122.504871, 30.713249],
						[122.50615, 30.720051],
						[122.528345, 30.724897],
						[122.536268, 30.717567],
						[122.526672, 30.713983],
						[122.539664, 30.703678],
						[122.535186, 30.698301],
						[122.513778, 30.702049],
						[122.510136, 30.69492],
						[122.499605, 30.70323],
						[122.490501, 30.695775],
						[122.487154, 30.701193],
						[122.4499, 30.691457],
						[122.444241, 30.697079],
						[122.437055, 30.691743],
						[122.427607, 30.69602],
						[122.430264, 30.706529],
						[122.442518, 30.716345],
						[122.441681, 30.733082],
						[122.427607, 30.738538]
					]
				],
				[
					[
						[122.163088, 30.329809],
						[122.173816, 30.337578],
						[122.178147, 30.350579],
						[122.18174, 30.340971],
						[122.191877, 30.337414],
						[122.191287, 30.329155],
						[122.209003, 30.32985],
						[122.213383, 30.33443],
						[122.228344, 30.329564],
						[122.221602, 30.324657],
						[122.231887, 30.305968],
						[122.248177, 30.304496],
						[122.239466, 30.296479],
						[122.224456, 30.290425],
						[122.231395, 30.277989],
						[122.237202, 30.277007],
						[122.229427, 30.260436],
						[122.230116, 30.23269],
						[122.208856, 30.229129],
						[122.208413, 30.235514],
						[122.199604, 30.234327],
						[122.194141, 30.24374],
						[122.146356, 30.246237],
						[122.134446, 30.251884],
						[122.101031, 30.275084],
						[122.057822, 30.291775],
						[122.051867, 30.300078],
						[122.058511, 30.304618],
						[122.06791, 30.301714],
						[122.092812, 30.299996],
						[122.124357, 30.319995],
						[122.133019, 30.314515],
						[122.137743, 30.32159],
						[122.144043, 30.315538],
						[122.163088, 30.329809]
					]
				],
				[
					[
						[122.317468, 30.249593],
						[122.318699, 30.26551],
						[122.322685, 30.26997],
						[122.349457, 30.267392],
						[122.358807, 30.271238],
						[122.385727, 30.270993],
						[122.400343, 30.275657],
						[122.407233, 30.27267],
						[122.409595, 30.25704],
						[122.429477, 30.250861],
						[122.418798, 30.246278],
						[122.417174, 30.23887],
						[122.407725, 30.236005],
						[122.408217, 30.227778],
						[122.397193, 30.225241],
						[122.391534, 30.239893],
						[122.381986, 30.238134],
						[122.380707, 30.253889],
						[122.363236, 30.254871],
						[122.362055, 30.239566],
						[122.34862, 30.233222],
						[122.336809, 30.23576],
						[122.32923, 30.230193],
						[122.318403, 30.236455],
						[122.309004, 30.23531],
						[122.305559, 30.228883],
						[122.298472, 30.234082],
						[122.29173, 30.226509],
						[122.284545, 30.226837],
						[122.275982, 30.23535],
						[122.278, 30.243004],
						[122.317468, 30.249593]
					]
				],
				[
					[
						[122.026375, 29.178351],
						[122.040843, 29.17955],
						[122.029771, 29.187367],
						[122.037005, 29.190552],
						[122.031247, 29.196342],
						[122.036217, 29.207383],
						[122.056198, 29.200518],
						[122.050095, 29.193488],
						[122.057576, 29.188939],
						[122.044534, 29.1841],
						[122.049013, 29.175083],
						[122.063235, 29.174008],
						[122.074505, 29.178144],
						[122.06791, 29.165611],
						[122.056739, 29.158454],
						[122.039859, 29.163253],
						[122.037645, 29.151959],
						[122.027605, 29.155806],
						[122.013383, 29.151504],
						[122.026375, 29.178351]
					]
				],
				[
					[
						[122.675245, 30.848779],
						[122.679133, 30.861102],
						[122.690108, 30.849105],
						[122.698523, 30.848128],
						[122.695472, 30.839018],
						[122.687991, 30.838082],
						[122.669192, 30.845566],
						[122.675245, 30.848779]
					]
				],
				[
					[
						[121.84911, 28.733666],
						[121.855557, 28.736075],
						[121.846994, 28.741433],
						[121.851177, 28.748868],
						[121.875833, 28.749034],
						[121.893008, 28.762532],
						[121.909544, 28.761867],
						[121.896109, 28.757341],
						[121.893008, 28.752108],
						[121.880508, 28.748702],
						[121.866089, 28.738027],
						[121.873077, 28.727518],
						[121.865547, 28.721992],
						[121.859642, 28.727891],
						[121.846797, 28.729055],
						[121.84911, 28.733666]
					]
				],
				[
					[
						[122.782824, 30.789748],
						[122.782135, 30.7823],
						[122.775689, 30.788038],
						[122.782824, 30.789748]
					]
				],
				[
					[
						[121.749651, 28.69058],
						[121.761856, 28.689333],
						[121.765252, 28.705124],
						[121.780508, 28.699182],
						[121.772732, 28.694195],
						[121.790006, 28.690913],
						[121.801571, 28.702423],
						[121.808559, 28.699431],
						[121.800045, 28.695317],
						[121.794041, 28.679608],
						[121.781689, 28.680066],
						[121.778687, 28.687629],
						[121.768254, 28.690746],
						[121.75226, 28.683349],
						[121.749651, 28.69058]
					]
				],
				[
					[
						[122.331002, 29.938089],
						[122.351868, 29.959105],
						[122.356691, 29.950321],
						[122.372734, 29.954139],
						[122.377164, 29.949008],
						[122.397882, 29.939648],
						[122.401573, 29.945806],
						[122.410235, 29.94478],
						[122.408955, 29.951429],
						[122.424309, 29.945765],
						[122.420618, 29.937309],
						[122.430215, 29.916904],
						[122.410923, 29.91793],
						[122.41363, 29.912551],
						[122.43489, 29.906227],
						[122.432085, 29.893989],
						[122.434053, 29.883557],
						[122.418601, 29.881462],
						[122.41929, 29.873082],
						[122.401819, 29.870042],
						[122.398079, 29.853609],
						[122.413236, 29.84835],
						[122.416189, 29.828995],
						[122.386366, 29.834009],
						[122.378345, 29.84309],
						[122.369978, 29.862031],
						[122.376819, 29.871151],
						[122.376327, 29.88676],
						[122.372341, 29.893209],
						[122.362744, 29.8944],
						[122.341337, 29.908198],
						[122.327213, 29.923103],
						[122.331002, 29.938089]
					]
				],
				[
					[
						[122.430412, 30.408653],
						[122.41112, 30.411268],
						[122.404821, 30.4176],
						[122.387695, 30.417477],
						[122.378295, 30.413556],
						[122.375441, 30.419357],
						[122.365156, 30.417151],
						[122.352409, 30.421971],
						[122.348079, 30.410696],
						[122.318305, 30.407182],
						[122.285923, 30.417028],
						[122.280411, 30.420337],
						[122.279378, 30.444477],
						[122.281838, 30.460118],
						[122.278689, 30.474369],
						[122.287596, 30.47739],
						[122.303984, 30.46657],
						[122.314959, 30.470245],
						[122.337006, 30.465794],
						[122.35615, 30.464651],
						[122.372734, 30.47886],
						[122.383414, 30.472858],
						[122.373817, 30.46167],
						[122.381445, 30.455953],
						[122.402459, 30.458281],
						[122.411268, 30.452686],
						[122.432282, 30.445376],
						[122.428542, 30.430549],
						[122.432725, 30.420092],
						[122.440796, 30.413556],
						[122.430412, 30.408653]
					]
				],
				[
					[
						[122.231297, 28.859829],
						[122.243797, 28.861322],
						[122.238679, 28.853315],
						[122.231297, 28.859829]
					]
				],
				[
					[
						[122.181936, 29.407693],
						[122.179771, 29.424694],
						[122.187497, 29.421806],
						[122.197242, 29.425478],
						[122.199358, 29.436247],
						[122.21112, 29.44095],
						[122.22485, 29.438392],
						[122.223866, 29.428366],
						[122.207921, 29.429645],
						[122.205362, 29.418092],
						[122.190204, 29.415905],
						[122.181936, 29.407693]
					]
				],
				[
					[
						[121.919928, 28.707285],
						[121.916581, 28.717215],
						[121.942664, 28.720663],
						[121.920617, 28.704916],
						[121.919928, 28.707285]
					]
				],
				[
					[
						[121.387347, 28.119292],
						[121.401323, 28.129862],
						[121.401569, 28.122968],
						[121.387347, 28.119292]
					]
				],
				[
					[
						[121.837349, 28.770505],
						[121.850538, 28.784747],
						[121.844386, 28.788816],
						[121.852949, 28.793092],
						[121.857034, 28.803637],
						[121.850734, 28.808286],
						[121.861561, 28.813765],
						[121.872388, 28.807871],
						[121.865498, 28.799361],
						[121.862693, 28.78209],
						[121.843254, 28.770629],
						[121.837349, 28.770505]
					]
				],
				[
					[
						[122.327163, 30.519474],
						[122.340008, 30.522371],
						[122.34611, 30.528044],
						[122.343699, 30.504006],
						[122.31924, 30.512781],
						[122.317518, 30.518046],
						[122.327163, 30.519474]
					]
				],
				[
					[
						[122.450737, 30.426097],
						[122.459693, 30.426424],
						[122.46427, 30.436799],
						[122.476081, 30.436023],
						[122.474211, 30.429528],
						[122.485727, 30.415762],
						[122.469634, 30.414413],
						[122.450737, 30.426097]
					]
				],
				[
					[
						[121.687397, 28.384526],
						[121.69532, 28.381317],
						[121.686118, 28.374648],
						[121.687397, 28.384526]
					]
				],
				[
					[
						[122.477361, 30.229784],
						[122.489516, 30.231298],
						[122.503493, 30.22565],
						[122.503197, 30.215907],
						[122.481445, 30.221147],
						[122.477361, 30.229784]
					]
				],
				[
					[
						[122.264762, 29.845391],
						[122.282527, 29.845515],
						[122.302065, 29.838488],
						[122.302951, 29.83368],
						[122.319289, 29.829447],
						[122.323768, 29.821844],
						[122.318354, 29.817857],
						[122.297882, 29.81798],
						[122.297045, 29.811486],
						[122.31614, 29.806389],
						[122.309447, 29.794098],
						[122.328443, 29.777693],
						[122.317222, 29.774198],
						[122.310136, 29.766796],
						[122.296799, 29.778968],
						[122.28484, 29.779667],
						[122.267862, 29.792782],
						[122.248571, 29.804334],
						[122.24109, 29.820323],
						[122.23046, 29.822707],
						[122.221257, 29.835817],
						[122.234446, 29.846542],
						[122.248374, 29.848761],
						[122.264762, 29.845391]
					]
				],
				[
					[
						[122.302951, 30.499108],
						[122.321848, 30.49425],
						[122.31427, 30.491066],
						[122.302951, 30.499108]
					]
				],
				[
					[
						[122.217222, 29.638577],
						[122.231002, 29.634748],
						[122.21983, 29.629971],
						[122.217222, 29.638577]
					]
				],
				[
					[
						[120.971745, 27.649859],
						[120.967759, 27.658042],
						[120.97957, 27.670419],
						[120.988281, 27.662783],
						[120.986509, 27.655104],
						[120.974747, 27.645033],
						[120.971745, 27.649859]
					]
				],
				[
					[
						[122.703247, 30.19732],
						[122.704724, 30.207065],
						[122.711564, 30.209357],
						[122.70807, 30.188476],
						[122.703247, 30.19732]
					]
				],
				[
					[
						[122.426918, 30.032094],
						[122.428197, 30.038656],
						[122.433463, 30.022004],
						[122.426918, 30.032094]
					]
				],
				[
					[
						[121.199945, 27.62493],
						[121.213577, 27.633324],
						[121.220811, 27.630303],
						[121.209, 27.61855],
						[121.198321, 27.614646],
						[121.191677, 27.62195],
						[121.199945, 27.62493]
					]
				],
				[
					[
						[122.470766, 30.730069],
						[122.46678, 30.742936],
						[122.452115, 30.743343],
						[122.452607, 30.757592],
						[122.470077, 30.752585],
						[122.46801, 30.744035],
						[122.470766, 30.730069]
					]
				],
				[
					[
						[122.189564, 29.810007],
						[122.183708, 29.815186],
						[122.190598, 29.820652],
						[122.201179, 29.815227],
						[122.195618, 29.804704],
						[122.189564, 29.810007]
					]
				],
				[
					[
						[121.790892, 29.082264],
						[121.788677, 29.094601],
						[121.793795, 29.099444],
						[121.820272, 29.099402],
						[121.831591, 29.095015],
						[121.840941, 29.081519],
						[121.838628, 29.057752],
						[121.832329, 29.050381],
						[121.82352, 29.051043],
						[121.817319, 29.063052],
						[121.808559, 29.059243],
						[121.791089, 29.074232],
						[121.790892, 29.082264]
					]
				],
				[
					[
						[122.184299, 29.460627],
						[122.19483, 29.465453],
						[122.194141, 29.45345],
						[122.183216, 29.455595],
						[122.184299, 29.460627]
					]
				],
				[
					[
						[122.026473, 29.621859],
						[122.033855, 29.624741],
						[122.037645, 29.613457],
						[122.025686, 29.604314],
						[122.022389, 29.620211],
						[122.026473, 29.621859]
					]
				],
				[
					[
						[122.258807, 28.886586],
						[122.267025, 28.886835],
						[122.267321, 28.880364],
						[122.258807, 28.886586]
					]
				],
				[
					[
						[122.52554, 30.221557],
						[122.516682, 30.231339],
						[122.529428, 30.230439],
						[122.52554, 30.221557]
					]
				],
				[
					[
						[122.269683, 30.222621],
						[122.274653, 30.230234],
						[122.282823, 30.227942],
						[122.269683, 30.222621]
					]
				],
				[
					[
						[121.943697, 30.77709],
						[121.969731, 30.789178],
						[121.987989, 30.753318],
						[121.990794, 30.739353],
						[121.988235, 30.711172],
						[121.992812, 30.695368],
						[122.010971, 30.669497],
						[122.024357, 30.662489],
						[122.034495, 30.661633],
						[122.063284, 30.650222],
						[122.072536, 30.649448],
						[122.081592, 30.639666],
						[122.07918, 30.634775],
						[122.102113, 30.622994],
						[122.11358, 30.621078],
						[122.113629, 30.613781],
						[122.12672, 30.609826],
						[122.134298, 30.612394],
						[122.136907, 30.600244],
						[122.133265, 30.595514],
						[122.123078, 30.598368],
						[122.090745, 30.600325],
						[122.071011, 30.611294],
						[122.052851, 30.625399],
						[122.024406, 30.643701],
						[122.015007, 30.645291],
						[121.997044, 30.658821],
						[121.968205, 30.688361],
						[121.961119, 30.705877],
						[121.958609, 30.740493],
						[121.955607, 30.75686],
						[121.943697, 30.77709]
					]
				],
				[
					[
						[122.636072, 30.204281],
						[122.640895, 30.210913],
						[122.650344, 30.210995],
						[122.654527, 30.189704],
						[122.646308, 30.18692],
						[122.643848, 30.197853],
						[122.636072, 30.204281]
					]
				],
				[
					[
						[121.889563, 28.471513],
						[121.876128, 28.472554],
						[121.874111, 28.47701],
						[121.883116, 28.484089],
						[121.883658, 28.495456],
						[121.871305, 28.49429],
						[121.87037, 28.500035],
						[121.880065, 28.501909],
						[121.8873, 28.511359],
						[121.896994, 28.514231],
						[121.899455, 28.500701],
						[121.918943, 28.497371],
						[121.908313, 28.479092],
						[121.889563, 28.471513]
					]
				],
				[
					[
						[121.113133, 27.918344],
						[121.123812, 27.921274],
						[121.123911, 27.911353],
						[121.113379, 27.904403],
						[121.108163, 27.910934],
						[121.113133, 27.918344]
					]
				],
				[
					[
						[122.18233, 29.650764],
						[122.174358, 29.659945],
						[122.158117, 29.655293],
						[122.141484, 29.660521],
						[122.132822, 29.668548],
						[122.133117, 29.683036],
						[122.125686, 29.693119],
						[122.111168, 29.70032],
						[122.109052, 29.713899],
						[122.095962, 29.716491],
						[122.079968, 29.70139],
						[122.073816, 29.701802],
						[122.047881, 29.717972],
						[122.065155, 29.749893],
						[122.071405, 29.7728],
						[122.083659, 29.783203],
						[122.10856, 29.783655],
						[122.120863, 29.790973],
						[122.131395, 29.78863],
						[122.137842, 29.774527],
						[122.141385, 29.75779],
						[122.146651, 29.749647],
						[122.182133, 29.728833],
						[122.200785, 29.711183],
						[122.211366, 29.692255],
						[122.192517, 29.655334],
						[122.18233, 29.650764]
					]
				],
				[
					[
						[121.678588, 28.278319],
						[121.677604, 28.285954],
						[121.686413, 28.2895],
						[121.688775, 28.273939],
						[121.678588, 28.278319]
					]
				],
				[
					[
						[122.232626, 29.682666],
						[122.24296, 29.675298],
						[122.234594, 29.672005],
						[122.232626, 29.682666]
					]
				],
				[
					[
						[122.358807, 30.600081],
						[122.374358, 30.587399],
						[122.356543, 30.593353],
						[122.358807, 30.600081]
					]
				],
				[
					[
						[122.077901, 30.596411],
						[122.100096, 30.592415],
						[122.082231, 30.587236],
						[122.085233, 30.578834],
						[122.071749, 30.572553],
						[122.055607, 30.585482],
						[122.055164, 30.591681],
						[122.077901, 30.596411]
					]
				],
				[
					[
						[122.36176, 29.839556],
						[122.376868, 29.841734],
						[122.371209, 29.835529],
						[122.378788, 29.834379],
						[122.375933, 29.825748],
						[122.369289, 29.828091],
						[122.36176, 29.839556]
					]
				],
				[
					[
						[122.229968, 29.661056],
						[122.243502, 29.661015],
						[122.245913, 29.654716],
						[122.229968, 29.661056]
					]
				],
				[
					[
						[121.983461, 29.227808],
						[121.993451, 29.227808],
						[122.001818, 29.221441],
						[121.991089, 29.221441],
						[121.983461, 29.227808]
					]
				],
				[
					[
						[121.410674, 28.079425],
						[121.404227, 28.077627],
						[121.40718, 28.089873],
						[121.400831, 28.092506],
						[121.410526, 28.101617],
						[121.410674, 28.079425]
					]
				],
				[
					[
						[122.461367, 29.943877],
						[122.456987, 29.92569],
						[122.449162, 29.939238],
						[122.459546, 29.948638],
						[122.461367, 29.943877]
					]
				],
				[
					[
						[122.570717, 30.644313],
						[122.547046, 30.650752],
						[122.54803, 30.663467],
						[122.555757, 30.667419],
						[122.558709, 30.679072],
						[122.575639, 30.66583],
						[122.587893, 30.665341],
						[122.582922, 30.655113],
						[122.568798, 30.65442],
						[122.570717, 30.644313]
					]
				],
				[
					[
						[122.179377, 30.226428],
						[122.186956, 30.230644],
						[122.200244, 30.226755],
						[122.204574, 30.214106],
						[122.190942, 30.212264],
						[122.186415, 30.21779],
						[122.179082, 30.214884],
						[122.179377, 30.226428]
					]
				],
				[
					[
						[122.424949, 30.6212],
						[122.432725, 30.61745],
						[122.423965, 30.612272],
						[122.424949, 30.6212]
					]
				],
				[
					[
						[121.131047, 27.762472],
						[121.139118, 27.765155],
						[121.144383, 27.758531],
						[121.133114, 27.753123],
						[121.131047, 27.762472]
					]
				],
				[
					[
						[121.980705, 29.472671],
						[121.987792, 29.474898],
						[121.990843, 29.467845],
						[121.980705, 29.472671]
					]
				],
				[
					[
						[121.131047, 27.770143],
						[121.138281, 27.776682],
						[121.149846, 27.772029],
						[121.136952, 27.766999],
						[121.131047, 27.770143]
					]
				],
				[
					[
						[121.869534, 28.423946],
						[121.871256, 28.433111],
						[121.889711, 28.451189],
						[121.920617, 28.45273],
						[121.910823, 28.440068],
						[121.893451, 28.430278],
						[121.88602, 28.433986],
						[121.869534, 28.423946]
					]
				],
				[
					[
						[121.687397, 29.09667],
						[121.681885, 29.109336],
						[121.691777, 29.11124],
						[121.697092, 29.094062],
						[121.687397, 29.09667]
					]
				],
				[
					[
						[122.209003, 30.222375],
						[122.216681, 30.22082],
						[122.225441, 30.229293],
						[122.23735, 30.232322],
						[122.245322, 30.218405],
						[122.228295, 30.220451],
						[122.215746, 30.218036],
						[122.209003, 30.222375]
					]
				],
				[
					[
						[121.976178, 29.501124],
						[121.989908, 29.510071],
						[122.004967, 29.503763],
						[122.004574, 29.500299],
						[121.984741, 29.503886],
						[121.983806, 29.497042],
						[121.976178, 29.501124]
					]
				],
				[
					[
						[121.695271, 29.088474],
						[121.710084, 29.082719],
						[121.694385, 29.084707],
						[121.695271, 29.088474]
					]
				],
				[
					[
						[122.15546, 29.619429],
						[122.160824, 29.619346],
						[122.152704, 29.60695],
						[122.14419, 29.608474],
						[122.15546, 29.619429]
					]
				],
				[
					[
						[122.391484, 29.970309],
						[122.376819, 29.973305],
						[122.367813, 29.980486],
						[122.372291, 29.988364],
						[122.373128, 30.001658],
						[122.380018, 30.024506],
						[122.397784, 30.026721],
						[122.40861, 30.031725],
						[122.41053, 30.024301],
						[122.403345, 30.0154],
						[122.41801, 30.006293],
						[122.414418, 29.998458],
						[122.39675, 29.999114],
						[122.393502, 29.985123],
						[122.398571, 29.975151],
						[122.391484, 29.970309]
					]
				],
				[
					[
						[122.065204, 30.179631],
						[122.059003, 30.17832],
						[122.033068, 30.161201],
						[122.024013, 30.162593],
						[122.017664, 30.186469],
						[122.030115, 30.198057],
						[122.040056, 30.196051],
						[122.04291, 30.201497],
						[122.055755, 30.200309],
						[122.065696, 30.192202],
						[122.065204, 30.179631]
					]
				],
				[
					[
						[121.888087, 30.092078],
						[121.880114, 30.085274],
						[121.893402, 30.082691],
						[121.89537, 30.073303],
						[121.906935, 30.055797],
						[121.915597, 30.057273],
						[121.92475, 30.052598],
						[121.924849, 30.037877],
						[121.934199, 30.011749],
						[121.932821, 29.994806],
						[121.915646, 29.984097],
						[121.890941, 29.974495],
						[121.874258, 29.96481],
						[121.850882, 29.969652],
						[121.85039, 29.977285],
						[121.837004, 29.987174],
						[121.835232, 29.993001],
						[121.844041, 30.007893],
						[121.843156, 30.02869],
						[121.839809, 30.047268],
						[121.854081, 30.068179],
						[121.848667, 30.101218],
						[121.85979, 30.10171],
						[121.885774, 30.094742],
						[121.888087, 30.092078]
					]
				],
				[
					[
						[121.107277, 27.444005],
						[121.09399, 27.453001],
						[121.086066, 27.452413],
						[121.066381, 27.461325],
						[121.063379, 27.458298],
						[121.071942, 27.444972],
						[121.066283, 27.444972],
						[121.047976, 27.458046],
						[121.050043, 27.464688],
						[121.058852, 27.463847],
						[121.055013, 27.473893],
						[121.070515, 27.471161],
						[121.066234, 27.478222],
						[121.084147, 27.472379],
						[121.089364, 27.462628],
						[121.105407, 27.454893],
						[121.107277, 27.444005]
					]
				],
				[
					[
						[122.325638, 30.226919],
						[122.335628, 30.227778],
						[122.332183, 30.220247],
						[122.325638, 30.226919]
					]
				],
				[
					[
						[121.952064, 29.187616],
						[121.975636, 29.192123],
						[121.971601, 29.185093],
						[121.981788, 29.175911],
						[121.983511, 29.165404],
						[121.971404, 29.163294],
						[121.951719, 29.183107],
						[121.952064, 29.187616]
					]
				],
				[
					[
						[121.830803, 30.066375],
						[121.821994, 30.082076],
						[121.833264, 30.082855],
						[121.844927, 30.077239],
						[121.852506, 30.065596],
						[121.847437, 30.06166],
						[121.830803, 30.066375]
					]
				],
				[
					[
						[120.903388, 27.69387],
						[120.912099, 27.699238],
						[120.911951, 27.689171],
						[120.903388, 27.69387]
					]
				],
				[
					[
						[122.038235, 29.759229],
						[122.043944, 29.753801],
						[122.043599, 29.742654],
						[122.031837, 29.736814],
						[122.029721, 29.716944],
						[122.016335, 29.714475],
						[122.011365, 29.74611],
						[122.024357, 29.756844],
						[122.038235, 29.759229]
					]
				],
				[
					[
						[122.32239, 29.83257],
						[122.323965, 29.839515],
						[122.332872, 29.826652],
						[122.32239, 29.83257]
					]
				],
				[
					[
						[121.217415, 27.613681],
						[121.228685, 27.616409],
						[121.224945, 27.607048],
						[121.217415, 27.613681]
					]
				],
				[
					[
						[122.716486, 30.17574],
						[122.72185, 30.181965],
						[122.728051, 30.17271],
						[122.718553, 30.168368],
						[122.716486, 30.17574]
					]
				],
				[
					[
						[122.1436, 30.610927],
						[122.13607, 30.61533],
						[122.149997, 30.619081],
						[122.1436, 30.610927]
					]
				],
				[
					[
						[122.514516, 30.649],
						[122.522784, 30.643579],
						[122.514221, 30.641786],
						[122.514516, 30.649]
					]
				],
				[
					[
						[121.957428, 30.287684],
						[121.931542, 30.304414],
						[121.921502, 30.307563],
						[121.940252, 30.331731],
						[121.976079, 30.337619],
						[121.981001, 30.343384],
						[121.989121, 30.340031],
						[121.986168, 30.331036],
						[121.992763, 30.328092],
						[122.000883, 30.308504],
						[121.989022, 30.289525],
						[121.979869, 30.288502],
						[121.968304, 30.294556],
						[121.957428, 30.287684]
					]
				],
				[
					[
						[121.940351, 30.114537],
						[121.950341, 30.113594],
						[121.963481, 30.10339],
						[121.957674, 30.084659],
						[121.945961, 30.064448],
						[121.928638, 30.06658],
						[121.929623, 30.078469],
						[121.916483, 30.083265],
						[121.911266, 30.095685],
						[121.923323, 30.106628],
						[121.940351, 30.114537]
					]
				],
				[
					[
						[122.526278, 30.666767],
						[122.533365, 30.672268],
						[122.544881, 30.663344],
						[122.540894, 30.657884],
						[122.526278, 30.666767]
					]
				],
				[
					[
						[121.083655, 27.791896],
						[121.091037, 27.793237],
						[121.096893, 27.783053],
						[121.090545, 27.776221],
						[121.073566, 27.778023],
						[121.083655, 27.791896]
					]
				],
				[
					[
						[121.67908, 28.371063],
						[121.688431, 28.373064],
						[121.687348, 28.366269],
						[121.67908, 28.371063]
					]
				],
				[
					[
						[121.672633, 29.062224],
						[121.680507, 29.054688],
						[121.665842, 29.059615],
						[121.672633, 29.062224]
					]
				],
				[
					[
						[122.680856, 30.190523],
						[122.673178, 30.208334],
						[122.687007, 30.205345],
						[122.694094, 30.187698],
						[122.689222, 30.180982],
						[122.688434, 30.191301],
						[122.680856, 30.190523]
					]
				],
				[
					[
						[122.226572, 29.808856],
						[122.239023, 29.801867],
						[122.224702, 29.801867],
						[122.226572, 29.808856]
					]
				],
				[
					[
						[121.930459, 29.036051],
						[121.931, 29.041394],
						[121.948766, 29.047233],
						[121.954524, 29.043961],
						[121.940991, 29.03369],
						[121.930459, 29.036051]
					]
				],
				[
					[
						[121.851227, 28.423487],
						[121.855607, 28.431819],
						[121.860872, 28.426737],
						[121.851227, 28.423487]
					]
				],
				[
					[
						[122.41678, 30.682047],
						[122.435431, 30.674672],
						[122.425737, 30.668886],
						[122.408807, 30.672472],
						[122.41678, 30.682047]
					]
				],
				[
					[
						[122.006641, 29.234877],
						[122.013826, 29.23281],
						[122.008609, 29.222971],
						[122.00103, 29.227394],
						[122.006641, 29.234877]
					]
				],
				[
					[
						[122.178492, 29.978393],
						[122.193255, 29.965179],
						[122.195962, 29.958694],
						[122.182921, 29.955288],
						[122.170765, 29.966164],
						[122.154426, 29.971253],
						[122.14355, 29.968462],
						[122.141877, 29.974823],
						[122.16924, 29.988241],
						[122.178492, 29.978393]
					]
				],
				[
					[
						[121.618106, 30.604811],
						[121.617712, 30.60848],
						[121.637397, 30.608847],
						[121.618106, 30.604811]
					]
				],
				[
					[
						[122.001621, 29.410416],
						[122.018944, 29.409674],
						[122.016286, 29.404185],
						[122.003835, 29.405051],
						[122.001621, 29.410416]
					]
				],
				[
					[
						[122.225047, 29.738294],
						[122.234299, 29.739775],
						[122.241287, 29.731918],
						[122.233561, 29.731013],
						[122.225047, 29.738294]
					]
				],
				[
					[
						[122.127802, 30.218364],
						[122.146946, 30.222007],
						[122.151917, 30.21603],
						[122.140647, 30.214393],
						[122.129476, 30.207433],
						[122.127802, 30.218364]
					]
				],
				[
					[
						[121.863825, 30.116955],
						[121.870567, 30.106628],
						[121.861168, 30.104292],
						[121.863825, 30.116955]
					]
				],
				[
					[
						[121.145761, 27.760669],
						[121.155013, 27.756645],
						[121.146696, 27.754171],
						[121.145761, 27.760669]
					]
				],
				[
					[
						[122.197734, 29.726776],
						[122.206789, 29.728833],
						[122.219683, 29.724102],
						[122.217124, 29.717355],
						[122.197734, 29.726776]
					]
				],
				[
					[
						[122.759941, 30.137073],
						[122.763435, 30.142112],
						[122.773326, 30.140432],
						[122.784793, 30.12601],
						[122.767126, 30.12347],
						[122.759941, 30.137073]
					]
				],
				[
					[
						[120.826223, 27.686193],
						[120.833113, 27.687368],
						[120.842758, 27.675537],
						[120.832473, 27.67688],
						[120.826223, 27.686193]
					]
				],
				[
					[
						[122.287941, 29.723938],
						[122.269978, 29.730725],
						[122.251573, 29.731178],
						[122.238236, 29.741996],
						[122.213285, 29.771525],
						[122.21422, 29.780366],
						[122.233856, 29.784477],
						[122.246159, 29.783367],
						[122.261021, 29.773622],
						[122.255706, 29.76108],
						[122.258364, 29.753307],
						[122.280017, 29.746233],
						[122.296602, 29.749606],
						[122.309545, 29.743518],
						[122.313187, 29.731466],
						[122.296848, 29.729985],
						[122.287941, 29.723938]
					]
				],
				[
					[
						[121.224108, 27.817876],
						[121.213281, 27.820096],
						[121.225043, 27.824496],
						[121.224108, 27.817876]
					]
				],
				[
					[
						[122.153836, 30.578957],
						[122.156739, 30.584503],
						[122.167862, 30.583687],
						[122.153836, 30.578957]
					]
				],
				[
					[
						[121.634592, 28.225448],
						[121.644927, 28.232836],
						[121.644828, 28.222985],
						[121.634592, 28.225448]
					]
				],
				[
					[
						[122.259053, 30.519882],
						[122.267567, 30.526901],
						[122.277901, 30.524493],
						[122.275244, 30.513148],
						[122.25738, 30.511842],
						[122.259053, 30.519882]
					]
				],
				[
					[
						[122.192468, 29.796194],
						[122.202015, 29.790891],
						[122.198324, 29.785217],
						[122.182429, 29.788013],
						[122.175686, 29.797181],
						[122.192468, 29.796194]
					]
				],
				[
					[
						[120.824943, 27.646208],
						[120.8339, 27.649985],
						[120.821991, 27.634835],
						[120.824943, 27.646208]
					]
				],
				[
					[
						[121.981444, 29.332638],
						[121.970223, 29.340856],
						[121.985135, 29.348454],
						[121.978688, 29.340485],
						[121.981444, 29.332638]
					]
				],
				[
					[
						[122.146257, 29.96247],
						[122.163088, 29.965713],
						[122.170273, 29.957833],
						[122.166336, 29.94634],
						[122.140696, 29.943712],
						[122.132232, 29.956519],
						[122.146257, 29.96247]
					]
				],
				[
					[
						[122.452115, 29.973469],
						[122.450244, 29.964728],
						[122.444683, 29.968216],
						[122.452115, 29.973469]
					]
				],
				[
					[
						[122.467469, 30.408857],
						[122.477853, 30.410491],
						[122.476376, 30.403587],
						[122.467469, 30.408857]
					]
				],
				[
					[
						[121.502062, 28.072235],
						[121.504867, 28.085736],
						[121.528834, 28.101742],
						[121.532279, 28.093426],
						[121.527111, 28.086363],
						[121.516137, 28.087199],
						[121.511068, 28.077084],
						[121.502062, 28.072235]
					]
				],
				[
					[
						[121.346353, 28.087784],
						[121.345565, 28.096059],
						[121.359443, 28.098065],
						[121.373961, 28.10989],
						[121.372091, 28.099903],
						[121.356786, 28.089121],
						[121.346353, 28.087784]
					]
				],
				[
					[
						[122.264122, 30.269888],
						[122.30177, 30.270052],
						[122.304821, 30.262523],
						[122.312941, 30.265142],
						[122.315844, 30.250165],
						[122.291878, 30.248324],
						[122.276277, 30.244232],
						[122.261612, 30.234736],
						[122.25423, 30.237356],
						[122.254574, 30.253235],
						[122.264122, 30.269888]
					]
				],
				[
					[
						[122.283019, 29.860388],
						[122.284545, 29.875588],
						[122.301474, 29.883844],
						[122.319191, 29.878792],
						[122.340057, 29.883598],
						[122.348423, 29.878833],
						[122.342961, 29.870782],
						[122.343305, 29.86047],
						[122.329968, 29.85895],
						[122.323915, 29.852541],
						[122.309004, 29.849582],
						[122.293403, 29.852089],
						[122.283019, 29.860388]
					]
				],
				[
					[
						[122.331199, 30.595677],
						[122.343207, 30.599632],
						[122.341337, 30.593597],
						[122.326031, 30.590131],
						[122.331199, 30.595677]
					]
				],
				[
					[
						[121.204325, 27.609735],
						[121.208951, 27.618172],
						[121.216923, 27.618928],
						[121.210033, 27.608476],
						[121.204325, 27.609735]
					]
				],
				[
					[
						[122.78125, 30.694187],
						[122.775196, 30.704167],
						[122.758218, 30.70213],
						[122.75748, 30.713901],
						[122.782086, 30.730028],
						[122.792815, 30.729499],
						[122.799508, 30.716467],
						[122.7906, 30.717444],
						[122.787647, 30.711498],
						[122.791732, 30.698423],
						[122.78125, 30.694187]
					]
				],
				[
					[
						[122.648375, 30.812494],
						[122.640255, 30.816318],
						[122.643355, 30.826733],
						[122.660629, 30.819858],
						[122.648375, 30.812494]
					]
				],
				[
					[
						[121.977999, 30.100275],
						[121.982822, 30.095234],
						[121.973865, 30.084905],
						[121.966483, 30.097447],
						[121.977999, 30.100275]
					]
				],
				[
					[
						[121.981001, 30.06699],
						[121.975538, 30.075148],
						[121.981739, 30.083224],
						[121.988579, 30.083634],
						[121.99045, 30.07109],
						[121.981001, 30.06699]
					]
				],
				[
					[
						[121.81727, 28.610428],
						[121.823274, 28.607267],
						[121.803933, 28.599115],
						[121.81727, 28.610428]
					]
				],
				[
					[
						[122.069436, 29.992385],
						[122.076867, 30.000714],
						[122.093796, 29.985492],
						[122.078147, 29.97273],
						[122.072241, 29.972853],
						[122.069436, 29.992385]
					]
				],
				[
					[
						[121.098173, 27.937514],
						[121.080259, 27.947181],
						[121.063527, 27.947809],
						[121.049993, 27.94128],
						[121.03833, 27.948939],
						[121.040544, 27.964296],
						[121.076027, 27.986344],
						[121.094334, 27.984127],
						[121.120663, 27.986637],
						[121.134049, 27.980529],
						[121.152946, 27.961576],
						[121.147385, 27.953374],
						[121.125978, 27.944126],
						[121.098173, 27.937514]
					]
				],
				[
					[
						[122.145322, 29.966328],
						[122.146454, 29.963496],
						[122.129033, 29.960541],
						[122.128393, 29.96641],
						[122.145322, 29.966328]
					]
				],
				[
					[
						[120.896548, 27.711444],
						[120.899451, 27.706033],
						[120.887394, 27.704523],
						[120.896548, 27.711444]
					]
				],
				[
					[
						[122.178295, 29.406001],
						[122.184348, 29.399604],
						[122.173866, 29.399769],
						[122.178295, 29.406001]
					]
				],
				[
					[
						[122.391583, 30.740615],
						[122.386366, 30.759384],
						[122.395274, 30.760523],
						[122.391583, 30.740615]
					]
				],
				[
					[
						[121.685576, 29.115917],
						[121.690153, 29.120883],
						[121.694385, 29.113061],
						[121.685576, 29.115917]
					]
				],
				[
					[
						[121.18587, 27.962957],
						[121.171352, 27.978605],
						[121.177356, 27.990527],
						[121.194974, 28.000148],
						[121.220122, 27.991489],
						[121.24025, 27.993748],
						[121.237543, 27.988143],
						[121.206195, 27.976889],
						[121.18587, 27.962957]
					]
				],
				[
					[
						[122.284988, 30.635835],
						[122.277212, 30.638933],
						[122.284742, 30.648714],
						[122.292616, 30.650548],
						[122.295766, 30.640726],
						[122.284988, 30.635835]
					]
				],
				[
					[
						[122.16422, 29.799278],
						[122.161218, 29.8038],
						[122.174259, 29.807664],
						[122.180017, 29.802361],
						[122.174948, 29.797222],
						[122.16422, 29.799278]
					]
				],
				[
					[
						[122.452804, 29.956889],
						[122.458955, 29.95106],
						[122.450687, 29.945929],
						[122.444831, 29.955042],
						[122.452804, 29.956889]
					]
				],
				[
					[
						[121.145122, 28.013239],
						[121.149649, 28.019805],
						[121.166185, 28.021771],
						[121.145122, 28.013239]
					]
				],
				[
					[
						[122.83627, 30.698708],
						[122.826821, 30.709136],
						[122.810777, 30.712476],
						[122.804232, 30.723024],
						[122.814616, 30.732879],
						[122.831053, 30.728521],
						[122.836811, 30.719155],
						[122.839911, 30.703759],
						[122.83627, 30.698708]
					]
				],
				[
					[
						[122.009987, 29.902654],
						[122.005312, 29.913044],
						[122.011513, 29.917027],
						[122.02416, 29.909594],
						[122.02165, 29.901546],
						[122.009987, 29.902654]
					]
				],
				[
					[
						[122.132379, 29.983769],
						[122.143206, 29.987051],
						[122.143108, 29.978311],
						[122.132379, 29.983769]
					]
				],
				[
					[
						[122.096208, 29.944862],
						[122.097733, 29.938745],
						[122.083511, 29.935625],
						[122.079672, 29.939566],
						[122.081542, 29.953687],
						[122.090942, 29.956314],
						[122.096208, 29.944862]
					]
				],
				[
					[
						[122.227852, 29.715627],
						[122.235382, 29.717725],
						[122.233364, 29.70999],
						[122.227852, 29.715627]
					]
				],
				[
					[
						[122.213137, 29.958161],
						[122.19296, 29.975972],
						[122.20482, 29.973879],
						[122.239811, 29.960049],
						[122.274604, 29.93891],
						[122.273374, 29.932259],
						[122.237399, 29.944739],
						[122.213137, 29.958161]
					]
				],
				[
					[
						[121.969091, 30.064038],
						[121.974406, 30.062111],
						[121.974997, 30.049523],
						[121.964071, 30.053787],
						[121.969091, 30.064038]
					]
				],
				[
					[
						[122.108314, 29.963086],
						[122.112842, 29.978434],
						[122.128245, 29.973797],
						[122.125883, 29.96087],
						[122.110922, 29.958735],
						[122.108314, 29.963086]
					]
				],
				[
					[
						[122.028983, 29.955042],
						[122.042271, 29.964522],
						[122.05108, 29.964974],
						[122.058462, 29.952907],
						[122.047782, 29.93423],
						[122.037005, 29.929508],
						[122.031198, 29.935215],
						[122.028983, 29.955042]
					]
				],
				[
					[
						[121.04394, 27.979316],
						[121.043251, 27.993372],
						[121.074108, 28.007426],
						[121.089068, 28.004916],
						[121.08961, 27.998684],
						[121.075436, 27.990025],
						[121.04394, 27.979316]
					]
				],
				[
					[
						[122.2561, 29.864702],
						[122.249899, 29.875588],
						[122.267222, 29.875793],
						[122.278246, 29.867701],
						[122.274161, 29.862401],
						[122.2561, 29.864702]
					]
				],
				[
					[
						[122.193747, 29.766262],
						[122.200342, 29.765151],
						[122.201277, 29.755487],
						[122.189171, 29.75524],
						[122.193747, 29.766262]
					]
				],
				[
					[
						[121.940105, 28.441526],
						[121.94355, 28.450731],
						[121.945174, 28.436652],
						[121.940105, 28.441526]
					]
				],
				[
					[
						[122.288827, 29.93074],
						[122.288138, 29.936118],
						[122.301573, 29.941865],
						[122.311809, 29.942029],
						[122.315352, 29.931027],
						[122.30674, 29.922118],
						[122.291435, 29.924623],
						[122.288827, 29.93074]
					]
				],
				[
					[
						[122.006247, 29.899574],
						[122.017221, 29.900806],
						[122.014367, 29.892634],
						[122.006247, 29.899574]
					]
				],
				[
					[
						[122.212399, 29.69172],
						[122.228836, 29.690732],
						[122.229673, 29.685423],
						[122.215844, 29.684312],
						[122.212399, 29.69172]
					]
				],
				[
					[
						[122.042418, 29.981635],
						[122.046749, 29.988693],
						[122.054672, 29.988693],
						[122.051424, 29.976834],
						[122.042418, 29.981635]
					]
				],
				[
					[
						[121.112986, 27.473136],
						[121.12337, 27.466327],
						[121.112346, 27.463511],
						[121.106539, 27.473178],
						[121.112986, 27.473136]
					]
				],
				[
					[
						[121.079029, 27.428743],
						[121.076962, 27.434125],
						[121.088084, 27.431602],
						[121.090397, 27.424538],
						[121.079029, 27.428743]
					]
				],
				[
					[
						[122.300687, 29.894646],
						[122.309496, 29.896084],
						[122.314713, 29.88943],
						[122.299899, 29.890539],
						[122.300687, 29.894646]
					]
				],
				[
					[
						[121.09458, 27.494023],
						[121.09458, 27.486333],
						[121.085673, 27.4923],
						[121.09458, 27.494023]
					]
				]
			]
		}
	}, {
		"type": "Feature",
		"properties": {
			"adcode": "310000",
			"name": "上海市",
			"center": [121.472644, 31.231706],
			"centroid": [121.438734, 31.07256],
			"cp":[121.872644, 30.831706],
			"childrenNum": 16,
			"level": "province",
			"parent": {
				"adcode": 100000
			},
			"subFeatureIndex": 8,
			"acroutes": [100000]
		},
		"geometry": {
			"type": "MultiPolygon",
			"coordinates": [
				[
					[
						[120.901349, 31.017327],
						[120.890878, 31.094229],
						[120.859465, 31.100379],
						[120.881023, 31.134706],
						[120.930298, 31.141365],
						[121.018377, 31.134194],
						[121.076892, 31.158267],
						[121.060261, 31.245289],
						[121.090442, 31.291838],
						[121.138485, 31.276495],
						[121.160659, 31.283144],
						[121.129862, 31.302577],
						[121.130478, 31.343987],
						[121.113848, 31.37465],
						[121.143413, 31.392021],
						[121.174826, 31.44922],
						[121.240731, 31.493627],
						[121.247507, 31.476785],
						[121.301093, 31.49873],
						[121.301093, 31.49873],
						[121.343593, 31.511996],
						[121.404571, 31.479337],
						[121.520984, 31.394575],
						[121.599208, 31.37465],
						[121.722396, 31.3036],
						[121.809859, 31.196669],
						[121.946598, 31.066039],
						[121.977395, 31.016301],
						[121.990945, 30.96859],
						[121.994025, 30.862823],
						[121.954605, 30.825828],
						[121.970004, 30.789333],
						[121.943518, 30.776993],
						[121.904714, 30.814007],
						[121.681128, 30.818633],
						[121.601056, 30.805269],
						[121.517288, 30.775451],
						[121.426129, 30.730192],
						[121.362071, 30.679764],
						[121.274608, 30.677191],
						[121.272144, 30.723504],
						[121.232108, 30.755909],
						[121.21671, 30.785734],
						[121.174826, 30.771851],
						[121.123087, 30.77905],
						[121.13787, 30.826342],
						[121.097833, 30.857171],
						[121.060261, 30.845354],
						[121.038087, 30.814007],
						[120.991892, 30.837133],
						[121.020225, 30.872069],
						[120.993124, 30.889532],
						[121.000515, 30.938309],
						[120.989428, 31.01425],
						[120.949392, 31.030148],
						[120.940153, 31.010146],
						[120.901349, 31.017327]
					]
				],
				[
					[
						[121.974931, 31.61704],
						[121.995873, 31.493117],
						[121.981706, 31.464024],
						[121.890547, 31.428795],
						[121.819098, 31.437987],
						[121.682976, 31.491075],
						[121.625693, 31.501792],
						[121.547469, 31.531382],
						[121.434136, 31.590535],
						[121.395332, 31.585437],
						[121.371926, 31.553314],
						[121.289391, 31.61653],
						[121.145261, 31.75403],
						[121.118775, 31.759119],
						[121.200079, 31.834907],
						[121.265369, 31.863883],
						[121.323267, 31.868458],
						[121.384861, 31.833382],
						[121.431673, 31.769295],
						[121.49881, 31.753012],
						[121.599824, 31.703128],
						[121.64294, 31.697527],
						[121.715005, 31.673592],
						[121.974931, 31.61704]
					]
				],
				[
					[
						[121.779062, 31.310247],
						[121.727939, 31.35472],
						[121.572107, 31.435944],
						[121.509897, 31.4824],
						[121.520984, 31.494137],
						[121.567179, 31.48342],
						[121.585657, 31.454836],
						[121.742106, 31.407345],
						[121.792613, 31.363408],
						[121.793845, 31.31945],
						[121.779062, 31.310247]
					]
				],
				[
					[
						[121.801852, 31.356765],
						[121.792613, 31.377715],
						[121.845584, 31.37465],
						[121.951525, 31.337343],
						[122.040837, 31.324051],
						[122.116597, 31.320984],
						[122.122756, 31.307179],
						[122.097503, 31.255522],
						[122.016199, 31.282121],
						[121.932431, 31.283144],
						[121.840656, 31.295418],
						[121.8037, 31.328652],
						[121.801852, 31.356765]
					]
				],
				[
					[
						[121.626925, 31.445135],
						[121.579498, 31.479848],
						[121.631853, 31.456878],
						[121.626925, 31.445135]
					]
				],
				[
					[
						[121.943518, 31.215608],
						[121.950909, 31.228915],
						[122.008808, 31.221238],
						[121.995873, 31.160828],
						[121.959533, 31.159291],
						[121.943518, 31.215608]
					]
				],
				[
					[
						[121.88254, 31.240684],
						[121.923808, 31.234032],
						[121.909026, 31.195133],
						[121.88254, 31.240684]
					]
				]
			]
		}
	}]
}
